(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("solid-logic"), require("solid-ui"), require("rdflib"));
	else if(typeof define === 'function' && define.amd)
		define(["solid-logic", "solid-ui", "rdflib"], factory);
	else if(typeof exports === 'object')
		exports["ContactsPane"] = factory(require("solid-logic"), require("solid-ui"), require("rdflib"));
	else
		root["ContactsPane"] = factory(root["SolidLogic"], root["UI"], root["$rdf"]);
})(globalThis, (__WEBPACK_EXTERNAL_MODULE__941__, __WEBPACK_EXTERNAL_MODULE__104__, __WEBPACK_EXTERNAL_MODULE__53__) => {
return /******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ 903
(module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(354);
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(314);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(417);
/* harmony import */ var _node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2__);
// Imports



var ___CSS_LOADER_URL_IMPORT_0___ = new URL(/* asset import */ __webpack_require__(102), __webpack_require__.b);
var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
var ___CSS_LOADER_URL_REPLACEMENT_0___ = _node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Focus indicator for keyboard navigation */
.contactPane table tr[tabindex="0"]:focus {
  outline: var(--focus-ring-width) solid var(--color-primary);
  outline-offset: 2px;
  background: var(--color-info-bg);
}
/* contactsPane styles — extracted from inline styles in contactsPane.js */
/* Uses CSS custom properties from the global stylesheet (dev-global.css / mashlib) */

/* ── Layout: Three-column browser ────────────────────────────── */

.contactPane .peopleSection .selected {
  background-color: var(--color-info-bg) !important;
}

.contactPane .detailSection,
.contactPane .addressBookSection {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  flex: 1 1 0; /* allow it to grow but not force wrap */
  min-width: 0; /* allow sections to collapse when stacked */
  box-sizing: border-box;
  background: var(--color-section-bg);
}

.contactPane .detailsSectionContent {
  flex: 1 1 auto;
  min-height: 12.5rem; /* 200px */
  padding: var(--spacing-lg);
  max-width: 56.25rem; /* 900px */
  width: 100%;
  box-sizing: border-box;
}

.contactPane .detailsSectionContent--wide {
  max-width: 56.25rem; /* 900px */
}

.contactPane .cardFooter {
  display: flex;
  flex-wrap: nowrap; /* keep buttons inline */
  align-items: center; /* vertical centering if varied heights */
  gap: var(--spacing-xs);
  padding-top: var(--spacing-md);
  margin-top: var(--spacing-md);
}

.contactPane .detailsSectionContent {
  margin: 0;
}

/* ── Contact type chooser ───────────────────────────────────── */

.contactPane .contactTypeChooser {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-sm);
  max-width: 22.5rem; /* 360px */
}

.contactPane .contactTypeChooser h3 {
  margin: 0 0 var(--spacing-xs) 0;
  font-size: var(--font-size-lg);
}

.contactPane .contactTypeSelect {
  height: var(--min-touch-target);
  border: var(--border-width-sm, 1px) solid var(--color-border-pale);
  border-radius: var(--border-radius-base);
  padding: 0 var(--spacing-sm);
  font-size: var(--font-size-sm);
  background: var(--color-section-bg);
}

/* ── Search ──────────────────────────────────────────────────── */

.contactPane .allGroupsButton {
  border-radius: var(--border-radius-full) !important;
  /* existing styles */
}
/* wrapper to position clear icon/button */
.contactPane .searchDiv {
  position: relative;
}

.contactPane .searchInput {
  height: var(--min-touch-target);
  border: var(--border-width-sm, 1px) solid var(--color-border-pale);
  background-color: var(--color-section-bg);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: 0.5rem center; /* 8px */
  background-size: 1.25rem 1.25rem; /* 20px 20px */
  border-radius: var(--border-radius-base);
  padding: 0 var(--spacing-sm) 0 2.125rem; /* 34px */
  font-size: var(--font-size-base);
  width: 100%;
  box-sizing: border-box;
}

/* clear button inside search input */
.contactPane .searchClearButton {
  position: absolute;
  right: var(--spacing-sm);
  top: 50%;
  transform: translateY(-50%);
  border: none;
  background: transparent;
  font-size: var(--font-size-base);
  line-height: 1;
  padding: 0;
  cursor: pointer;
  color: var(--color-text-muted);
  /* visibility is controlled via the generic \`.hidden\` utility class */
  display: block;
}
.contactPane .searchClearButton.hidden {
  display: none;
}
.contactPane .searchClearButton:hover {
  color: var(--color-text);
}

/* ── Contact toolbar (top-right link + delete) ──────────────── */

.contactPane .contact-toolbar {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
  padding: var(--spacing-xs) 0;
}

.contactPane .contact-toolbar a {
  margin: 0.3rem;
}

.contactPane .contact-toolbar a img {
  width: 1.3rem;
  height: 1rem;
  margin: 0;
}

.contact-toolbar .deleteButton {
  margin-left: auto; /* keeps delete icon on the right */
  margin-right: var(--spacing-xxxs, 0.2rem);
  width: var(--icon-xxs, 1rem);
  height: var(--icon-xxs, 1rem);
  float: none; /* important: prevents overlap behavior */
}

/* ── "All" groups button ─────────────────────────────────────── */

.contactPane .allGroupsButton {
  margin-left: var(--spacing-md);
  font-size: var(--font-size-base);
}

.contactPane .allGroupsButton--loading {
  background-color: var(--color-primary);
}

.contactPane .allGroupsButton--active {
  background-color: var(--color-primary);
  color: var(--color-background);
}

.contactPane .allGroupsButton--loaded {
  background-color: var(--color-primary);
}

/* ── Mint new address book ───────────────────────────────────── */

.contactPane .claimSuccess {
  font-size: var(--font-size-xl);
}

.contactPane {
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.contactPane .addressBook-grid {
  display: flex;
  flex-wrap: nowrap; /* keep sections side-by-side */
  flex: 1;
  min-width: 0; /* allow it to shrink */
  align-items: stretch;
  width: 100%;
  box-sizing: border-box;
  overflow-x: hidden;
}

@media ((min-width: 500px) and (max-width: 900px)) {
  .contactPane .addressBookSection {
    max-width: 900px;
  }
  .contactPane .addressBookSection section {
    max-width: 485px;
  }
}

.contactPane.contactPane--narrow .addressBook-grid {
  flex-direction: column !important;
  flex-wrap: nowrap !important;
  min-width: 0 !important;
  overflow-x: hidden !important;
}

.contactPane.contactPane--narrow .addressBookSection,
.contactPane.contactPane--narrow .detailSection {
  flex: 1 1 100% !important;
  max-width: 100% !important;
  min-width: 0 !important;
  width: 100% !important;
}

@media (max-width: 1000px) {
  /* Stack sidebar + details vertically on narrow screens */
  .contactPane {
    min-height: auto !important;
  }

  .contactPane .addressBook-grid {
    flex-direction: column !important;
    flex-wrap: nowrap !important;
    min-height: auto !important;
    height: auto !important;
  }

  .contactPane .addressBookSection,
  .contactPane .detailSection {
    order: initial !important;
    flex: none !important;
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
  }


  .contactPane .addressBookSection {
    max-height: none !important;
    min-height: auto !important;
    overflow-y: visible !important;
    padding-bottom: var(--spacing-lg) !important;
    display: flex !important;
    flex-direction: column !important;
    height: auto !important;
  }

  .contactPane .peopleSection ul {
    max-height: 50vh;
    overflow-y: auto;
  }

  .contactPane .detailSection {
    max-height: none !important;
    min-height: auto !important;
    overflow-y: visible !important;
  }

  .contactPane .detailsSectionContent {
    display: flex !important;
    flex-direction: column !important;
    justify-content: flex-start !important;
    align-items: stretch !important;
    min-height: auto !important;
    height: auto !important;
    overflow-y: visible !important;
  }

  .contactPane .detailSection > .detailsSectionContent {
    padding-top: var(--spacing-sm) !important;
    box-sizing: border-box !important;
  }

  /* Keep a normal mobile text scale while preserving comfortable touch targets */
  /* The following rule made all text much larger on mobile; comment out to restore normal font size for non-buttons.
   .contactPane,
   .contactPane * {
    font-size: 1.5rem !important;
  } */

  .contactPane .actionButton,
  .contactPane .searchInput,
  .contactPane .flatButton,
  .contactPane .buttonSection button,
  .contactPane .groupButtonsList button {
    min-height: calc(var(--min-touch-target) + 0.5em) !important;
    font-size: 1.5rem !important;
    padding: 0.875em 1em !important;
  }

  .contactPane .group-membership-item .group-membership-toolbar > img.hoverControlHide, .contactPane .group-membership-item .group-membership-toolbar > [data-testid="deleteButtonWithCheck"],
  .individualPane .hoverControl img.hoverControlHide, 
  .individualPane .hoverControl [data-testid="deleteButtonWithCheck"] {
    display: inline-flex !important;
    visibility: visible !important;
    opacity: 1 !important;
  }
}


/* Card Section Background */
.contactPane .addressBookSection.section-bg {
  background: var(--color-section-bg);
  padding: var(--spacing-md);
  box-sizing: border-box;
  border: none !important;
  border-radius: 0 !important;
}

/* Keep detail section content anchored at top */
.contactPane .detailSection {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
}

.contactPane .detailsSectionContent {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
}

/* ── Button section: horizontal scrollable row ──────────────── */


.contactPane .buttonSection {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  padding: var(--spacing-sm);
  padding-bottom: 0;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: thin;
  margin-bottom: 0;
}

@media (max-width: 1000px) {
  .contactPane .buttonSection {
    position: sticky;
    top: 0;
    z-index: 2;
    background: var(--color-section-bg);
    box-shadow: 0 2px 4px -2px rgba(0,0,0,0.04);
  }
}

.contactPane .buttonSection::-webkit-scrollbar {
  height: 6px;
}

.contactPane .buttonSection::-webkit-scrollbar-thumb {
  background: var(--color-border-pale);
  border-radius: var(--border-radius-base);
}

.contactPane .buttonSection::-webkit-scrollbar-track {
  background: transparent;
}

.contactPane .buttonSection .selected {
  background: none !important;
}

.contactPane .groupButtonsList {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: var(--spacing-xs);
  list-style: none;
}

.contactPane .buttonSection .groupButtonsList {
  margin-left: var(--spacing-xs);
  margin-right: var(--spacing-xs);
  padding-left: 0;
}

.contactPane .groupButtonsList li {
  flex-shrink: 0;
}

.contactPane .groupButtonsList button {
  white-space: nowrap;
  flex-shrink: 0;
  min-width: max-content;
  margin-left: 0;
}

/* Groups list in details section — flexible 2-column grid */
.contactPane .detailsSectionContent .groupButtonsList {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: var(--spacing-sm);
  list-style: none;
  padding: 0;
  width: 100%;
  box-sizing: border-box;
}

.contactPane .detailsSectionContent .groupButtonsList li {
  width: 100%;
  aspect-ratio: auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: var(--spacing-xs);
}

.contactPane .detailsSectionContent .groupButtonsList button {
  width: 100%;
  height: auto;
  text-align: center;
  border-radius: var(--border-radius-base);
  word-wrap: break-word;
  overflow-wrap: break-word;
}

.contactPane .detailsSectionContent .groupButtonsList li > img.hoverControlHide,
.contactPane .detailsSectionContent .groupButtonsList li > img[data-testid="deleteButtonWithCheck"] {
  display: block;
  align-self: flex-end;
  float: none !important;
  margin: 0 !important;
}

@media (max-width: 599px) {
  .contactPane .detailsSectionContent .groupButtonsList {
    grid-template-columns: repeat(2, 1fr);
    gap: var(--spacing-xs);
  }

  .contactPane .detailsSectionContent .groupButtonsList button {
    font-size: var(--font-size-sm);
    border-radius: var(--border-radius-base);
  }
}

@media (min-width: 900px) {
  .contactPane .detailsSectionContent .groupButtonsList {
    grid-template-columns: repeat(3, 1fr);
  }
}

.contactPane .detailsSectionContent .newGroupBtn {
  width: 100%;
  box-sizing: border-box;
  margin-top: var(--spacing-sm);
}

.contactPane .detailsSectionContent h3 {
  font-size: var(--font-size-xl);
  margin-bottom: var(--spacing-sm);
  padding-left: 0;
}

/* Delete confirmation POPUP — centered overlay in details section */
.contactPane .detailSection {
  position: relative;
}

.contactPane .webidControl div[style*="position: relative"]:has(> div[style*="display: grid"]) {
  position: static !important;
}


.contactPane .webidControl .personaRow--webid td > div[style*="position: relative"] > div,
.contactPane .detailsSectionContent .groupButtonsList li > div[style*="position: relative"] > div,
.contactPane .detailsSectionContent .contact-toolbar  > div[style*="position: relative"] > div {
  position: absolute !important;
  left: auto !important;
  z-index: 9999 !important;
  display: grid !important;
  pointer-events: auto !important;
  opacity: 1 !important;
  visibility: visible !important;
  padding: var(--spacing-btn) !important;
  min-width: 12em !important;
  background: var(--color-background) !important;
  border: var(--border-width-sm) solid var(--color-primary) !important;
  border-radius: var(--border-radius-base) !important;
  box-shadow: var(--box-shadow-popup) !important;
  grid-template-columns: auto auto !important;
  gap: var(--spacing-xxs) !important;
}

.contactPane .detailsSectionContent .contact-toolbar > div[style*="position: relative"] > div > button:has(> img[src\$=".svg"]),
.contactPane .detailsSectionContent .group-membership-item .group-membership-toolbar > div[style*="position: relative"] > div > button:has(> img[src\$=".svg"]),
.contactPane .webidControl .personaRow--webid td > div[style*="position: relative"] > div > button:has(> img[src\$=".svg"]) {
  background-color: transparent !important;
}

/* Selected state for All contacts button */
.contactPane .allGroupsButton--selected {
  background-color: var(--color-primary);
  color: var(--color-background);
}

/* ── Header section ──────────────────────────────────────────── */

.contactPane .headerSection {
  background: var(--color-background);
  padding: var(--spacing-sm);
  border-top-left-radius: var(--border-radius-full);
  border-top-right-radius: var(--border-radius-full);
  margin-bottom: 0;
}

.contactPane .headerSection header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0;
}

.contactPane .headerSection h2 {
  margin-bottom: 0;
}

/* ── Dotted horizontal rule ─────────────────────────────────── */

.contactPane .dottedHr {
  border: none;
  border-top: var(--border-width-sm, 0.1rem) dotted var(--color-text-muted);
  margin: 0;
}

/* ── Search section ─────────────────────────────────────────── */

.contactPane .searchSection {
  padding: var(--spacing-sm);
  padding-bottom: 0;
  margin-bottom: 0;
}

/* ── People list section ────────────────────────────────────── */

.contactPane .peopleSection {
  display: flex;
  background: var(--color-background);
  border-top: 1px dotted var(--color-text-muted);
  margin-bottom: 0;
}

.contactPane .peopleSection ul {
  list-style: none;
  padding: 0;
  margin: 0;
  width: 100%;
  max-height: 70vh;
  overflow-y: auto;
}

.contactPane .peopleSection li {
  border-top: var(--border-width-sm, 0.1rem) solid var(--color-border-pale);
  padding: var(--spacing-xs);
}

/* ── Person list item (addressBookPresenter) ─────────────────── */

.contactPane .personLi-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.contactPane .personLi-avatar {
  width: 2.813rem /* 45px */;
  height: 2.813rem /* 45px */;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.contactPane .personLi-avatar .avatar-placeholder {
  width: 2.25rem /* 36px */;
  height: 2.25rem /* 36px */;
  display: flex;
  align-items: center;
  justify-content: center;
}

.contactPane .personLi-avatar img {
  width: 2.5rem /* 40px */;
  height: 2.5rem /* 40px */;
  border-radius: 50%;
  object-fit: cover;
}

.contactPane .personLi-info {
  flex: 1;
  margin-left: var(--spacing-sm);
  overflow: hidden;
}

.contactPane .personLi-name {
  font-weight: bold;
  font-size: var(--font-size-base);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.contactPane .personLi-arrow {
  margin-left: auto;
  display: flex;
  align-items: center;
}

.contactPane .personLi--error {
  opacity: 0.5;
}`, "",{"version":3,"sources":["webpack://./src/styles/contactsPane.css"],"names":[],"mappings":"AAAA,4CAA4C;AAC5C;EACE,2DAA2D;EAC3D,mBAAmB;EACnB,gCAAgC;AAClC;AACA,0EAA0E;AAC1E,qFAAqF;;AAErF,mEAAmE;;AAEnE;EACE,iDAAiD;AACnD;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,WAAW,EAAE,wCAAwC;EACrD,YAAY,EAAE,4CAA4C;EAC1D,sBAAsB;EACtB,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,mBAAmB,EAAE,UAAU;EAC/B,0BAA0B;EAC1B,mBAAmB,EAAE,UAAU;EAC/B,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,mBAAmB,EAAE,UAAU;AACjC;;AAEA;EACE,aAAa;EACb,iBAAiB,EAAE,wBAAwB;EAC3C,mBAAmB,EAAE,yCAAyC;EAC9D,sBAAsB;EACtB,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,SAAS;AACX;;AAEA,kEAAkE;;AAElE;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB,EAAE,UAAU;AAChC;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;EAC/B,kEAAkE;EAClE,wCAAwC;EACxC,4BAA4B;EAC5B,8BAA8B;EAC9B,mCAAmC;AACrC;;AAEA,mEAAmE;;AAEnE;EACE,mDAAmD;EACnD,oBAAoB;AACtB;AACA,0CAA0C;AAC1C;EACE,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,kEAAkE;EAClE,yCAAyC;EACzC,yDAAgZ;EAChZ,4BAA4B;EAC5B,kCAAkC,EAAE,QAAQ;EAC5C,gCAAgC,EAAE,cAAc;EAChD,wCAAwC;EACxC,uCAAuC,EAAE,SAAS;EAClD,gCAAgC;EAChC,WAAW;EACX,sBAAsB;AACxB;;AAEA,qCAAqC;AACrC;EACE,kBAAkB;EAClB,wBAAwB;EACxB,QAAQ;EACR,2BAA2B;EAC3B,YAAY;EACZ,uBAAuB;EACvB,gCAAgC;EAChC,cAAc;EACd,UAAU;EACV,eAAe;EACf,8BAA8B;EAC9B,qEAAqE;EACrE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,wBAAwB;AAC1B;;AAEA,kEAAkE;;AAElE;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,iBAAiB,EAAE,mCAAmC;EACtD,yCAAyC;EACzC,4BAA4B;EAC5B,6BAA6B;EAC7B,WAAW,EAAE,yCAAyC;AACxD;;AAEA,mEAAmE;;AAEnE;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;EACtC,8BAA8B;AAChC;;AAEA;EACE,sCAAsC;AACxC;;AAEA,mEAAmE;;AAEnE;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,iBAAiB,EAAE,+BAA+B;EAClD,OAAO;EACP,YAAY,EAAE,uBAAuB;EACrC,oBAAoB;EACpB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,iCAAiC;EACjC,4BAA4B;EAC5B,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;;EAEE,yBAAyB;EACzB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,yDAAyD;EACzD;IACE,2BAA2B;EAC7B;;EAEA;IACE,iCAAiC;IACjC,4BAA4B;IAC5B,2BAA2B;IAC3B,uBAAuB;EACzB;;EAEA;;IAEE,yBAAyB;IACzB,qBAAqB;IACrB,sBAAsB;IACtB,0BAA0B;IAC1B,uBAAuB;EACzB;;;EAGA;IACE,2BAA2B;IAC3B,2BAA2B;IAC3B,8BAA8B;IAC9B,4CAA4C;IAC5C,wBAAwB;IACxB,iCAAiC;IACjC,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,2BAA2B;IAC3B,2BAA2B;IAC3B,8BAA8B;EAChC;;EAEA;IACE,wBAAwB;IACxB,iCAAiC;IACjC,sCAAsC;IACtC,+BAA+B;IAC/B,2BAA2B;IAC3B,uBAAuB;IACvB,8BAA8B;EAChC;;EAEA;IACE,yCAAyC;IACzC,iCAAiC;EACnC;;EAEA,+EAA+E;EAC/E;;;;KAIG;;EAEH;;;;;IAKE,4DAA4D;IAC5D,4BAA4B;IAC5B,+BAA+B;EACjC;;EAEA;;;IAGE,+BAA+B;IAC/B,8BAA8B;IAC9B,qBAAqB;EACvB;AACF;;;AAGA,4BAA4B;AAC5B;EACE,mCAAmC;EACnC,0BAA0B;EAC1B,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA,gDAAgD;AAChD;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA,kEAAkE;;;AAGlE;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;EACjC,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE;IACE,gBAAgB;IAChB,MAAM;IACN,UAAU;IACV,mCAAmC;IACnC,2CAA2C;EAC7C;AACF;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;AAC1C;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,sBAAsB;EACtB,cAAc;AAChB;;AAEA,4DAA4D;AAC5D;EACE,aAAa;EACb,2DAA2D;EAC3D,sBAAsB;EACtB,gBAAgB;EAChB,UAAU;EACV,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wCAAwC;EACxC,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;EACd,oBAAoB;EACpB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE;IACE,qCAAqC;IACrC,sBAAsB;EACxB;;EAEA;IACE,8BAA8B;IAC9B,wCAAwC;EAC1C;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,eAAe;AACjB;;AAEA,oEAAoE;AACpE;EACE,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;;AAGA;;;EAGE,6BAA6B;EAC7B,qBAAqB;EACrB,wBAAwB;EACxB,wBAAwB;EACxB,+BAA+B;EAC/B,qBAAqB;EACrB,8BAA8B;EAC9B,sCAAsC;EACtC,0BAA0B;EAC1B,8CAA8C;EAC9C,oEAAoE;EACpE,mDAAmD;EACnD,8CAA8C;EAC9C,2CAA2C;EAC3C,kCAAkC;AACpC;;AAEA;;;EAGE,wCAAwC;AAC1C;;AAEA,2CAA2C;AAC3C;EACE,sCAAsC;EACtC,8BAA8B;AAChC;;AAEA,mEAAmE;;AAEnE;EACE,mCAAmC;EACnC,0BAA0B;EAC1B,iDAAiD;EACjD,kDAAkD;EAClD,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,kEAAkE;;AAElE;EACE,YAAY;EACZ,yEAAyE;EACzE,SAAS;AACX;;AAEA,kEAAkE;;AAElE;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,kEAAkE;;AAElE;EACE,aAAa;EACb,mCAAmC;EACnC,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yEAAyE;EACzE,0BAA0B;AAC5B;;AAEA,mEAAmE;;AAEnE;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,OAAO;EACP,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd","sourcesContent":["/* Focus indicator for keyboard navigation */\n.contactPane table tr[tabindex=\"0\"]:focus {\n  outline: var(--focus-ring-width) solid var(--color-primary);\n  outline-offset: 2px;\n  background: var(--color-info-bg);\n}\n/* contactsPane styles — extracted from inline styles in contactsPane.js */\n/* Uses CSS custom properties from the global stylesheet (dev-global.css / mashlib) */\n\n/* ── Layout: Three-column browser ────────────────────────────── */\n\n.contactPane .peopleSection .selected {\n  background-color: var(--color-info-bg) !important;\n}\n\n.contactPane .detailSection,\n.contactPane .addressBookSection {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  flex: 1 1 0; /* allow it to grow but not force wrap */\n  min-width: 0; /* allow sections to collapse when stacked */\n  box-sizing: border-box;\n  background: var(--color-section-bg);\n}\n\n.contactPane .detailsSectionContent {\n  flex: 1 1 auto;\n  min-height: 12.5rem; /* 200px */\n  padding: var(--spacing-lg);\n  max-width: 56.25rem; /* 900px */\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.contactPane .detailsSectionContent--wide {\n  max-width: 56.25rem; /* 900px */\n}\n\n.contactPane .cardFooter {\n  display: flex;\n  flex-wrap: nowrap; /* keep buttons inline */\n  align-items: center; /* vertical centering if varied heights */\n  gap: var(--spacing-xs);\n  padding-top: var(--spacing-md);\n  margin-top: var(--spacing-md);\n}\n\n.contactPane .detailsSectionContent {\n  margin: 0;\n}\n\n/* ── Contact type chooser ───────────────────────────────────── */\n\n.contactPane .contactTypeChooser {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-sm);\n  max-width: 22.5rem; /* 360px */\n}\n\n.contactPane .contactTypeChooser h3 {\n  margin: 0 0 var(--spacing-xs) 0;\n  font-size: var(--font-size-lg);\n}\n\n.contactPane .contactTypeSelect {\n  height: var(--min-touch-target);\n  border: var(--border-width-sm, 1px) solid var(--color-border-pale);\n  border-radius: var(--border-radius-base);\n  padding: 0 var(--spacing-sm);\n  font-size: var(--font-size-sm);\n  background: var(--color-section-bg);\n}\n\n/* ── Search ──────────────────────────────────────────────────── */\n\n.contactPane .allGroupsButton {\n  border-radius: var(--border-radius-full) !important;\n  /* existing styles */\n}\n/* wrapper to position clear icon/button */\n.contactPane .searchDiv {\n  position: relative;\n}\n\n.contactPane .searchInput {\n  height: var(--min-touch-target);\n  border: var(--border-width-sm, 1px) solid var(--color-border-pale);\n  background-color: var(--color-section-bg);\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23999' viewBox='0 0 24 24' width='20' height='20'%3E%3Cpath d='M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99c.41.41 1.09.41 1.5 0s.41-1.09 0-1.5l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: 0.5rem center; /* 8px */\n  background-size: 1.25rem 1.25rem; /* 20px 20px */\n  border-radius: var(--border-radius-base);\n  padding: 0 var(--spacing-sm) 0 2.125rem; /* 34px */\n  font-size: var(--font-size-base);\n  width: 100%;\n  box-sizing: border-box;\n}\n\n/* clear button inside search input */\n.contactPane .searchClearButton {\n  position: absolute;\n  right: var(--spacing-sm);\n  top: 50%;\n  transform: translateY(-50%);\n  border: none;\n  background: transparent;\n  font-size: var(--font-size-base);\n  line-height: 1;\n  padding: 0;\n  cursor: pointer;\n  color: var(--color-text-muted);\n  /* visibility is controlled via the generic `.hidden` utility class */\n  display: block;\n}\n.contactPane .searchClearButton.hidden {\n  display: none;\n}\n.contactPane .searchClearButton:hover {\n  color: var(--color-text);\n}\n\n/* ── Contact toolbar (top-right link + delete) ──────────────── */\n\n.contactPane .contact-toolbar {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-sm);\n  padding: var(--spacing-xs) 0;\n}\n\n.contactPane .contact-toolbar a {\n  margin: 0.3rem;\n}\n\n.contactPane .contact-toolbar a img {\n  width: 1.3rem;\n  height: 1rem;\n  margin: 0;\n}\n\n.contact-toolbar .deleteButton {\n  margin-left: auto; /* keeps delete icon on the right */\n  margin-right: var(--spacing-xxxs, 0.2rem);\n  width: var(--icon-xxs, 1rem);\n  height: var(--icon-xxs, 1rem);\n  float: none; /* important: prevents overlap behavior */\n}\n\n/* ── \"All\" groups button ─────────────────────────────────────── */\n\n.contactPane .allGroupsButton {\n  margin-left: var(--spacing-md);\n  font-size: var(--font-size-base);\n}\n\n.contactPane .allGroupsButton--loading {\n  background-color: var(--color-primary);\n}\n\n.contactPane .allGroupsButton--active {\n  background-color: var(--color-primary);\n  color: var(--color-background);\n}\n\n.contactPane .allGroupsButton--loaded {\n  background-color: var(--color-primary);\n}\n\n/* ── Mint new address book ───────────────────────────────────── */\n\n.contactPane .claimSuccess {\n  font-size: var(--font-size-xl);\n}\n\n.contactPane {\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n}\n\n.contactPane .addressBook-grid {\n  display: flex;\n  flex-wrap: nowrap; /* keep sections side-by-side */\n  flex: 1;\n  min-width: 0; /* allow it to shrink */\n  align-items: stretch;\n  width: 100%;\n  box-sizing: border-box;\n  overflow-x: hidden;\n}\n\n@media ((min-width: 500px) and (max-width: 900px)) {\n  .contactPane .addressBookSection {\n    max-width: 900px;\n  }\n  .contactPane .addressBookSection section {\n    max-width: 485px;\n  }\n}\n\n.contactPane.contactPane--narrow .addressBook-grid {\n  flex-direction: column !important;\n  flex-wrap: nowrap !important;\n  min-width: 0 !important;\n  overflow-x: hidden !important;\n}\n\n.contactPane.contactPane--narrow .addressBookSection,\n.contactPane.contactPane--narrow .detailSection {\n  flex: 1 1 100% !important;\n  max-width: 100% !important;\n  min-width: 0 !important;\n  width: 100% !important;\n}\n\n@media (max-width: 1000px) {\n  /* Stack sidebar + details vertically on narrow screens */\n  .contactPane {\n    min-height: auto !important;\n  }\n\n  .contactPane .addressBook-grid {\n    flex-direction: column !important;\n    flex-wrap: nowrap !important;\n    min-height: auto !important;\n    height: auto !important;\n  }\n\n  .contactPane .addressBookSection,\n  .contactPane .detailSection {\n    order: initial !important;\n    flex: none !important;\n    width: 100% !important;\n    max-width: 100% !important;\n    min-width: 0 !important;\n  }\n\n\n  .contactPane .addressBookSection {\n    max-height: none !important;\n    min-height: auto !important;\n    overflow-y: visible !important;\n    padding-bottom: var(--spacing-lg) !important;\n    display: flex !important;\n    flex-direction: column !important;\n    height: auto !important;\n  }\n\n  .contactPane .peopleSection ul {\n    max-height: 50vh;\n    overflow-y: auto;\n  }\n\n  .contactPane .detailSection {\n    max-height: none !important;\n    min-height: auto !important;\n    overflow-y: visible !important;\n  }\n\n  .contactPane .detailsSectionContent {\n    display: flex !important;\n    flex-direction: column !important;\n    justify-content: flex-start !important;\n    align-items: stretch !important;\n    min-height: auto !important;\n    height: auto !important;\n    overflow-y: visible !important;\n  }\n\n  .contactPane .detailSection > .detailsSectionContent {\n    padding-top: var(--spacing-sm) !important;\n    box-sizing: border-box !important;\n  }\n\n  /* Keep a normal mobile text scale while preserving comfortable touch targets */\n  /* The following rule made all text much larger on mobile; comment out to restore normal font size for non-buttons.\n   .contactPane,\n   .contactPane * {\n    font-size: 1.5rem !important;\n  } */\n\n  .contactPane .actionButton,\n  .contactPane .searchInput,\n  .contactPane .flatButton,\n  .contactPane .buttonSection button,\n  .contactPane .groupButtonsList button {\n    min-height: calc(var(--min-touch-target) + 0.5em) !important;\n    font-size: 1.5rem !important;\n    padding: 0.875em 1em !important;\n  }\n\n  .contactPane .group-membership-item .group-membership-toolbar > img.hoverControlHide, .contactPane .group-membership-item .group-membership-toolbar > [data-testid=\"deleteButtonWithCheck\"],\n  .individualPane .hoverControl img.hoverControlHide, \n  .individualPane .hoverControl [data-testid=\"deleteButtonWithCheck\"] {\n    display: inline-flex !important;\n    visibility: visible !important;\n    opacity: 1 !important;\n  }\n}\n\n\n/* Card Section Background */\n.contactPane .addressBookSection.section-bg {\n  background: var(--color-section-bg);\n  padding: var(--spacing-md);\n  box-sizing: border-box;\n  border: none !important;\n  border-radius: 0 !important;\n}\n\n/* Keep detail section content anchored at top */\n.contactPane .detailSection {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: stretch;\n}\n\n.contactPane .detailsSectionContent {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: stretch;\n}\n\n/* ── Button section: horizontal scrollable row ──────────────── */\n\n\n.contactPane .buttonSection {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  padding: var(--spacing-sm);\n  padding-bottom: 0;\n  overflow-x: auto;\n  overflow-y: hidden;\n  -webkit-overflow-scrolling: touch;\n  scrollbar-width: thin;\n  margin-bottom: 0;\n}\n\n@media (max-width: 1000px) {\n  .contactPane .buttonSection {\n    position: sticky;\n    top: 0;\n    z-index: 2;\n    background: var(--color-section-bg);\n    box-shadow: 0 2px 4px -2px rgba(0,0,0,0.04);\n  }\n}\n\n.contactPane .buttonSection::-webkit-scrollbar {\n  height: 6px;\n}\n\n.contactPane .buttonSection::-webkit-scrollbar-thumb {\n  background: var(--color-border-pale);\n  border-radius: var(--border-radius-base);\n}\n\n.contactPane .buttonSection::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.contactPane .buttonSection .selected {\n  background: none !important;\n}\n\n.contactPane .groupButtonsList {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  gap: var(--spacing-xs);\n  list-style: none;\n}\n\n.contactPane .buttonSection .groupButtonsList {\n  margin-left: var(--spacing-xs);\n  margin-right: var(--spacing-xs);\n  padding-left: 0;\n}\n\n.contactPane .groupButtonsList li {\n  flex-shrink: 0;\n}\n\n.contactPane .groupButtonsList button {\n  white-space: nowrap;\n  flex-shrink: 0;\n  min-width: max-content;\n  margin-left: 0;\n}\n\n/* Groups list in details section — flexible 2-column grid */\n.contactPane .detailsSectionContent .groupButtonsList {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  gap: var(--spacing-sm);\n  list-style: none;\n  padding: 0;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.contactPane .detailsSectionContent .groupButtonsList li {\n  width: 100%;\n  aspect-ratio: auto;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: var(--spacing-xs);\n}\n\n.contactPane .detailsSectionContent .groupButtonsList button {\n  width: 100%;\n  height: auto;\n  text-align: center;\n  border-radius: var(--border-radius-base);\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n}\n\n.contactPane .detailsSectionContent .groupButtonsList li > img.hoverControlHide,\n.contactPane .detailsSectionContent .groupButtonsList li > img[data-testid=\"deleteButtonWithCheck\"] {\n  display: block;\n  align-self: flex-end;\n  float: none !important;\n  margin: 0 !important;\n}\n\n@media (max-width: 599px) {\n  .contactPane .detailsSectionContent .groupButtonsList {\n    grid-template-columns: repeat(2, 1fr);\n    gap: var(--spacing-xs);\n  }\n\n  .contactPane .detailsSectionContent .groupButtonsList button {\n    font-size: var(--font-size-sm);\n    border-radius: var(--border-radius-base);\n  }\n}\n\n@media (min-width: 900px) {\n  .contactPane .detailsSectionContent .groupButtonsList {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n.contactPane .detailsSectionContent .newGroupBtn {\n  width: 100%;\n  box-sizing: border-box;\n  margin-top: var(--spacing-sm);\n}\n\n.contactPane .detailsSectionContent h3 {\n  font-size: var(--font-size-xl);\n  margin-bottom: var(--spacing-sm);\n  padding-left: 0;\n}\n\n/* Delete confirmation POPUP — centered overlay in details section */\n.contactPane .detailSection {\n  position: relative;\n}\n\n.contactPane .webidControl div[style*=\"position: relative\"]:has(> div[style*=\"display: grid\"]) {\n  position: static !important;\n}\n\n\n.contactPane .webidControl .personaRow--webid td > div[style*=\"position: relative\"] > div,\n.contactPane .detailsSectionContent .groupButtonsList li > div[style*=\"position: relative\"] > div,\n.contactPane .detailsSectionContent .contact-toolbar  > div[style*=\"position: relative\"] > div {\n  position: absolute !important;\n  left: auto !important;\n  z-index: 9999 !important;\n  display: grid !important;\n  pointer-events: auto !important;\n  opacity: 1 !important;\n  visibility: visible !important;\n  padding: var(--spacing-btn) !important;\n  min-width: 12em !important;\n  background: var(--color-background) !important;\n  border: var(--border-width-sm) solid var(--color-primary) !important;\n  border-radius: var(--border-radius-base) !important;\n  box-shadow: var(--box-shadow-popup) !important;\n  grid-template-columns: auto auto !important;\n  gap: var(--spacing-xxs) !important;\n}\n\n.contactPane .detailsSectionContent .contact-toolbar > div[style*=\"position: relative\"] > div > button:has(> img[src$=\".svg\"]),\n.contactPane .detailsSectionContent .group-membership-item .group-membership-toolbar > div[style*=\"position: relative\"] > div > button:has(> img[src$=\".svg\"]),\n.contactPane .webidControl .personaRow--webid td > div[style*=\"position: relative\"] > div > button:has(> img[src$=\".svg\"]) {\n  background-color: transparent !important;\n}\n\n/* Selected state for All contacts button */\n.contactPane .allGroupsButton--selected {\n  background-color: var(--color-primary);\n  color: var(--color-background);\n}\n\n/* ── Header section ──────────────────────────────────────────── */\n\n.contactPane .headerSection {\n  background: var(--color-background);\n  padding: var(--spacing-sm);\n  border-top-left-radius: var(--border-radius-full);\n  border-top-right-radius: var(--border-radius-full);\n  margin-bottom: 0;\n}\n\n.contactPane .headerSection header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 0;\n}\n\n.contactPane .headerSection h2 {\n  margin-bottom: 0;\n}\n\n/* ── Dotted horizontal rule ─────────────────────────────────── */\n\n.contactPane .dottedHr {\n  border: none;\n  border-top: var(--border-width-sm, 0.1rem) dotted var(--color-text-muted);\n  margin: 0;\n}\n\n/* ── Search section ─────────────────────────────────────────── */\n\n.contactPane .searchSection {\n  padding: var(--spacing-sm);\n  padding-bottom: 0;\n  margin-bottom: 0;\n}\n\n/* ── People list section ────────────────────────────────────── */\n\n.contactPane .peopleSection {\n  display: flex;\n  background: var(--color-background);\n  border-top: 1px dotted var(--color-text-muted);\n  margin-bottom: 0;\n}\n\n.contactPane .peopleSection ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  width: 100%;\n  max-height: 70vh;\n  overflow-y: auto;\n}\n\n.contactPane .peopleSection li {\n  border-top: var(--border-width-sm, 0.1rem) solid var(--color-border-pale);\n  padding: var(--spacing-xs);\n}\n\n/* ── Person list item (addressBookPresenter) ─────────────────── */\n\n.contactPane .personLi-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.contactPane .personLi-avatar {\n  width: 2.813rem /* 45px */;\n  height: 2.813rem /* 45px */;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.contactPane .personLi-avatar .avatar-placeholder {\n  width: 2.25rem /* 36px */;\n  height: 2.25rem /* 36px */;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.contactPane .personLi-avatar img {\n  width: 2.5rem /* 40px */;\n  height: 2.5rem /* 40px */;\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n.contactPane .personLi-info {\n  flex: 1;\n  margin-left: var(--spacing-sm);\n  overflow: hidden;\n}\n\n.contactPane .personLi-name {\n  font-weight: bold;\n  font-size: var(--font-size-base);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.contactPane .personLi-arrow {\n  margin-left: auto;\n  display: flex;\n  align-items: center;\n}\n\n.contactPane .personLi--error {\n  opacity: 0.5;\n}"],"sourceRoot":""}]);
// Exports
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ },

/***/ 686
(module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(354);
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(314);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Solid-UI form */

/* Vertically center autocomplete input in .formFieldValue */
.individualPane .formFieldValue > div[style*="flex-direction: row"],
.contactPane .formFieldValue > div[style*="flex-direction: row"] {
  align-items: center;
  display: flex;
}

.individualPane .formFieldValue input[data-testid="autocomplete-input"],
.contactPane .formFieldValue input[data-testid="autocomplete-input"] {
  vertical-align: middle;
}

.individualPane .hoverControl,
.contactPane .hoverControl  {
  position: relative;
}

/* In contactPane, hover controls in table cells may contain a link + delete icon.
   Make the cell grow and keep the delete icon right-aligned (no overlap). */
.contactPane td.hoverControl:has(> a) {
  width: auto !important;
  min-width: 4rem !important;
  justify-content: space-between !important;
}

.contactPane td.hoverControl:has(> a) > a {
  flex: 1 1 auto;
  min-width: 0;
  overflow-wrap: anywhere;
  word-break: break-word;
  white-space: normal;
}

.individualPane .hoverControl:has(> img:first-child),
.contactPane .hoverControl:has(> img:first-child) {
  background-color: transparent !important;
  border: none !important;
  margin: 0 !important;
  border-radius: 0 !important;
  padding: var(--spacing-btn) !important;
  min-height: var(--min-touch-target);
  min-width: var(--min-touch-target);
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.individualPane .hoverControl:has(> img:first-child) > span,
.contactPane .hoverControl:has(> img:first-child) > span {
  display: inline-flex;
  align-items: center;
  margin-left: var(--spacing-xxs);
}

.individualPane div[style*="padding: 0.5em"]:has(> img),
.contactPane div[style*="padding: 0.5em"]:has(> img) {
  display: inline-flex;
  align-items: center;
}

.individualPane div[style*="padding: 0.5em"]:has(> img) > span,
.contactPane div[style*="padding: 0.5em"]:has(> img) > span {
  margin-left: var(--spacing-xxs);
}

.individualPane .hoverControl:has(> img:first-child):hover,
.contactPane .hoverControl:has(> img:first-child):hover {
  background-color: var(--color-section-bg) !important;
}

.individualPane button:has(> img[src\$=".svg"]),
.contactPane button:has(> img[src\$=".svg"]) {
  background-color: var(--color-section-bg) !important;
  border: none !important;
  margin: 0 !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  transition: background-color 0.2s ease, box-shadow 0.2s ease;
}

/* Ensure certain icon images render at a consistent size and align nicely when adjacent. */
.contactPane img[src\$="red.svg"],
.contactPane img[src\$="go-to-this.png"],
.individualPane img[src\$="red.svg"],
.individualPane img[src\$="go-to-this.png"] {
  width: 1.2rem !important;
  height: 1.2rem !important;
  max-width: none !important;
  max-height: none !important;
  object-fit: contain;
  display: inline-block;
  vertical-align: middle;
}

/* If the SVG button is inside a statsLog wrapper, add pink background to the button only. */
.individualPane .statsLog button:has(> img[src\$=".svg"]),
.contactPane .statsLog button:has(> img[src\$=".svg"]) {
  background-color: var(--color-info-bg) !important;
  border: initial !important;
  margin: initial !important;
  border-radius: initial !important;
}

/* Hide the “Continue” icon button that Solid-UI sometimes renders below textareas. */
.individualPane button:has(> img[title="Continue"]),
.contactPane button:has(> img[title="Continue"]) {
  display: none !important;
}

.contactPane .detailSection .detailsSectionContent button:has(> img[title="Continue"]),
.contactPane .detailSection .detailsSectionContent img[title="Continue"] {
  display: inline-flex !important;
}

.contactPane .detailSection .detailsSectionContent img[title="Continue"] {
  width: var(--icon-base, 2rem) !important;
  height: var(--icon-base, 2rem) !important;
}

/* Allow “Continue” buttons inside contactFormContainer to be visible. */
.individualPane .contactFormContainer button:has(> img[src\$="noun_1180158.svg"]),
.contactPane .contactFormContainer button:has(> img[src\$="noun_1180158.svg"]),
.individualPane .contactFormContainer button:has(> img[title="Continue"]),
.contactPane .contactFormContainer button:has(> img[title="Continue"]) {
  display: inline-flex !important;
}

/* Exception: allow “Continue” buttons inside statsLog to remain visible. */
.individualPane .statsLog button:has(> img[title="Continue"]),
.contactPane .statsLog button:has(> img[title="Continue"]),
.individualPane .webidControl button:has(> img[title="Continue"]),
.contactPane .webidControl button:has(> img[title="Continue"]){
  display: inline-flex !important;
}

.individualPane button,
.contactPane button {
  min-height: var(--min-touch-target);
  min-width: var(--min-touch-target);
}

.individualPane input:not([type="color"]),
.contactPane input:not([type="color"]) {
  width: 99%;
  max-width: 99%;
  min-width: 0;
  box-sizing: border-box;
  font: inherit;
  color: var(--color-text);
  background-color: var(--color-card-bg) !important;
  border: var(--border-width-sm) solid var(--color-border-pale);
  margin-left: 0 !important;
  margin-right: 0 !important;
}

.individualPane textarea,
.contactPane textarea,
.individualPane .formFieldValue textarea,
.contactPane .formFieldValue textarea {
  appearance: none;
  -webkit-appearance: none;
  border-radius: var(--border-radius-sm) !important;
  border: var(--border-width-xthin) solid var(--color-border-accent) !important;
  width: 99%;
  max-width: 99%;
  box-sizing: border-box;
  font: inherit;
  color: var(--color-text);
  background-color: var(--color-card-bg) !important;
  margin: 0 !important;
  margin-top: var(--spacing-xs);
  margin-left: 0 !important;
  margin-right: 0 !important;
  padding: var(--spacing-xs) !important;
}

.individualPane select,
.contactPane select {
  max-width: 99%;
  min-width: 0;
  box-sizing: border-box;
  font: inherit;
  color: var(--color-text);
  background-color: var(--color-card-bg) !important;
  border: var(--border-width-sm) solid var(--color-border-pale);
}

.individualPane input[type="date"],
.contactPane input[type="date"],
.individualPane input[type="month"],
.contactPane input[type="month"],
.individualPane input[type="week"],
.contactPane input[type="week"],
.individualPane input[type="time"],
.contactPane input[type="time"],
.individualPane input[type="datetime-local"],
.contactPane input[type="datetime-local"] {
  min-height: var(--min-touch-target);
}

.individualPane .hoverControl:has(> img:first-child):focus-visible,
.contactPane .hoverControl:has(> img:first-child):focus-visible,
.individualPane button:focus-visible,
.contactPane button:focus-visible,
.individualPane input:not([type="color"]):focus-visible,
.contactPane input:not([type="color"]):focus-visible,
.individualPane textarea:focus-visible,
.contactPane textarea:focus-visible,
.individualPane select:focus-visible,
.contactPane select:focus-visible {
  outline: var(--focus-ring-width) solid var(--color-primary) !important;
  outline-offset: 2px;
  box-shadow: 0 0 0 1px var(--color-background);
}

.individualPane input[type="url"],
.contactPane input[type="url"] {
  width: 99%;
}

.individualPane .formFieldValue,
.contactPane .formFieldValue {
  min-width: 0;
  margin-bottom: var(--spacing-sm);
}

.individualPane .formFieldValue table,
.contactPane .formFieldValue table {
  margin: 0 !important;
  padding: 0 !important;
}

.individualPane .formFieldValue td,
.contactPane .formFieldValue td {
  padding: 0 !important;
  vertical-align: middle;
}

.individualPane .formFieldValue table[data-testid="autocomplete-table"],
.contactPane .formFieldValue table[data-testid="autocomplete-table"] {
  height: 100%;
}

.individualPane .formFieldValue input:not([type="color"]),
.contactPane .formFieldValue input:not([type="color"]),
.individualPane .formFieldValue textarea,
.contactPane .formFieldValue textarea {
  width: 99% !important;
  max-width: 99%;
}

/* Email and phone value inputs: do not stretch full width */
.individualPane .formFieldName:has(a[href="http://www.w3.org/2006/vcard/ns#value"]) + .formFieldValue input:not([type="color"]),
.contactPane .formFieldName:has(a[href="http://www.w3.org/2006/vcard/ns#value"]) + .formFieldValue input:not([type="color"]) {
  width: 98% !important;
  max-width: 98%;
}

.individualPane .formFieldValue select,
.contactPane .formFieldValue select {
  width: 99%;
  display: inline-block;
  max-width: none !important;
}

.individualPane select#formSelect,
.contactPane select#formSelect {
  width: 99%;
  max-width: 98%;
  box-sizing: border-box;
  margin-left: 0 !important;
  margin-right: 0 !important;
}

.individualPane span select,
.contactPane span select {
  max-width: 96% !important;
  box-sizing: border-box;
  margin: 0 !important;
}

.individualPane .formFieldValue span select,
.contactPane .formFieldValue span select {
  margin-left: 0 !important;
  margin-right: 0 !important;
}

/* Remove border/padding from the first wrapper div (and its first child wrapper). */
.individualPane > div:first-of-type,
.contactPane > div:first-of-type,
.individualPane > div:first-of-type > div:first-of-type,
.contactPane > div:first-of-type > div:first-of-type {
  border: none !important;
  padding: 0 !important;
}

/* In contactPane, remove border/padding from all direct child divs. */
.individualPane > div,
.contactPane > div {
  border: none !important;
  padding: 0 !important;
}

/* Align schema.org, solid terms, FOAF, vCard, and org field labels with their input values. */
.individualPane :not(.choiceBox):has(> .formFieldName):has(> .formFieldValue),
.contactPane :not(.choiceBox):has(> .formFieldName):has(> .formFieldValue) {
  display: flex;
  align-items: baseline;
  margin-bottom: var(--spacing-sm);
}

/* for the Resume inside corporation choice */
/* Add space between classifierBox label and select box */
.individualPane .choiceBox .classifierBox-label,
.contactPane .choiceBox .classifierBox-label {
  margin-right: 0;
  padding-left: var(--spacing-xxs);
}

.individualPane .choiceBox .choiceBox-selectBox select,
.contactPane .choiceBox .choiceBox-selectBox select {
  margin-left: 2.1rem !important;
}

/* for the Resume orga details */
/* Add space between classifierBox label and select box */
.individualPane .classifierBox .classifierBox-label,
.contactPane .classifierBox .classifierBox-label {
  margin-right: 0;
  padding-left: var(--spacing-xxs);
  width: 8rem;
  padding: var(--spacing-xxs);
  vertical-align: middle;
}

.individualPane .classifierBox .classifierBox-selectBox,
.contactPane .classifierBox .classifierBox-selectBox {
  margin-left: 0 !important;
}

.individualPane .classifierBox .classifierBox-selectBox select,
.contactPane .classifierBox .classifierBox-selectBox select {
  margin-left: 0 !important;
}

.individualPane .formFieldValue > span > select,
.contactPane .formFieldValue > span > select {
  margin-left: 0 !important;
}

.individualPane :not(.choiceBox):has(> .formFieldName):has(> .formFieldValue) > .formFieldValue,
.contactPane :not(.choiceBox):has(> .formFieldName):has(> .formFieldValue) > .formFieldValue {
  margin-bottom: 0;
}

.individualPane :not(.choiceBox) > .formFieldName:has(a[href*="http://schema.org/"]),
.contactPane :not(.choiceBox) > .formFieldName:has(a[href*="http://schema.org/"]),
.individualPane :not(.choiceBox) > .formFieldName:has(a[href*="http://www.w3.org/ns/solid/terms#"]),
.contactPane :not(.choiceBox) > .formFieldName:has(a[href*="http://www.w3.org/ns/solid/terms#"]),
.individualPane :not(.choiceBox) > .formFieldName:has(a[href*="http://xmlns.com/foaf/0.1/"]),
.contactPane :not(.choiceBox) > .formFieldName:has(a[href*="http://xmlns.com/foaf/0.1/"]),
.individualPane :not(.choiceBox) > .formFieldName:has(a[href*="http://www.w3.org/2006/vcard/ns"]),
.contactPane :not(.choiceBox) > .formFieldName:has(a[href*="http://www.w3.org/2006/vcard/ns"]),
.individualPane :not(.choiceBox) > .formFieldName:has(a[href*="http://www.w3.org/ns/org#"]),
.contactPane :not(.choiceBox) > .formFieldName:has(a[href*="http://www.w3.org/ns/org#"]) {
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
}

.individualPane :not(.choiceBox) > .formFieldName:has(a[href*="http://schema.org/"]) + .formFieldValue,
.contactPane :not(.choiceBox) > .formFieldName:has(a[href*="http://schema.org/"]) + .formFieldValue,
.individualPane :not(.choiceBox) > .formFieldName:has(a[href*="http://www.w3.org/ns/solid/terms#"]) + .formFieldValue,
.contactPane :not(.choiceBox) > .formFieldName:has(a[href*="http://www.w3.org/ns/solid/terms#"]) + .formFieldValue,
.individualPane :not(.choiceBox) > .formFieldName:has(a[href*="http://xmlns.com/foaf/0.1/"]) + .formFieldValue,
.contactPane :not(.choiceBox) > .formFieldName:has(a[href*="http://xmlns.com/foaf/0.1/"]) + .formFieldValue,
.individualPane :not(.choiceBox) > .formFieldName:has(a[href*="http://www.w3.org/2006/vcard/ns"]) + .formFieldValue,
.contactPane :not(.choiceBox) > .formFieldName:has(a[href*="http://www.w3.org/2006/vcard/ns"]) + .formFieldValue,
.individualPane :not(.choiceBox) > .formFieldName:has(a[href*="http://www.w3.org/ns/org#"]) + .formFieldValue,
.contactPane :not(.choiceBox) > .formFieldName:has(a[href*="http://www.w3.org/ns/org#"]) + .formFieldValue {
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
  flex: 1;
  min-width: 0;
}

/* Center textarea label vertically in flex rows. */
.individualPane div[style*="display: flex"][style*="flex-direction: row"]:has(textarea),
.contactPane div[style*="display: flex"][style*="flex-direction: row"]:has(textarea) {
  align-items: flex-start;
}

.individualPane div[style*="display: flex"][style*="flex-direction: row"]:has(textarea) > div:has(> a),
.contactPane div[style*="display: flex"][style*="flex-direction: row"]:has(textarea) > div:has(> a) {
  padding-left: var(--spacing-xs);
  padding-top: var(--spacing-sm);
}

/* Keep autocomplete/table-based fields (e.g. Occupation) aligned to label text baseline. */
.individualPane :not(.choiceBox):has(> .formFieldValue input[data-testid="autocomplete-input"]),
.contactPane :not(.choiceBox):has(> .formFieldValue input[data-testid="autocomplete-input"]) {
  align-items: flex-start;
}

.individualPane :not(.choiceBox):has(> .formFieldValue input[data-testid="autocomplete-input"]) > .formFieldName,
.contactPane :not(.choiceBox):has(> .formFieldValue input[data-testid="autocomplete-input"]) > .formFieldName {
  padding-top: var(--spacing-xs) !important;
}

.individualPane .formFieldValue:has(input[data-testid="autocomplete-input"]),
.contactPane .formFieldValue:has(input[data-testid="autocomplete-input"]) {
  align-self: flex-start;
}

.individualPane .formFieldValue table[data-testid="autocomplete-table"],
.contactPane .formFieldValue table[data-testid="autocomplete-table"],
.individualPane .formFieldValue input[data-testid="autocomplete-input"],
.contactPane .formFieldValue input[data-testid="autocomplete-input"] {
  margin: 0 !important;
}

.individualPane .formFieldValue table[data-testid="autocomplete-table"],
.contactPane .formFieldValue table[data-testid="autocomplete-table"] {
  vertical-align: baseline;
}

.individualPane input:disabled,
.contactPane input:disabled,
.individualPane textarea:disabled,
.contactPane textarea:disabled,
.individualPane select:disabled,
.contactPane select:disabled,
.individualPane input[readonly],
.contactPane input[readonly],
.individualPane textarea[readonly],
.contactPane textarea[readonly],
.individualPane input:read-only,
.contactPane input:read-only,
.individualPane textarea:read-only,
.contactPane textarea:read-only {
  background-color: var(--color-background) !important;
  cursor: not-allowed;
  opacity: var(--opacity-input-disabled);
  border: var(--border-width-xthin) solid var(--color-background) !important;
}

.contactPane .webidControl table td div.contactPane.namedPane {
  border: none !important;
}

/* ------------------------------------------------------------------ */
/* inline popup used for small confirmation flows (like the new confirmDialog) */
/* apply the class \`rdf-inline-modal\` on the outer wrapper and give the
   inner box the class \`popup\` instead of using the old inline styles. */

/* selectors that match the old inline-styled markup when no classes can be added */

/* Delete pop up */
/* Remove the intermediate positioned ancestor so the popup anchors to .hoverControl instead */
.individualPane div[style*="position: relative"]:has(> div[style*="display: grid"]) {
  position: static !important;
}

.individualPane div[style*="position: relative"] > div[style*="display: grid"] {
  /* override inline values with theme variables */
  position: absolute !important;
  top: 0 !important;
  right: 0 !important;
  left: auto !important;
  z-index: 9999 !important;
  display: grid !important;
  pointer-events: auto !important;
  opacity: 1 !important;
  visibility: visible !important;
  padding: var(--spacing-btn) !important;
  background: var(--color-background) !important;
  border: var(--border-width-sm) solid var(--color-primary) !important;
  border-radius: var(--border-radius-base) !important;
  box-shadow: var(--box-shadow-popup) !important;
  grid-template-columns: auto auto !important;
  gap: var(--spacing-xxs) !important;
}

.individualPane .hoverControl img.hoverControlHide,
.individualPane .hoverControl [data-testid="deleteButtonWithCheck"] {
  position: absolute !important;
  right: var(--spacing-xxxs) !important;
  width: var(--icon-xs, 1.5rem) !important;
  height: var(--icon-xs, 1.5rem) !important;
  display: none !important;
  align-items: center;
  justify-content: center;
  margin: 0 !important;
  float: none !important;
  z-index: 2 !important;
}

/* Show delete icon only on hover */
.individualPane .hoverControl:hover img.hoverControlHide,
.individualPane .hoverControl:hover [data-testid="deleteButtonWithCheck"] {
  display: inline-flex !important;
}

/* If the hoverControl has exactly one div + the delete icon, keep the icon vertically centered but right-aligned */
.individualPane .hoverControl:has(> div:nth-child(1):nth-last-child(2)):hover > img.hoverControlHide,
.individualPane .hoverControl:has(> div:nth-child(1):nth-last-child(2)):hover > [data-testid="deleteButtonWithCheck"] {
  top: 50% !important;
  right: var(--spacing-xxxs) !important;
  left: auto !important;
  transform: translateY(-50%) !important;
}`, "",{"version":3,"sources":["webpack://./src/styles/contactsRDFFormsEnforced.css"],"names":[],"mappings":"AAAA,kBAAkB;;AAElB,4DAA4D;AAC5D;;EAEE,mBAAmB;EACnB,aAAa;AACf;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;4EAC4E;AAC5E;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;;EAEE,wCAAwC;EACxC,uBAAuB;EACvB,oBAAoB;EACpB,2BAA2B;EAC3B,sCAAsC;EACtC,mCAAmC;EACnC,kCAAkC;EAClC,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,oDAAoD;AACtD;;AAEA;;EAEE,oDAAoD;EACpD,uBAAuB;EACvB,oBAAoB;EACpB,2BAA2B;EAC3B,2BAA2B;EAC3B,4DAA4D;AAC9D;;AAEA,2FAA2F;AAC3F;;;;EAIE,wBAAwB;EACxB,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA,4FAA4F;AAC5F;;EAEE,iDAAiD;EACjD,0BAA0B;EAC1B,0BAA0B;EAC1B,iCAAiC;AACnC;;AAEA,qFAAqF;AACrF;;EAEE,wBAAwB;AAC1B;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;EACE,wCAAwC;EACxC,yCAAyC;AAC3C;;AAEA,wEAAwE;AACxE;;;;EAIE,+BAA+B;AACjC;;AAEA,2EAA2E;AAC3E;;;;EAIE,+BAA+B;AACjC;;AAEA;;EAEE,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;;EAEE,UAAU;EACV,cAAc;EACd,YAAY;EACZ,sBAAsB;EACtB,aAAa;EACb,wBAAwB;EACxB,iDAAiD;EACjD,6DAA6D;EAC7D,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;;;;EAIE,gBAAgB;EAChB,wBAAwB;EACxB,iDAAiD;EACjD,6EAA6E;EAC7E,UAAU;EACV,cAAc;EACd,sBAAsB;EACtB,aAAa;EACb,wBAAwB;EACxB,iDAAiD;EACjD,oBAAoB;EACpB,6BAA6B;EAC7B,yBAAyB;EACzB,0BAA0B;EAC1B,qCAAqC;AACvC;;AAEA;;EAEE,cAAc;EACd,YAAY;EACZ,sBAAsB;EACtB,aAAa;EACb,wBAAwB;EACxB,iDAAiD;EACjD,6DAA6D;AAC/D;;AAEA;;;;;;;;;;EAUE,mCAAmC;AACrC;;AAEA;;;;;;;;;;EAUE,sEAAsE;EACtE,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,YAAY;EACZ,gCAAgC;AAClC;;AAEA;;EAEE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;;EAEE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;;EAEE,YAAY;AACd;;AAEA;;;;EAIE,qBAAqB;EACrB,cAAc;AAChB;;AAEA,4DAA4D;AAC5D;;EAEE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;EAEE,UAAU;EACV,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;;EAEE,UAAU;EACV,cAAc;EACd,sBAAsB;EACtB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;;EAEE,yBAAyB;EACzB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;;EAEE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA,oFAAoF;AACpF;;;;EAIE,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA,sEAAsE;AACtE;;EAEE,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA,8FAA8F;AAC9F;;EAEE,aAAa;EACb,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA,6CAA6C;AAC7C,yDAAyD;AACzD;;EAEE,eAAe;EACf,gCAAgC;AAClC;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA,gCAAgC;AAChC,yDAAyD;AACzD;;EAEE,eAAe;EACf,gCAAgC;EAChC,WAAW;EACX,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;;;;;;;;;EAUE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;;;;;;;;;;EAUE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,OAAO;EACP,YAAY;AACd;;AAEA,mDAAmD;AACnD;;EAEE,uBAAuB;AACzB;;AAEA;;EAEE,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA,2FAA2F;AAC3F;;EAEE,uBAAuB;AACzB;;AAEA;;EAEE,yCAAyC;AAC3C;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;;;;EAIE,oBAAoB;AACtB;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;;;;;;;;;;;;;;EAcE,oDAAoD;EACpD,mBAAmB;EACnB,sCAAsC;EACtC,0EAA0E;AAC5E;;AAEA;EACE,uBAAuB;AACzB;;AAEA,uEAAuE;AACvE,gFAAgF;AAChF;wEACwE;;AAExE,mFAAmF;;AAEnF,kBAAkB;AAClB,8FAA8F;AAC9F;EACE,2BAA2B;AAC7B;;AAEA;EACE,gDAAgD;EAChD,6BAA6B;EAC7B,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,wBAAwB;EACxB,wBAAwB;EACxB,+BAA+B;EAC/B,qBAAqB;EACrB,8BAA8B;EAC9B,sCAAsC;EACtC,8CAA8C;EAC9C,oEAAoE;EACpE,mDAAmD;EACnD,8CAA8C;EAC9C,2CAA2C;EAC3C,kCAAkC;AACpC;;AAEA;;EAEE,6BAA6B;EAC7B,qCAAqC;EACrC,wCAAwC;EACxC,yCAAyC;EACzC,wBAAwB;EACxB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA,mCAAmC;AACnC;;EAEE,+BAA+B;AACjC;;AAEA,mHAAmH;AACnH;;EAEE,mBAAmB;EACnB,qCAAqC;EACrC,qBAAqB;EACrB,sCAAsC;AACxC","sourcesContent":["/* Solid-UI form */\n\n/* Vertically center autocomplete input in .formFieldValue */\n.individualPane .formFieldValue > div[style*=\"flex-direction: row\"],\n.contactPane .formFieldValue > div[style*=\"flex-direction: row\"] {\n  align-items: center;\n  display: flex;\n}\n\n.individualPane .formFieldValue input[data-testid=\"autocomplete-input\"],\n.contactPane .formFieldValue input[data-testid=\"autocomplete-input\"] {\n  vertical-align: middle;\n}\n\n.individualPane .hoverControl,\n.contactPane .hoverControl  {\n  position: relative;\n}\n\n/* In contactPane, hover controls in table cells may contain a link + delete icon.\n   Make the cell grow and keep the delete icon right-aligned (no overlap). */\n.contactPane td.hoverControl:has(> a) {\n  width: auto !important;\n  min-width: 4rem !important;\n  justify-content: space-between !important;\n}\n\n.contactPane td.hoverControl:has(> a) > a {\n  flex: 1 1 auto;\n  min-width: 0;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n  white-space: normal;\n}\n\n.individualPane .hoverControl:has(> img:first-child),\n.contactPane .hoverControl:has(> img:first-child) {\n  background-color: transparent !important;\n  border: none !important;\n  margin: 0 !important;\n  border-radius: 0 !important;\n  padding: var(--spacing-btn) !important;\n  min-height: var(--min-touch-target);\n  min-width: var(--min-touch-target);\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.individualPane .hoverControl:has(> img:first-child) > span,\n.contactPane .hoverControl:has(> img:first-child) > span {\n  display: inline-flex;\n  align-items: center;\n  margin-left: var(--spacing-xxs);\n}\n\n.individualPane div[style*=\"padding: 0.5em\"]:has(> img),\n.contactPane div[style*=\"padding: 0.5em\"]:has(> img) {\n  display: inline-flex;\n  align-items: center;\n}\n\n.individualPane div[style*=\"padding: 0.5em\"]:has(> img) > span,\n.contactPane div[style*=\"padding: 0.5em\"]:has(> img) > span {\n  margin-left: var(--spacing-xxs);\n}\n\n.individualPane .hoverControl:has(> img:first-child):hover,\n.contactPane .hoverControl:has(> img:first-child):hover {\n  background-color: var(--color-section-bg) !important;\n}\n\n.individualPane button:has(> img[src$=\".svg\"]),\n.contactPane button:has(> img[src$=\".svg\"]) {\n  background-color: var(--color-section-bg) !important;\n  border: none !important;\n  margin: 0 !important;\n  border-radius: 0 !important;\n  box-shadow: none !important;\n  transition: background-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n/* Ensure certain icon images render at a consistent size and align nicely when adjacent. */\n.contactPane img[src$=\"red.svg\"],\n.contactPane img[src$=\"go-to-this.png\"],\n.individualPane img[src$=\"red.svg\"],\n.individualPane img[src$=\"go-to-this.png\"] {\n  width: 1.2rem !important;\n  height: 1.2rem !important;\n  max-width: none !important;\n  max-height: none !important;\n  object-fit: contain;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n/* If the SVG button is inside a statsLog wrapper, add pink background to the button only. */\n.individualPane .statsLog button:has(> img[src$=\".svg\"]),\n.contactPane .statsLog button:has(> img[src$=\".svg\"]) {\n  background-color: var(--color-info-bg) !important;\n  border: initial !important;\n  margin: initial !important;\n  border-radius: initial !important;\n}\n\n/* Hide the “Continue” icon button that Solid-UI sometimes renders below textareas. */\n.individualPane button:has(> img[title=\"Continue\"]),\n.contactPane button:has(> img[title=\"Continue\"]) {\n  display: none !important;\n}\n\n.contactPane .detailSection .detailsSectionContent button:has(> img[title=\"Continue\"]),\n.contactPane .detailSection .detailsSectionContent img[title=\"Continue\"] {\n  display: inline-flex !important;\n}\n\n.contactPane .detailSection .detailsSectionContent img[title=\"Continue\"] {\n  width: var(--icon-base, 2rem) !important;\n  height: var(--icon-base, 2rem) !important;\n}\n\n/* Allow “Continue” buttons inside contactFormContainer to be visible. */\n.individualPane .contactFormContainer button:has(> img[src$=\"noun_1180158.svg\"]),\n.contactPane .contactFormContainer button:has(> img[src$=\"noun_1180158.svg\"]),\n.individualPane .contactFormContainer button:has(> img[title=\"Continue\"]),\n.contactPane .contactFormContainer button:has(> img[title=\"Continue\"]) {\n  display: inline-flex !important;\n}\n\n/* Exception: allow “Continue” buttons inside statsLog to remain visible. */\n.individualPane .statsLog button:has(> img[title=\"Continue\"]),\n.contactPane .statsLog button:has(> img[title=\"Continue\"]),\n.individualPane .webidControl button:has(> img[title=\"Continue\"]),\n.contactPane .webidControl button:has(> img[title=\"Continue\"]){\n  display: inline-flex !important;\n}\n\n.individualPane button,\n.contactPane button {\n  min-height: var(--min-touch-target);\n  min-width: var(--min-touch-target);\n}\n\n.individualPane input:not([type=\"color\"]),\n.contactPane input:not([type=\"color\"]) {\n  width: 99%;\n  max-width: 99%;\n  min-width: 0;\n  box-sizing: border-box;\n  font: inherit;\n  color: var(--color-text);\n  background-color: var(--color-card-bg) !important;\n  border: var(--border-width-sm) solid var(--color-border-pale);\n  margin-left: 0 !important;\n  margin-right: 0 !important;\n}\n\n.individualPane textarea,\n.contactPane textarea,\n.individualPane .formFieldValue textarea,\n.contactPane .formFieldValue textarea {\n  appearance: none;\n  -webkit-appearance: none;\n  border-radius: var(--border-radius-sm) !important;\n  border: var(--border-width-xthin) solid var(--color-border-accent) !important;\n  width: 99%;\n  max-width: 99%;\n  box-sizing: border-box;\n  font: inherit;\n  color: var(--color-text);\n  background-color: var(--color-card-bg) !important;\n  margin: 0 !important;\n  margin-top: var(--spacing-xs);\n  margin-left: 0 !important;\n  margin-right: 0 !important;\n  padding: var(--spacing-xs) !important;\n}\n\n.individualPane select,\n.contactPane select {\n  max-width: 99%;\n  min-width: 0;\n  box-sizing: border-box;\n  font: inherit;\n  color: var(--color-text);\n  background-color: var(--color-card-bg) !important;\n  border: var(--border-width-sm) solid var(--color-border-pale);\n}\n\n.individualPane input[type=\"date\"],\n.contactPane input[type=\"date\"],\n.individualPane input[type=\"month\"],\n.contactPane input[type=\"month\"],\n.individualPane input[type=\"week\"],\n.contactPane input[type=\"week\"],\n.individualPane input[type=\"time\"],\n.contactPane input[type=\"time\"],\n.individualPane input[type=\"datetime-local\"],\n.contactPane input[type=\"datetime-local\"] {\n  min-height: var(--min-touch-target);\n}\n\n.individualPane .hoverControl:has(> img:first-child):focus-visible,\n.contactPane .hoverControl:has(> img:first-child):focus-visible,\n.individualPane button:focus-visible,\n.contactPane button:focus-visible,\n.individualPane input:not([type=\"color\"]):focus-visible,\n.contactPane input:not([type=\"color\"]):focus-visible,\n.individualPane textarea:focus-visible,\n.contactPane textarea:focus-visible,\n.individualPane select:focus-visible,\n.contactPane select:focus-visible {\n  outline: var(--focus-ring-width) solid var(--color-primary) !important;\n  outline-offset: 2px;\n  box-shadow: 0 0 0 1px var(--color-background);\n}\n\n.individualPane input[type=\"url\"],\n.contactPane input[type=\"url\"] {\n  width: 99%;\n}\n\n.individualPane .formFieldValue,\n.contactPane .formFieldValue {\n  min-width: 0;\n  margin-bottom: var(--spacing-sm);\n}\n\n.individualPane .formFieldValue table,\n.contactPane .formFieldValue table {\n  margin: 0 !important;\n  padding: 0 !important;\n}\n\n.individualPane .formFieldValue td,\n.contactPane .formFieldValue td {\n  padding: 0 !important;\n  vertical-align: middle;\n}\n\n.individualPane .formFieldValue table[data-testid=\"autocomplete-table\"],\n.contactPane .formFieldValue table[data-testid=\"autocomplete-table\"] {\n  height: 100%;\n}\n\n.individualPane .formFieldValue input:not([type=\"color\"]),\n.contactPane .formFieldValue input:not([type=\"color\"]),\n.individualPane .formFieldValue textarea,\n.contactPane .formFieldValue textarea {\n  width: 99% !important;\n  max-width: 99%;\n}\n\n/* Email and phone value inputs: do not stretch full width */\n.individualPane .formFieldName:has(a[href=\"http://www.w3.org/2006/vcard/ns#value\"]) + .formFieldValue input:not([type=\"color\"]),\n.contactPane .formFieldName:has(a[href=\"http://www.w3.org/2006/vcard/ns#value\"]) + .formFieldValue input:not([type=\"color\"]) {\n  width: 98% !important;\n  max-width: 98%;\n}\n\n.individualPane .formFieldValue select,\n.contactPane .formFieldValue select {\n  width: 99%;\n  display: inline-block;\n  max-width: none !important;\n}\n\n.individualPane select#formSelect,\n.contactPane select#formSelect {\n  width: 99%;\n  max-width: 98%;\n  box-sizing: border-box;\n  margin-left: 0 !important;\n  margin-right: 0 !important;\n}\n\n.individualPane span select,\n.contactPane span select {\n  max-width: 96% !important;\n  box-sizing: border-box;\n  margin: 0 !important;\n}\n\n.individualPane .formFieldValue span select,\n.contactPane .formFieldValue span select {\n  margin-left: 0 !important;\n  margin-right: 0 !important;\n}\n\n/* Remove border/padding from the first wrapper div (and its first child wrapper). */\n.individualPane > div:first-of-type,\n.contactPane > div:first-of-type,\n.individualPane > div:first-of-type > div:first-of-type,\n.contactPane > div:first-of-type > div:first-of-type {\n  border: none !important;\n  padding: 0 !important;\n}\n\n/* In contactPane, remove border/padding from all direct child divs. */\n.individualPane > div,\n.contactPane > div {\n  border: none !important;\n  padding: 0 !important;\n}\n\n/* Align schema.org, solid terms, FOAF, vCard, and org field labels with their input values. */\n.individualPane :not(.choiceBox):has(> .formFieldName):has(> .formFieldValue),\n.contactPane :not(.choiceBox):has(> .formFieldName):has(> .formFieldValue) {\n  display: flex;\n  align-items: baseline;\n  margin-bottom: var(--spacing-sm);\n}\n\n/* for the Resume inside corporation choice */\n/* Add space between classifierBox label and select box */\n.individualPane .choiceBox .classifierBox-label,\n.contactPane .choiceBox .classifierBox-label {\n  margin-right: 0;\n  padding-left: var(--spacing-xxs);\n}\n\n.individualPane .choiceBox .choiceBox-selectBox select,\n.contactPane .choiceBox .choiceBox-selectBox select {\n  margin-left: 2.1rem !important;\n}\n\n/* for the Resume orga details */\n/* Add space between classifierBox label and select box */\n.individualPane .classifierBox .classifierBox-label,\n.contactPane .classifierBox .classifierBox-label {\n  margin-right: 0;\n  padding-left: var(--spacing-xxs);\n  width: 8rem;\n  padding: var(--spacing-xxs);\n  vertical-align: middle;\n}\n\n.individualPane .classifierBox .classifierBox-selectBox,\n.contactPane .classifierBox .classifierBox-selectBox {\n  margin-left: 0 !important;\n}\n\n.individualPane .classifierBox .classifierBox-selectBox select,\n.contactPane .classifierBox .classifierBox-selectBox select {\n  margin-left: 0 !important;\n}\n\n.individualPane .formFieldValue > span > select,\n.contactPane .formFieldValue > span > select {\n  margin-left: 0 !important;\n}\n\n.individualPane :not(.choiceBox):has(> .formFieldName):has(> .formFieldValue) > .formFieldValue,\n.contactPane :not(.choiceBox):has(> .formFieldName):has(> .formFieldValue) > .formFieldValue {\n  margin-bottom: 0;\n}\n\n.individualPane :not(.choiceBox) > .formFieldName:has(a[href*=\"http://schema.org/\"]),\n.contactPane :not(.choiceBox) > .formFieldName:has(a[href*=\"http://schema.org/\"]),\n.individualPane :not(.choiceBox) > .formFieldName:has(a[href*=\"http://www.w3.org/ns/solid/terms#\"]),\n.contactPane :not(.choiceBox) > .formFieldName:has(a[href*=\"http://www.w3.org/ns/solid/terms#\"]),\n.individualPane :not(.choiceBox) > .formFieldName:has(a[href*=\"http://xmlns.com/foaf/0.1/\"]),\n.contactPane :not(.choiceBox) > .formFieldName:has(a[href*=\"http://xmlns.com/foaf/0.1/\"]),\n.individualPane :not(.choiceBox) > .formFieldName:has(a[href*=\"http://www.w3.org/2006/vcard/ns\"]),\n.contactPane :not(.choiceBox) > .formFieldName:has(a[href*=\"http://www.w3.org/2006/vcard/ns\"]),\n.individualPane :not(.choiceBox) > .formFieldName:has(a[href*=\"http://www.w3.org/ns/org#\"]),\n.contactPane :not(.choiceBox) > .formFieldName:has(a[href*=\"http://www.w3.org/ns/org#\"]) {\n  display: inline-flex;\n  align-items: center;\n  vertical-align: middle;\n}\n\n.individualPane :not(.choiceBox) > .formFieldName:has(a[href*=\"http://schema.org/\"]) + .formFieldValue,\n.contactPane :not(.choiceBox) > .formFieldName:has(a[href*=\"http://schema.org/\"]) + .formFieldValue,\n.individualPane :not(.choiceBox) > .formFieldName:has(a[href*=\"http://www.w3.org/ns/solid/terms#\"]) + .formFieldValue,\n.contactPane :not(.choiceBox) > .formFieldName:has(a[href*=\"http://www.w3.org/ns/solid/terms#\"]) + .formFieldValue,\n.individualPane :not(.choiceBox) > .formFieldName:has(a[href*=\"http://xmlns.com/foaf/0.1/\"]) + .formFieldValue,\n.contactPane :not(.choiceBox) > .formFieldName:has(a[href*=\"http://xmlns.com/foaf/0.1/\"]) + .formFieldValue,\n.individualPane :not(.choiceBox) > .formFieldName:has(a[href*=\"http://www.w3.org/2006/vcard/ns\"]) + .formFieldValue,\n.contactPane :not(.choiceBox) > .formFieldName:has(a[href*=\"http://www.w3.org/2006/vcard/ns\"]) + .formFieldValue,\n.individualPane :not(.choiceBox) > .formFieldName:has(a[href*=\"http://www.w3.org/ns/org#\"]) + .formFieldValue,\n.contactPane :not(.choiceBox) > .formFieldName:has(a[href*=\"http://www.w3.org/ns/org#\"]) + .formFieldValue {\n  display: inline-flex;\n  align-items: center;\n  vertical-align: middle;\n  flex: 1;\n  min-width: 0;\n}\n\n/* Center textarea label vertically in flex rows. */\n.individualPane div[style*=\"display: flex\"][style*=\"flex-direction: row\"]:has(textarea),\n.contactPane div[style*=\"display: flex\"][style*=\"flex-direction: row\"]:has(textarea) {\n  align-items: flex-start;\n}\n\n.individualPane div[style*=\"display: flex\"][style*=\"flex-direction: row\"]:has(textarea) > div:has(> a),\n.contactPane div[style*=\"display: flex\"][style*=\"flex-direction: row\"]:has(textarea) > div:has(> a) {\n  padding-left: var(--spacing-xs);\n  padding-top: var(--spacing-sm);\n}\n\n/* Keep autocomplete/table-based fields (e.g. Occupation) aligned to label text baseline. */\n.individualPane :not(.choiceBox):has(> .formFieldValue input[data-testid=\"autocomplete-input\"]),\n.contactPane :not(.choiceBox):has(> .formFieldValue input[data-testid=\"autocomplete-input\"]) {\n  align-items: flex-start;\n}\n\n.individualPane :not(.choiceBox):has(> .formFieldValue input[data-testid=\"autocomplete-input\"]) > .formFieldName,\n.contactPane :not(.choiceBox):has(> .formFieldValue input[data-testid=\"autocomplete-input\"]) > .formFieldName {\n  padding-top: var(--spacing-xs) !important;\n}\n\n.individualPane .formFieldValue:has(input[data-testid=\"autocomplete-input\"]),\n.contactPane .formFieldValue:has(input[data-testid=\"autocomplete-input\"]) {\n  align-self: flex-start;\n}\n\n.individualPane .formFieldValue table[data-testid=\"autocomplete-table\"],\n.contactPane .formFieldValue table[data-testid=\"autocomplete-table\"],\n.individualPane .formFieldValue input[data-testid=\"autocomplete-input\"],\n.contactPane .formFieldValue input[data-testid=\"autocomplete-input\"] {\n  margin: 0 !important;\n}\n\n.individualPane .formFieldValue table[data-testid=\"autocomplete-table\"],\n.contactPane .formFieldValue table[data-testid=\"autocomplete-table\"] {\n  vertical-align: baseline;\n}\n\n.individualPane input:disabled,\n.contactPane input:disabled,\n.individualPane textarea:disabled,\n.contactPane textarea:disabled,\n.individualPane select:disabled,\n.contactPane select:disabled,\n.individualPane input[readonly],\n.contactPane input[readonly],\n.individualPane textarea[readonly],\n.contactPane textarea[readonly],\n.individualPane input:read-only,\n.contactPane input:read-only,\n.individualPane textarea:read-only,\n.contactPane textarea:read-only {\n  background-color: var(--color-background) !important;\n  cursor: not-allowed;\n  opacity: var(--opacity-input-disabled);\n  border: var(--border-width-xthin) solid var(--color-background) !important;\n}\n\n.contactPane .webidControl table td div.contactPane.namedPane {\n  border: none !important;\n}\n\n/* ------------------------------------------------------------------ */\n/* inline popup used for small confirmation flows (like the new confirmDialog) */\n/* apply the class `rdf-inline-modal` on the outer wrapper and give the\n   inner box the class `popup` instead of using the old inline styles. */\n\n/* selectors that match the old inline-styled markup when no classes can be added */\n\n/* Delete pop up */\n/* Remove the intermediate positioned ancestor so the popup anchors to .hoverControl instead */\n.individualPane div[style*=\"position: relative\"]:has(> div[style*=\"display: grid\"]) {\n  position: static !important;\n}\n\n.individualPane div[style*=\"position: relative\"] > div[style*=\"display: grid\"] {\n  /* override inline values with theme variables */\n  position: absolute !important;\n  top: 0 !important;\n  right: 0 !important;\n  left: auto !important;\n  z-index: 9999 !important;\n  display: grid !important;\n  pointer-events: auto !important;\n  opacity: 1 !important;\n  visibility: visible !important;\n  padding: var(--spacing-btn) !important;\n  background: var(--color-background) !important;\n  border: var(--border-width-sm) solid var(--color-primary) !important;\n  border-radius: var(--border-radius-base) !important;\n  box-shadow: var(--box-shadow-popup) !important;\n  grid-template-columns: auto auto !important;\n  gap: var(--spacing-xxs) !important;\n}\n\n.individualPane .hoverControl img.hoverControlHide,\n.individualPane .hoverControl [data-testid=\"deleteButtonWithCheck\"] {\n  position: absolute !important;\n  right: var(--spacing-xxxs) !important;\n  width: var(--icon-xs, 1.5rem) !important;\n  height: var(--icon-xs, 1.5rem) !important;\n  display: none !important;\n  align-items: center;\n  justify-content: center;\n  margin: 0 !important;\n  float: none !important;\n  z-index: 2 !important;\n}\n\n/* Show delete icon only on hover */\n.individualPane .hoverControl:hover img.hoverControlHide,\n.individualPane .hoverControl:hover [data-testid=\"deleteButtonWithCheck\"] {\n  display: inline-flex !important;\n}\n\n/* If the hoverControl has exactly one div + the delete icon, keep the icon vertically centered but right-aligned */\n.individualPane .hoverControl:has(> div:nth-child(1):nth-last-child(2)):hover > img.hoverControlHide,\n.individualPane .hoverControl:has(> div:nth-child(1):nth-last-child(2)):hover > [data-testid=\"deleteButtonWithCheck\"] {\n  top: 50% !important;\n  right: var(--spacing-xxxs) !important;\n  left: auto !important;\n  transform: translateY(-50%) !important;\n}"],"sourceRoot":""}]);
// Exports
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ },

/***/ 93
(module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(354);
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(314);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Group Membership Section ──────────────────────────────── */

.contactPane .group-membership-container {
  padding: var(--spacing-sm) 0;
}

/* Grid wrapper — matches detailsSectionContent groupButtonsList */
.contactPane .group-pills-wrapper {
  display: grid !important;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr)) !important;
  gap: var(--spacing-sm) !important;
  list-style: none;
  padding: 0;
  margin: 0;
  width: 100% !important;
}

.contactPane .group-pills-wrapper span {
  width: max-content !important;
}

/* Each group item: button on top, toolbar below */
.contactPane .group-membership-item {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  max-width: 16rem; /* 256px */
}

.contactPane .group-membership-item > button {
  width: 100%;
  text-align: center;
  border-radius: var(--border-radius-base);
  word-wrap: break-word;
  overflow-wrap: break-word;
  min-height: var(--min-touch-target);
}

/* Toolbar with link icon and delete button below each group button */
.contactPane .group-membership-item .group-membership-toolbar {
  display: flex;
  align-items: center;
  gap: var(--spacing-xs);
  padding: var(--spacing-xs) 0 0 0;
}

.contactPane .group-membership-item .group-membership-toolbar a {
  margin: 0.3rem;
  margin-left: 1rem;
}

.contactPane .group-membership-item .group-membership-toolbar a img {
  width: 1.3rem;
  height: 1rem;
  margin: 0;
}

/* Cancel float:right and any absolute positioning injected by solid-ui */
.contactPane .group-membership-item .group-membership-toolbar > img.hoverControlHide,
.contactPane .group-membership-item .group-membership-toolbar > [data-testid="deleteButtonWithCheck"] {
  float: none !important;
  display: inline-flex !important;
  visibility: hidden !important;
  margin: 0 !important;
}

.contactPane .group-membership-item .group-membership-toolbar:hover > img.hoverControlHide,
.contactPane .group-membership-item .group-membership-toolbar:hover > [data-testid="deleteButtonWithCheck"] {
  visibility: visible !important;
}

.contactPane .detailsSectionContent .group-membership-item .group-membership-toolbar > div[style*="position: relative"] {
  position: absolute !important;
  top: 0 !important;
  left: 50% !important;
  transform: translateX(-50%) !important;
  width: min(90vw, 27.5rem) !important; /* 440px */
  min-width: 17.5rem !important; /* 280px */
  max-width: 90vw !important;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.contactPane .detailsSectionContent .group-membership-item .group-membership-toolbar > div[style*="position: relative"] > div {
  position: relative !important;
  top: auto !important;
  min-width: 17.5rem !important; /* 280px */ 
  background: var(--color-background);
  border-radius: var(--border-radius-full);
  padding: var(--spacing-lg);
  box-shadow: var(--box-shadow-overlay);
  z-index: 1001;
}

@media (max-width: 599px) {
  .contactPane .group-membership-item .group-pills-wrapper {
    grid-template-columns: repeat(2, 1fr) !important;
    gap: var(--spacing-xs) !important;
    max-width: 100% !important;
  }

  .contactPane .group-membership-item .group-membership-item > button {
    font-size: var(--font-size-sm) !important;
    border-radius: var(--border-radius-base) !important;
  }
}

@media (min-width: 900px) {
  .contactPane .group-membership-item .group-pills-wrapper {
    grid-template-columns: repeat(3, 1fr) !important;
    gap: var(--spacing-sm) !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/groupMembership.css"],"names":[],"mappings":"AAAA,iEAAiE;;AAEjE;EACE,4BAA4B;AAC9B;;AAEA,kEAAkE;AAClE;EACE,wBAAwB;EACxB,sEAAsE;EACtE,iCAAiC;EACjC,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,kDAAkD;AAClD;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,gBAAgB,EAAE,UAAU;AAC9B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,wCAAwC;EACxC,qBAAqB;EACrB,yBAAyB;EACzB,mCAAmC;AACrC;;AAEA,qEAAqE;AACrE;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,SAAS;AACX;;AAEA,yEAAyE;AACzE;;EAEE,sBAAsB;EACtB,+BAA+B;EAC/B,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,oBAAoB;EACpB,sCAAsC;EACtC,oCAAoC,EAAE,UAAU;EAChD,6BAA6B,EAAE,UAAU;EACzC,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,oBAAoB;EACpB,6BAA6B,EAAE,UAAU;EACzC,mCAAmC;EACnC,wCAAwC;EACxC,0BAA0B;EAC1B,qCAAqC;EACrC,aAAa;AACf;;AAEA;EACE;IACE,gDAAgD;IAChD,iCAAiC;IACjC,0BAA0B;EAC5B;;EAEA;IACE,yCAAyC;IACzC,mDAAmD;EACrD;AACF;;AAEA;EACE;IACE,gDAAgD;IAChD,iCAAiC;EACnC;AACF","sourcesContent":["/* ── Group Membership Section ──────────────────────────────── */\n\n.contactPane .group-membership-container {\n  padding: var(--spacing-sm) 0;\n}\n\n/* Grid wrapper — matches detailsSectionContent groupButtonsList */\n.contactPane .group-pills-wrapper {\n  display: grid !important;\n  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr)) !important;\n  gap: var(--spacing-sm) !important;\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  width: 100% !important;\n}\n\n.contactPane .group-pills-wrapper span {\n  width: max-content !important;\n}\n\n/* Each group item: button on top, toolbar below */\n.contactPane .group-membership-item {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  max-width: 16rem; /* 256px */\n}\n\n.contactPane .group-membership-item > button {\n  width: 100%;\n  text-align: center;\n  border-radius: var(--border-radius-base);\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  min-height: var(--min-touch-target);\n}\n\n/* Toolbar with link icon and delete button below each group button */\n.contactPane .group-membership-item .group-membership-toolbar {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-xs);\n  padding: var(--spacing-xs) 0 0 0;\n}\n\n.contactPane .group-membership-item .group-membership-toolbar a {\n  margin: 0.3rem;\n  margin-left: 1rem;\n}\n\n.contactPane .group-membership-item .group-membership-toolbar a img {\n  width: 1.3rem;\n  height: 1rem;\n  margin: 0;\n}\n\n/* Cancel float:right and any absolute positioning injected by solid-ui */\n.contactPane .group-membership-item .group-membership-toolbar > img.hoverControlHide,\n.contactPane .group-membership-item .group-membership-toolbar > [data-testid=\"deleteButtonWithCheck\"] {\n  float: none !important;\n  display: inline-flex !important;\n  visibility: hidden !important;\n  margin: 0 !important;\n}\n\n.contactPane .group-membership-item .group-membership-toolbar:hover > img.hoverControlHide,\n.contactPane .group-membership-item .group-membership-toolbar:hover > [data-testid=\"deleteButtonWithCheck\"] {\n  visibility: visible !important;\n}\n\n.contactPane .detailsSectionContent .group-membership-item .group-membership-toolbar > div[style*=\"position: relative\"] {\n  position: absolute !important;\n  top: 0 !important;\n  left: 50% !important;\n  transform: translateX(-50%) !important;\n  width: min(90vw, 27.5rem) !important; /* 440px */\n  min-width: 17.5rem !important; /* 280px */\n  max-width: 90vw !important;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.contactPane .detailsSectionContent .group-membership-item .group-membership-toolbar > div[style*=\"position: relative\"] > div {\n  position: relative !important;\n  top: auto !important;\n  min-width: 17.5rem !important; /* 280px */ \n  background: var(--color-background);\n  border-radius: var(--border-radius-full);\n  padding: var(--spacing-lg);\n  box-shadow: var(--box-shadow-overlay);\n  z-index: 1001;\n}\n\n@media (max-width: 599px) {\n  .contactPane .group-membership-item .group-pills-wrapper {\n    grid-template-columns: repeat(2, 1fr) !important;\n    gap: var(--spacing-xs) !important;\n    max-width: 100% !important;\n  }\n\n  .contactPane .group-membership-item .group-membership-item > button {\n    font-size: var(--font-size-sm) !important;\n    border-radius: var(--border-radius-base) !important;\n  }\n}\n\n@media (min-width: 900px) {\n  .contactPane .group-membership-item .group-pills-wrapper {\n    grid-template-columns: repeat(3, 1fr) !important;\n    gap: var(--spacing-sm) !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ },

/***/ 479
(module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(354);
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(314);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* individual.js styles — extracted from inline styles */

/* ── Individual pane container ───────────────────────────────── */

.individualPane {
  padding: var(--spacing-xs) var(--spacing-lg) var(--spacing-md) var(--spacing-lg);
  background: var(--color-section-bg);
  border-radius: var(--border-radius-full);
  box-shadow: var(--box-shadow);
  box-sizing: border-box;
  max-width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/styles/individual.css"],"names":[],"mappings":"AAAA,wDAAwD;;AAExD,mEAAmE;;AAEnE;EACE,gFAAgF;EAChF,mCAAmC;EACnC,wCAAwC;EACxC,6BAA6B;EAC7B,sBAAsB;EACtB,eAAe;AACjB","sourcesContent":["/* individual.js styles — extracted from inline styles */\n\n/* ── Individual pane container ───────────────────────────────── */\n\n.individualPane {\n  padding: var(--spacing-xs) var(--spacing-lg) var(--spacing-md) var(--spacing-lg);\n  background: var(--color-section-bg);\n  border-radius: var(--border-radius-full);\n  box-shadow: var(--box-shadow);\n  box-sizing: border-box;\n  max-width: 100%;\n}"],"sourceRoot":""}]);
// Exports
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ },

/***/ 546
(module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(354);
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(314);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CSS for the accessible modal dialogs created by localUtils.js */

/* backdrop / focus trap container */
.focus-trap {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  background: var(--overlay-bg);
  display: flex;
  justify-content: center;
  align-items: center;
}

/* inner dialog box */
.focus-trap .modal {
  background: var(--color-background);
  padding: var(--spacing-lg);
  border-radius: var(--border-radius-base);
  max-width: 90%;
  box-shadow: var(--box-shadow-modal);
}

/* button container: center buttons horizontally (uses id in markup) */
#contacts-modal #modal-buttons {
  margin-top: var(--spacing-md);
  display: flex;
  justify-content: center;
  gap: var(--spacing-sm);
}

/* buttons themselves use the shared btn-primary rules */
#contacts-modal .modal button {
  min-height: var(--min-touch-target);
  padding: var(--spacing-sm) var(--spacing-md);
  border: 1px solid var(--color-primary);
  border-radius: var(--border-radius-base);
  font-weight: var(--font-weight-bold, 600);
  cursor: pointer;
  transition: all var(--animation-duration) ease;
}

#contacts-modal .modal button:disabled {
  opacity: var(--opacity-disabled);
  cursor: not-allowed;
  transform: none;
}
`, "",{"version":3,"sources":["webpack://./src/styles/localUtils.css"],"names":[],"mappings":"AAAA,kEAAkE;;AAElE,oCAAoC;AACpC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,6BAA6B;EAC7B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,mCAAmC;EACnC,0BAA0B;EAC1B,wCAAwC;EACxC,cAAc;EACd,mCAAmC;AACrC;;AAEA,sEAAsE;AACtE;EACE,6BAA6B;EAC7B,aAAa;EACb,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA,wDAAwD;AACxD;EACE,mCAAmC;EACnC,4CAA4C;EAC5C,sCAAsC;EACtC,wCAAwC;EACxC,yCAAyC;EACzC,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,eAAe;AACjB","sourcesContent":["/* CSS for the accessible modal dialogs created by localUtils.js */\n\n/* backdrop / focus trap container */\n.focus-trap {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 9999;\n  background: var(--overlay-bg);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n/* inner dialog box */\n.focus-trap .modal {\n  background: var(--color-background);\n  padding: var(--spacing-lg);\n  border-radius: var(--border-radius-base);\n  max-width: 90%;\n  box-shadow: var(--box-shadow-modal);\n}\n\n/* button container: center buttons horizontally (uses id in markup) */\n#contacts-modal #modal-buttons {\n  margin-top: var(--spacing-md);\n  display: flex;\n  justify-content: center;\n  gap: var(--spacing-sm);\n}\n\n/* buttons themselves use the shared btn-primary rules */\n#contacts-modal .modal button {\n  min-height: var(--min-touch-target);\n  padding: var(--spacing-sm) var(--spacing-md);\n  border: 1px solid var(--color-primary);\n  border-radius: var(--border-radius-base);\n  font-weight: var(--font-weight-bold, 600);\n  cursor: pointer;\n  transition: all var(--animation-duration) ease;\n}\n\n#contacts-modal .modal button:disabled {\n  opacity: var(--opacity-disabled);\n  cursor: not-allowed;\n  transform: none;\n}\n"],"sourceRoot":""}]);
// Exports
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ },

/***/ 715
(module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(354);
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(314);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* mugshotGallery.js styles — extracted from inline styles */
/* Uses CSS custom properties from the global stylesheet (dev-global.css / mashlib) */

/* ── Mugshot image ───────────────────────────────────────────── */

.contactPane .mugshotImage {
  max-height: 10rem;
  border-radius: var(--border-radius-full);
  margin: var(--spacing-sm);
}

.contactPane button:has(> img[src\$=".svg"]) {
  background-color: var(--color-section-bg) !important;
  border: none !important;
  margin: 0 !important;
  border-radius: 0 !important;
}
`, "",{"version":3,"sources":["webpack://./src/styles/mugshotGallery.css"],"names":[],"mappings":"AAAA,4DAA4D;AAC5D,qFAAqF;;AAErF,mEAAmE;;AAEnE;EACE,iBAAiB;EACjB,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,oDAAoD;EACpD,uBAAuB;EACvB,oBAAoB;EACpB,2BAA2B;AAC7B","sourcesContent":["/* mugshotGallery.js styles — extracted from inline styles */\n/* Uses CSS custom properties from the global stylesheet (dev-global.css / mashlib) */\n\n/* ── Mugshot image ───────────────────────────────────────────── */\n\n.contactPane .mugshotImage {\n  max-height: 10rem;\n  border-radius: var(--border-radius-full);\n  margin: var(--spacing-sm);\n}\n\n.contactPane button:has(> img[src$=\".svg\"]) {\n  background-color: var(--color-section-bg) !important;\n  border: none !important;\n  margin: 0 !important;\n  border-radius: 0 !important;\n}\n"],"sourceRoot":""}]);
// Exports
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ },

/***/ 295
(module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(354);
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(314);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* toolsPane.js styles — extracted from inline styles */
/* Uses CSS custom properties from the global stylesheet (dev-global.css / mashlib) */

/* ── Tools pane table ────────────────────────────────────────── */

.contactPane .statsLog {
  font-size: var(--font-size-lg);
  margin: var(--spacing-md);
  background-color: var(--color-background);
}

.contactPane .statsLog pre {
  padding: var(--spacing-md);
  white-space: pre-wrap;
  word-wrap: break-word;
  overflow-wrap: break-word;
  overflow: hidden;
  max-width: 100%;
}

/* ── Tools pane layout ────────────────────────────────────────── */

.contactPane .toolsPane {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-xs);
}

.contactPane .toolsButtonsContainer {
  display: flex;
  flex-wrap: wrap;
  gap: var(--spacing-xs);
}

/* ── Load index button states ──────────────────────────────── */

.contactPane .toolsButton--error {
  background-color: var(--color-error);
}

.contactPane .toolsButton--success {
  background-color: var(--color-primary);
}
`, "",{"version":3,"sources":["webpack://./src/styles/toolsPane.css"],"names":[],"mappings":"AAAA,uDAAuD;AACvD,qFAAqF;;AAErF,mEAAmE;;AAEnE;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,oEAAoE;;AAEpE;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,sBAAsB;AACxB;;AAEA,iEAAiE;;AAEjE;EACE,oCAAoC;AACtC;;AAEA;EACE,sCAAsC;AACxC","sourcesContent":["/* toolsPane.js styles — extracted from inline styles */\n/* Uses CSS custom properties from the global stylesheet (dev-global.css / mashlib) */\n\n/* ── Tools pane table ────────────────────────────────────────── */\n\n.contactPane .statsLog {\n  font-size: var(--font-size-lg);\n  margin: var(--spacing-md);\n  background-color: var(--color-background);\n}\n\n.contactPane .statsLog pre {\n  padding: var(--spacing-md);\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  overflow: hidden;\n  max-width: 100%;\n}\n\n/* ── Tools pane layout ────────────────────────────────────────── */\n\n.contactPane .toolsPane {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-xs);\n}\n\n.contactPane .toolsButtonsContainer {\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--spacing-xs);\n}\n\n/* ── Load index button states ──────────────────────────────── */\n\n.contactPane .toolsButton--error {\n  background-color: var(--color-error);\n}\n\n.contactPane .toolsButton--success {\n  background-color: var(--color-primary);\n}\n"],"sourceRoot":""}]);
// Exports
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ },

/***/ 92
(module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(354);
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(314);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Shared utility variables for component styles.
   These are kept here (instead of in dev-global.css) so they can be
   bundled with component styles and reused consistently across the app.
*/

/* Utility helper classes */

/* different from mashlib .btn-primary:active {
  box-shadow: var(--box-shadow-active);
} */
`, "",{"version":3,"sources":["webpack://./src/styles/utilities.css"],"names":[],"mappings":"AAAA;;;CAGC;;AAED,2BAA2B;;AAE3B;;GAEG","sourcesContent":["/* Shared utility variables for component styles.\n   These are kept here (instead of in dev-global.css) so they can be\n   bundled with component styles and reused consistently across the app.\n*/\n\n/* Utility helper classes */\n\n/* different from mashlib .btn-primary:active {\n  box-shadow: var(--box-shadow-active);\n} */\n"],"sourceRoot":""}]);
// Exports
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ },

/***/ 886
(module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(354);
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(314);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Named pane (rendered sub-pane) ──────────────────────────── */
.contactPane .namedPane {
  border: var(--border-width-sm) solid var(--color-text-muted);
  border-radius: var(--border-radius-base);
}

/* ── Persona row ─────────────────────────────────────────────── */

.contactPane .personaRow {
  padding: var(--spacing-xs);
}

.contactPane .personaRow--webid,
.contactPane .personaRow--webid td,
.contactPane .personaRow--webid button,
.contactPane .personaRow--webid button:hover,
.contactPane .personaRow--webid .hoverControl:has(> img:first-child),
.contactPane .personaRow--webid .hoverControl:has(> img:first-child):hover,
.contactPane .personaRow--webid .personaOpenButton:has(> img:first-child),
.contactPane .personaRow--webid .personaOpenButton:has(> img:first-child):hover {
  background-color: var(--color-info-bg) !important;
}

/* ── Full-width elements ─────────────────────────────────────── */

.contactPane .fullWidth {
  width: 100%;
}

/* ── Open/close profile button ───────────────────────────────── */

.contactPane .personaOpenButton {
  float: right;
  background-color: transparent;
  border: none;
}

/* hoverControl layout overrides are now enforced in contactsRDFFormsEnforced.css */

/* ── Delete confirmation popup in webidControl ───────────────── */

/* Remove intermediate positioned ancestor so popup anchors to .hoverControl */
.contactPane .webidControl div[style*="position: relative"]:has(> div[style*="display: grid"]) {
  position: static !important;
}

/* Position the popup absolutely so it never participates in the flex row */
.contactPane .webidControl div[style*="position: relative"] > div[style*="display: grid"] {
  position: absolute !important;
  top: 0 !important;
  right: 0 !important;
  left: auto !important;
  z-index: 9999 !important;
  display: grid !important;
  pointer-events: auto !important;
  opacity: 1 !important;
  visibility: visible !important;
  padding: var(--spacing-btn) !important;
  min-width: 12em !important;
  background: var(--color-background) !important;
  border: var(--border-width-sm) solid var(--color-primary) !important;
  border-radius: var(--border-radius-base) !important;
  box-shadow: var(--box-shadow-popup) !important;
  grid-template-columns: auto auto !important;
  gap: var(--spacing-xxs) !important;
}

/* ── Section heading ─────────────────────────────────────────── */

.contactPane .contactPanedHeading {
  font-size: var(--font-size-lg);
  font-weight: bold;
  color: var(--color-primary);
  margin: var(--spacing-sm) 0;
}

/* ── Prompt text ─────────────────────────────────────────────── */

.contactPane .webidPrompt {
  padding: var(--spacing-sm);
  border: none;
  font-size: var(--font-size-base);
  white-space: pre-wrap;
}

.contactPane :is(.contactPane--narrow .webidControl, .webidControl.webidControl--mobile) .namedPane,
.contactPane :is(.contactPane--narrow .webidControl, .webidControl.webidControl--mobile) table td div.contactPane.namedPane {
  display: block;
  width: 100% !important;
  max-width: none !important;
  min-width: 0 !important;
  box-sizing: border-box;
  container-type: inline-size;
  container-name: nested-profile-pane;
  margin-top: var(--spacing-sm);
}

.contactPane :is(.contactPane--narrow .webidControl, .webidControl.webidControl--mobile) .namedPane .profile-grid,
.contactPane :is(.contactPane--narrow .webidControl, .webidControl.webidControl--mobile) .namedPane #main-content.profile-grid {
  display: flex !important;
  flex-direction: column !important;
  gap: var(--spacing-sm) !important;
}

.contactPane :is(.contactPane--narrow .webidControl, .webidControl.webidControl--mobile) .namedPane .profile__main,
.contactPane :is(.contactPane--narrow .webidControl, .webidControl.webidControl--mobile) .namedPane .profile__sidebar,
.contactPane :is(.contactPane--narrow .webidControl, .webidControl.webidControl--mobile) .namedPane .profile__section {
  width: 100% !important;
  min-width: 0 !important;
  max-width: 100% !important;
  box-sizing: border-box;
  overflow-wrap: anywhere;
}

.contactPane :is(.contactPane--narrow .webidControl, .webidControl.webidControl--mobile) .namedPane .profile__sidebar,
.contactPane :is(.contactPane--narrow .webidControl, .webidControl.webidControl--mobile) .namedPane .profile__section,
.contactPane :is(.contactPane--narrow .webidControl, .webidControl.webidControl--mobile) .namedPane .profile__main {
  padding: var(--spacing-sm) !important;
}

.contactPane :is(.contactPane--narrow .webidControl, .webidControl.webidControl--mobile) .namedPane .profileSectionCollapsible[data-expanded="false"] .profileSectionCollapsible__content {
  display: none !important;
}

.contactPane :is(.contactPane--narrow .webidControl, .webidControl.webidControl--mobile) .namedPane .profileSectionCollapsible__toggle {
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  min-height: auto !important;
  min-width: auto !important;
  padding: var(--spacing-xxs) !important;
  border: none !important;
  background: none !important;
  color: var(--color-text) !important;
}

.contactPane :is(.contactPane--narrow .webidControl, .webidControl.webidControl--mobile) .namedPane .profileSectionCollapsible[data-expanded="true"] .profileSectionCollapsible__chevron {
  transform: rotate(180deg);
}

.contactPane :is(.contactPane--narrow .webidControl, .webidControl.webidControl--mobile) .namedPane .profileSectionCollapsible__editLabel {
  display: none !important;
}

.contactPane :is(.contactPane--narrow .webidControl, .webidControl.webidControl--mobile) .namedPane .profileSectionCollapsible__editIcon {
  display: inline !important;
}

.contactPane :is(.contactPane--narrow .webidControl, .webidControl.webidControl--mobile) .namedPane .socialItem {
  display: flex !important;
  align-items: center !important;
  flex: 0 0 auto !important;
}

.contactPane :is(.contactPane--narrow .webidControl, .webidControl.webidControl--mobile) .namedPane .socialItem a {
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  flex: 0 0 auto !important;
  width: auto !important;
  min-width: var(--min-touch-target) !important;
  min-height: var(--min-touch-target) !important;
  line-height: 0 !important;
}

.contactPane :is(.contactPane--narrow .webidControl, .webidControl.webidControl--mobile) .namedPane .socialIcon {
  display: block !important;
  width: 40px !important;
  height: 40px !important;
  min-width: 40px !important;
  min-height: 40px !important;
  max-width: 40px !important;
  max-height: 40px !important;
  object-fit: contain !important;
  flex-shrink: 0 !important;
}

@media (max-width: 1000px) {
  .contactPane .webidControl,
  .contactPane .webidControl table,
  .contactPane .webidControl tbody,
  .contactPane .webidControl tr,
  .contactPane .webidControl td {
    width: 100%;
    max-width: 100%;
    min-width: 0;
    box-sizing: border-box;
  }

  .contactPane .webidControl table {
    table-layout: fixed;
  }

  .contactPane .webidControl .personaRow--webid td {
    vertical-align: top;
  }

  .contactPane .webidControl .contactPane,
  .contactPane .webidControl .contactPane .addressBook-grid,
  .contactPane .webidControl .contactPane .detailSection,
  .contactPane .webidControl .contactPane .detailsSectionContent {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
    box-sizing: border-box;
  }

  .contactPane .webidControl .contactPane .addressBook-grid {
    flex-direction: column !important;
    flex-wrap: nowrap !important;
  }

  .contactPane .webidControl .contactPane .detailSection,
  .contactPane .webidControl .contactPane .addressBookSection {
    flex: none !important;
  }

  .contactPane .webidControl .contactPane .detailsSectionContent,
  .contactPane .webidControl .contactPane .detailsSectionContent--wide {
    padding: var(--spacing-sm) !important;
    overflow-y: visible !important;
  }

}

@container nested-profile-pane (max-width: 900px) {
  .contactPane .webidControl .profile-grid {
    display: flex !important;
    flex-direction: column !important;
    gap: var(--spacing-sm) !important;
  }

  .contactPane .webidControl .profile-grid > * {
    min-width: 0 !important;
    max-width: 100% !important;
  }

  .contactPane .webidControl .profile__main,
  .contactPane .webidControl .profile__sidebar,
  .contactPane .webidControl .profile__section {
    width: 100% !important;
    min-width: 0 !important;
    max-width: 100% !important;
    overflow-wrap: anywhere;
  }
}

/* ── Visibility / display helpers ────────────────────────────── */

.contactPane .collapsed {
  visibility: collapse;
}
`, "",{"version":3,"sources":["webpack://./src/styles/webidControl.css"],"names":[],"mappings":"AAAA,mEAAmE;AACnE;EACE,4DAA4D;EAC5D,wCAAwC;AAC1C;;AAEA,mEAAmE;;AAEnE;EACE,0BAA0B;AAC5B;;AAEA;;;;;;;;EAQE,iDAAiD;AACnD;;AAEA,mEAAmE;;AAEnE;EACE,WAAW;AACb;;AAEA,mEAAmE;;AAEnE;EACE,YAAY;EACZ,6BAA6B;EAC7B,YAAY;AACd;;AAEA,mFAAmF;;AAEnF,mEAAmE;;AAEnE,8EAA8E;AAC9E;EACE,2BAA2B;AAC7B;;AAEA,2EAA2E;AAC3E;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,wBAAwB;EACxB,wBAAwB;EACxB,+BAA+B;EAC/B,qBAAqB;EACrB,8BAA8B;EAC9B,sCAAsC;EACtC,0BAA0B;EAC1B,8CAA8C;EAC9C,oEAAoE;EACpE,mDAAmD;EACnD,8CAA8C;EAC9C,2CAA2C;EAC3C,kCAAkC;AACpC;;AAEA,mEAAmE;;AAEnE;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA,mEAAmE;;AAEnE;EACE,0BAA0B;EAC1B,YAAY;EACZ,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;EACd,sBAAsB;EACtB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,2BAA2B;EAC3B,mCAAmC;EACnC,6BAA6B;AAC/B;;AAEA;;EAEE,wBAAwB;EACxB,iCAAiC;EACjC,iCAAiC;AACnC;;AAEA;;;EAGE,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;;;EAGE,qCAAqC;AACvC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,0BAA0B;EAC1B,sCAAsC;EACtC,uBAAuB;EACvB,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,kCAAkC;EAClC,yBAAyB;EACzB,sBAAsB;EACtB,6CAA6C;EAC7C,8CAA8C;EAC9C,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,2BAA2B;EAC3B,0BAA0B;EAC1B,2BAA2B;EAC3B,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE;;;;;IAKE,WAAW;IACX,eAAe;IACf,YAAY;IACZ,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;;;IAIE,sBAAsB;IACtB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;IACE,iCAAiC;IACjC,4BAA4B;EAC9B;;EAEA;;IAEE,qBAAqB;EACvB;;EAEA;;IAEE,qCAAqC;IACrC,8BAA8B;EAChC;;AAEF;;AAEA;EACE;IACE,wBAAwB;IACxB,iCAAiC;IACjC,iCAAiC;EACnC;;EAEA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;;EAEA;;;IAGE,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,uBAAuB;EACzB;AACF;;AAEA,mEAAmE;;AAEnE;EACE,oBAAoB;AACtB","sourcesContent":["/* ── Named pane (rendered sub-pane) ──────────────────────────── */\n.contactPane .namedPane {\n  border: var(--border-width-sm) solid var(--color-text-muted);\n  border-radius: var(--border-radius-base);\n}\n\n/* ── Persona row ─────────────────────────────────────────────── */\n\n.contactPane .personaRow {\n  padding: var(--spacing-xs);\n}\n\n.contactPane .personaRow--webid,\n.contactPane .personaRow--webid td,\n.contactPane .personaRow--webid button,\n.contactPane .personaRow--webid button:hover,\n.contactPane .personaRow--webid .hoverControl:has(> img:first-child),\n.contactPane .personaRow--webid .hoverControl:has(> img:first-child):hover,\n.contactPane .personaRow--webid .personaOpenButton:has(> img:first-child),\n.contactPane .personaRow--webid .personaOpenButton:has(> img:first-child):hover {\n  background-color: var(--color-info-bg) !important;\n}\n\n/* ── Full-width elements ─────────────────────────────────────── */\n\n.contactPane .fullWidth {\n  width: 100%;\n}\n\n/* ── Open/close profile button ───────────────────────────────── */\n\n.contactPane .personaOpenButton {\n  float: right;\n  background-color: transparent;\n  border: none;\n}\n\n/* hoverControl layout overrides are now enforced in contactsRDFFormsEnforced.css */\n\n/* ── Delete confirmation popup in webidControl ───────────────── */\n\n/* Remove intermediate positioned ancestor so popup anchors to .hoverControl */\n.contactPane .webidControl div[style*=\"position: relative\"]:has(> div[style*=\"display: grid\"]) {\n  position: static !important;\n}\n\n/* Position the popup absolutely so it never participates in the flex row */\n.contactPane .webidControl div[style*=\"position: relative\"] > div[style*=\"display: grid\"] {\n  position: absolute !important;\n  top: 0 !important;\n  right: 0 !important;\n  left: auto !important;\n  z-index: 9999 !important;\n  display: grid !important;\n  pointer-events: auto !important;\n  opacity: 1 !important;\n  visibility: visible !important;\n  padding: var(--spacing-btn) !important;\n  min-width: 12em !important;\n  background: var(--color-background) !important;\n  border: var(--border-width-sm) solid var(--color-primary) !important;\n  border-radius: var(--border-radius-base) !important;\n  box-shadow: var(--box-shadow-popup) !important;\n  grid-template-columns: auto auto !important;\n  gap: var(--spacing-xxs) !important;\n}\n\n/* ── Section heading ─────────────────────────────────────────── */\n\n.contactPane .contactPanedHeading {\n  font-size: var(--font-size-lg);\n  font-weight: bold;\n  color: var(--color-primary);\n  margin: var(--spacing-sm) 0;\n}\n\n/* ── Prompt text ─────────────────────────────────────────────── */\n\n.contactPane .webidPrompt {\n  padding: var(--spacing-sm);\n  border: none;\n  font-size: var(--font-size-base);\n  white-space: pre-wrap;\n}\n\n.contactPane :is(.contactPane--narrow .webidControl, .webidControl.webidControl--mobile) .namedPane,\n.contactPane :is(.contactPane--narrow .webidControl, .webidControl.webidControl--mobile) table td div.contactPane.namedPane {\n  display: block;\n  width: 100% !important;\n  max-width: none !important;\n  min-width: 0 !important;\n  box-sizing: border-box;\n  container-type: inline-size;\n  container-name: nested-profile-pane;\n  margin-top: var(--spacing-sm);\n}\n\n.contactPane :is(.contactPane--narrow .webidControl, .webidControl.webidControl--mobile) .namedPane .profile-grid,\n.contactPane :is(.contactPane--narrow .webidControl, .webidControl.webidControl--mobile) .namedPane #main-content.profile-grid {\n  display: flex !important;\n  flex-direction: column !important;\n  gap: var(--spacing-sm) !important;\n}\n\n.contactPane :is(.contactPane--narrow .webidControl, .webidControl.webidControl--mobile) .namedPane .profile__main,\n.contactPane :is(.contactPane--narrow .webidControl, .webidControl.webidControl--mobile) .namedPane .profile__sidebar,\n.contactPane :is(.contactPane--narrow .webidControl, .webidControl.webidControl--mobile) .namedPane .profile__section {\n  width: 100% !important;\n  min-width: 0 !important;\n  max-width: 100% !important;\n  box-sizing: border-box;\n  overflow-wrap: anywhere;\n}\n\n.contactPane :is(.contactPane--narrow .webidControl, .webidControl.webidControl--mobile) .namedPane .profile__sidebar,\n.contactPane :is(.contactPane--narrow .webidControl, .webidControl.webidControl--mobile) .namedPane .profile__section,\n.contactPane :is(.contactPane--narrow .webidControl, .webidControl.webidControl--mobile) .namedPane .profile__main {\n  padding: var(--spacing-sm) !important;\n}\n\n.contactPane :is(.contactPane--narrow .webidControl, .webidControl.webidControl--mobile) .namedPane .profileSectionCollapsible[data-expanded=\"false\"] .profileSectionCollapsible__content {\n  display: none !important;\n}\n\n.contactPane :is(.contactPane--narrow .webidControl, .webidControl.webidControl--mobile) .namedPane .profileSectionCollapsible__toggle {\n  display: inline-flex !important;\n  align-items: center;\n  justify-content: center;\n  min-height: auto !important;\n  min-width: auto !important;\n  padding: var(--spacing-xxs) !important;\n  border: none !important;\n  background: none !important;\n  color: var(--color-text) !important;\n}\n\n.contactPane :is(.contactPane--narrow .webidControl, .webidControl.webidControl--mobile) .namedPane .profileSectionCollapsible[data-expanded=\"true\"] .profileSectionCollapsible__chevron {\n  transform: rotate(180deg);\n}\n\n.contactPane :is(.contactPane--narrow .webidControl, .webidControl.webidControl--mobile) .namedPane .profileSectionCollapsible__editLabel {\n  display: none !important;\n}\n\n.contactPane :is(.contactPane--narrow .webidControl, .webidControl.webidControl--mobile) .namedPane .profileSectionCollapsible__editIcon {\n  display: inline !important;\n}\n\n.contactPane :is(.contactPane--narrow .webidControl, .webidControl.webidControl--mobile) .namedPane .socialItem {\n  display: flex !important;\n  align-items: center !important;\n  flex: 0 0 auto !important;\n}\n\n.contactPane :is(.contactPane--narrow .webidControl, .webidControl.webidControl--mobile) .namedPane .socialItem a {\n  display: inline-flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  flex: 0 0 auto !important;\n  width: auto !important;\n  min-width: var(--min-touch-target) !important;\n  min-height: var(--min-touch-target) !important;\n  line-height: 0 !important;\n}\n\n.contactPane :is(.contactPane--narrow .webidControl, .webidControl.webidControl--mobile) .namedPane .socialIcon {\n  display: block !important;\n  width: 40px !important;\n  height: 40px !important;\n  min-width: 40px !important;\n  min-height: 40px !important;\n  max-width: 40px !important;\n  max-height: 40px !important;\n  object-fit: contain !important;\n  flex-shrink: 0 !important;\n}\n\n@media (max-width: 1000px) {\n  .contactPane .webidControl,\n  .contactPane .webidControl table,\n  .contactPane .webidControl tbody,\n  .contactPane .webidControl tr,\n  .contactPane .webidControl td {\n    width: 100%;\n    max-width: 100%;\n    min-width: 0;\n    box-sizing: border-box;\n  }\n\n  .contactPane .webidControl table {\n    table-layout: fixed;\n  }\n\n  .contactPane .webidControl .personaRow--webid td {\n    vertical-align: top;\n  }\n\n  .contactPane .webidControl .contactPane,\n  .contactPane .webidControl .contactPane .addressBook-grid,\n  .contactPane .webidControl .contactPane .detailSection,\n  .contactPane .webidControl .contactPane .detailsSectionContent {\n    width: 100% !important;\n    max-width: 100% !important;\n    min-width: 0 !important;\n    box-sizing: border-box;\n  }\n\n  .contactPane .webidControl .contactPane .addressBook-grid {\n    flex-direction: column !important;\n    flex-wrap: nowrap !important;\n  }\n\n  .contactPane .webidControl .contactPane .detailSection,\n  .contactPane .webidControl .contactPane .addressBookSection {\n    flex: none !important;\n  }\n\n  .contactPane .webidControl .contactPane .detailsSectionContent,\n  .contactPane .webidControl .contactPane .detailsSectionContent--wide {\n    padding: var(--spacing-sm) !important;\n    overflow-y: visible !important;\n  }\n\n}\n\n@container nested-profile-pane (max-width: 900px) {\n  .contactPane .webidControl .profile-grid {\n    display: flex !important;\n    flex-direction: column !important;\n    gap: var(--spacing-sm) !important;\n  }\n\n  .contactPane .webidControl .profile-grid > * {\n    min-width: 0 !important;\n    max-width: 100% !important;\n  }\n\n  .contactPane .webidControl .profile__main,\n  .contactPane .webidControl .profile__sidebar,\n  .contactPane .webidControl .profile__section {\n    width: 100% !important;\n    min-width: 0 !important;\n    max-width: 100% !important;\n    overflow-wrap: anywhere;\n  }\n}\n\n/* ── Visibility / display helpers ────────────────────────────── */\n\n.contactPane .collapsed {\n  visibility: collapse;\n}\n"],"sourceRoot":""}]);
// Exports
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ },

/***/ 314
(module) {



/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
*/
module.exports = function (cssWithMappingToString) {
  var list = [];

  // return the list of modules as css string
  list.toString = function toString() {
    return this.map(function (item) {
      var content = "";
      var needLayer = typeof item[5] !== "undefined";
      if (item[4]) {
        content += "@supports (".concat(item[4], ") {");
      }
      if (item[2]) {
        content += "@media ".concat(item[2], " {");
      }
      if (needLayer) {
        content += "@layer".concat(item[5].length > 0 ? " ".concat(item[5]) : "", " {");
      }
      content += cssWithMappingToString(item);
      if (needLayer) {
        content += "}";
      }
      if (item[2]) {
        content += "}";
      }
      if (item[4]) {
        content += "}";
      }
      return content;
    }).join("");
  };

  // import a list of modules into the list
  list.i = function i(modules, media, dedupe, supports, layer) {
    if (typeof modules === "string") {
      modules = [[null, modules, undefined]];
    }
    var alreadyImportedModules = {};
    if (dedupe) {
      for (var k = 0; k < this.length; k++) {
        var id = this[k][0];
        if (id != null) {
          alreadyImportedModules[id] = true;
        }
      }
    }
    for (var _k = 0; _k < modules.length; _k++) {
      var item = [].concat(modules[_k]);
      if (dedupe && alreadyImportedModules[item[0]]) {
        continue;
      }
      if (typeof layer !== "undefined") {
        if (typeof item[5] === "undefined") {
          item[5] = layer;
        } else {
          item[1] = "@layer".concat(item[5].length > 0 ? " ".concat(item[5]) : "", " {").concat(item[1], "}");
          item[5] = layer;
        }
      }
      if (media) {
        if (!item[2]) {
          item[2] = media;
        } else {
          item[1] = "@media ".concat(item[2], " {").concat(item[1], "}");
          item[2] = media;
        }
      }
      if (supports) {
        if (!item[4]) {
          item[4] = "".concat(supports);
        } else {
          item[1] = "@supports (".concat(item[4], ") {").concat(item[1], "}");
          item[4] = supports;
        }
      }
      list.push(item);
    }
  };
  return list;
};

/***/ },

/***/ 417
(module) {



module.exports = function (url, options) {
  if (!options) {
    options = {};
  }
  if (!url) {
    return url;
  }
  url = String(url.__esModule ? url.default : url);

  // If url is already wrapped in quotes, remove them
  if (/^['"].*['"]$/.test(url)) {
    url = url.slice(1, -1);
  }
  if (options.hash) {
    url += options.hash;
  }

  // Should url be wrapped?
  // See https://drafts.csswg.org/css-values-3/#urls
  if (/["'() \t\n]|(%20)/.test(url) || options.needQuotes) {
    return "\"".concat(url.replace(/"/g, '\\"').replace(/\n/g, "\\n"), "\"");
  }
  return url;
};

/***/ },

/***/ 354
(module) {



module.exports = function (item) {
  var content = item[1];
  var cssMapping = item[3];
  if (!cssMapping) {
    return content;
  }
  if (typeof btoa === "function") {
    var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(cssMapping))));
    var data = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(base64);
    var sourceMapping = "/*# ".concat(data, " */");
    return [content].concat([sourceMapping]).join("\n");
  }
  return [content].join("\n");
};

/***/ },

/***/ 72
(module) {



var stylesInDOM = [];
function getIndexByIdentifier(identifier) {
  var result = -1;
  for (var i = 0; i < stylesInDOM.length; i++) {
    if (stylesInDOM[i].identifier === identifier) {
      result = i;
      break;
    }
  }
  return result;
}
function modulesToDom(list, options) {
  var idCountMap = {};
  var identifiers = [];
  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    var id = options.base ? item[0] + options.base : item[0];
    var count = idCountMap[id] || 0;
    var identifier = "".concat(id, " ").concat(count);
    idCountMap[id] = count + 1;
    var indexByIdentifier = getIndexByIdentifier(identifier);
    var obj = {
      css: item[1],
      media: item[2],
      sourceMap: item[3],
      supports: item[4],
      layer: item[5]
    };
    if (indexByIdentifier !== -1) {
      stylesInDOM[indexByIdentifier].references++;
      stylesInDOM[indexByIdentifier].updater(obj);
    } else {
      var updater = addElementStyle(obj, options);
      options.byIndex = i;
      stylesInDOM.splice(i, 0, {
        identifier: identifier,
        updater: updater,
        references: 1
      });
    }
    identifiers.push(identifier);
  }
  return identifiers;
}
function addElementStyle(obj, options) {
  var api = options.domAPI(options);
  api.update(obj);
  var updater = function updater(newObj) {
    if (newObj) {
      if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap && newObj.supports === obj.supports && newObj.layer === obj.layer) {
        return;
      }
      api.update(obj = newObj);
    } else {
      api.remove();
    }
  };
  return updater;
}
module.exports = function (list, options) {
  options = options || {};
  list = list || [];
  var lastIdentifiers = modulesToDom(list, options);
  return function update(newList) {
    newList = newList || [];
    for (var i = 0; i < lastIdentifiers.length; i++) {
      var identifier = lastIdentifiers[i];
      var index = getIndexByIdentifier(identifier);
      stylesInDOM[index].references--;
    }
    var newLastIdentifiers = modulesToDom(newList, options);
    for (var _i = 0; _i < lastIdentifiers.length; _i++) {
      var _identifier = lastIdentifiers[_i];
      var _index = getIndexByIdentifier(_identifier);
      if (stylesInDOM[_index].references === 0) {
        stylesInDOM[_index].updater();
        stylesInDOM.splice(_index, 1);
      }
    }
    lastIdentifiers = newLastIdentifiers;
  };
};

/***/ },

/***/ 659
(module) {



var memo = {};

/* istanbul ignore next  */
function getTarget(target) {
  if (typeof memo[target] === "undefined") {
    var styleTarget = document.querySelector(target);

    // Special case to return head of iframe instead of iframe itself
    if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
      try {
        // This will throw an exception if access to iframe is blocked
        // due to cross-origin restrictions
        styleTarget = styleTarget.contentDocument.head;
      } catch (e) {
        // istanbul ignore next
        styleTarget = null;
      }
    }
    memo[target] = styleTarget;
  }
  return memo[target];
}

/* istanbul ignore next  */
function insertBySelector(insert, style) {
  var target = getTarget(insert);
  if (!target) {
    throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
  }
  target.appendChild(style);
}
module.exports = insertBySelector;

/***/ },

/***/ 540
(module) {



/* istanbul ignore next  */
function insertStyleElement(options) {
  var element = document.createElement("style");
  options.setAttributes(element, options.attributes);
  options.insert(element, options.options);
  return element;
}
module.exports = insertStyleElement;

/***/ },

/***/ 56
(module, __unused_webpack_exports, __webpack_require__) {



/* istanbul ignore next  */
function setAttributesWithoutAttributes(styleElement) {
  var nonce =  true ? __webpack_require__.nc : 0;
  if (nonce) {
    styleElement.setAttribute("nonce", nonce);
  }
}
module.exports = setAttributesWithoutAttributes;

/***/ },

/***/ 825
(module) {



/* istanbul ignore next  */
function apply(styleElement, options, obj) {
  var css = "";
  if (obj.supports) {
    css += "@supports (".concat(obj.supports, ") {");
  }
  if (obj.media) {
    css += "@media ".concat(obj.media, " {");
  }
  var needLayer = typeof obj.layer !== "undefined";
  if (needLayer) {
    css += "@layer".concat(obj.layer.length > 0 ? " ".concat(obj.layer) : "", " {");
  }
  css += obj.css;
  if (needLayer) {
    css += "}";
  }
  if (obj.media) {
    css += "}";
  }
  if (obj.supports) {
    css += "}";
  }
  var sourceMap = obj.sourceMap;
  if (sourceMap && typeof btoa !== "undefined") {
    css += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))), " */");
  }

  // For old IE
  /* istanbul ignore if  */
  options.styleTagTransform(css, styleElement, options.options);
}
function removeStyleElement(styleElement) {
  // istanbul ignore if
  if (styleElement.parentNode === null) {
    return false;
  }
  styleElement.parentNode.removeChild(styleElement);
}

/* istanbul ignore next  */
function domAPI(options) {
  if (typeof document === "undefined") {
    return {
      update: function update() {},
      remove: function remove() {}
    };
  }
  var styleElement = options.insertStyleElement(options);
  return {
    update: function update(obj) {
      apply(styleElement, options, obj);
    },
    remove: function remove() {
      removeStyleElement(styleElement);
    }
  };
}
module.exports = domAPI;

/***/ },

/***/ 113
(module) {



/* istanbul ignore next  */
function styleTagTransform(css, styleElement) {
  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css;
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild);
    }
    styleElement.appendChild(document.createTextNode(css));
  }
}
module.exports = styleTagTransform;

/***/ },

/***/ 102
(module) {

module.exports = "data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27%23999%27 viewBox=%270 0 24 24%27 width=%2720%27 height=%2720%27%3E%3Cpath d=%27M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99c.41.41 1.09.41 1.5 0s.41-1.09 0-1.5l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z%27/%3E%3C/svg%3E";

/***/ },

/***/ 53
(module) {

module.exports = __WEBPACK_EXTERNAL_MODULE__53__;

/***/ },

/***/ 941
(module) {

module.exports = __WEBPACK_EXTERNAL_MODULE__941__;

/***/ },

/***/ 104
(module) {

module.exports = __WEBPACK_EXTERNAL_MODULE__104__;

/***/ }

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		__webpack_require__.b = (typeof document !== 'undefined' && document.baseURI) || self.location.href;
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			792: 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		// no on chunks loaded
/******/ 		
/******/ 		// no jsonp function
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/nonce */
/******/ 	(() => {
/******/ 		__webpack_require__.nc = undefined;
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ src_contactsPane)
});

// UNUSED EXPORTS: addPersonToGroup, addWebIDToContacts, getPersonas, groupMembers, removeWebIDFromContacts, saveNewContact, saveNewGroup

// EXTERNAL MODULE: external {"commonjs":"solid-logic","commonjs2":"solid-logic","amd":"solid-logic","root":"SolidLogic"}
var external_commonjs_solid_logic_commonjs2_solid_logic_amd_solid_logic_root_SolidLogic_ = __webpack_require__(941);
// EXTERNAL MODULE: external {"commonjs":"solid-ui","commonjs2":"solid-ui","amd":"solid-ui","root":"UI"}
var external_commonjs_solid_ui_commonjs2_solid_ui_amd_solid_ui_root_UI_ = __webpack_require__(104);
// EXTERNAL MODULE: external {"commonjs":"rdflib","commonjs2":"rdflib","amd":"rdflib","root":"$rdf"}
var external_commonjs_rdflib_commonjs2_rdflib_amd_rdflib_root_$rdf_ = __webpack_require__(53);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js
var injectStylesIntoStyleTag = __webpack_require__(72);
var injectStylesIntoStyleTag_default = /*#__PURE__*/__webpack_require__.n(injectStylesIntoStyleTag);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/styleDomAPI.js
var styleDomAPI = __webpack_require__(825);
var styleDomAPI_default = /*#__PURE__*/__webpack_require__.n(styleDomAPI);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/insertBySelector.js
var insertBySelector = __webpack_require__(659);
var insertBySelector_default = /*#__PURE__*/__webpack_require__.n(insertBySelector);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js
var setAttributesWithoutAttributes = __webpack_require__(56);
var setAttributesWithoutAttributes_default = /*#__PURE__*/__webpack_require__.n(setAttributesWithoutAttributes);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/insertStyleElement.js
var insertStyleElement = __webpack_require__(540);
var insertStyleElement_default = /*#__PURE__*/__webpack_require__.n(insertStyleElement);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/styleTagTransform.js
var styleTagTransform = __webpack_require__(113);
var styleTagTransform_default = /*#__PURE__*/__webpack_require__.n(styleTagTransform);
// EXTERNAL MODULE: ./node_modules/css-loader/dist/cjs.js!./src/styles/webidControl.css
var webidControl = __webpack_require__(886);
;// ./src/styles/webidControl.css

      
      
      
      
      
      
      
      
      

var options = {};

options.styleTagTransform = (styleTagTransform_default());
options.setAttributes = (setAttributesWithoutAttributes_default());
options.insert = insertBySelector_default().bind(null, "head");
options.domAPI = (styleDomAPI_default());
options.insertStyleElement = (insertStyleElement_default());

var update = injectStylesIntoStyleTag_default()(webidControl/* default */.A, options);




       /* harmony default export */ const styles_webidControl = (webidControl/* default */.A && webidControl/* default */.A.locals ? webidControl/* default */.A.locals : undefined);

;// ./src/debug.js
/* eslint-disable no-console */

function log (...args) {
  console.log(...args)
}

function warn (...args) {
  console.warn(...args)
}

function error (...args) {
  console.error(...args)
}

function trace (...args) {
  console.trace(...args)
}

;// ./src/webidControl.js
// Render a control to record the webids we have for this agent








const ns = external_commonjs_solid_ui_commonjs2_solid_ui_amd_solid_ui_root_UI_.ns
const widgets = external_commonjs_solid_ui_commonjs2_solid_ui_amd_solid_ui_root_UI_.widgets
const utils = external_commonjs_solid_ui_commonjs2_solid_ui_amd_solid_ui_root_UI_.utils
const kb = external_commonjs_solid_logic_commonjs2_solid_logic_amd_solid_logic_root_SolidLogic_.store

const wikidataClasses = widgets.publicData.wikidataClasses // @@ move to solid-logic
const wikidataParameters = widgets.publicData.wikidataParameters // @@ move to solid-logic

const WEBID_NOUN = 'WebID'
const PUBLICID_NOUN = 'WikiData link'
const DOWN_ARROW = external_commonjs_solid_ui_commonjs2_solid_ui_amd_solid_ui_root_UI_.icons.iconBase + 'noun_1369241.svg'
const UP_ARROW = external_commonjs_solid_ui_commonjs2_solid_ui_amd_solid_ui_root_UI_.icons.iconBase + 'noun_1369237.svg'

/// ///////////////////////// Logic

async function addWebIDToContacts (person, webid, urlType, kb) {
  /*
  if (!webid.startsWith('https:')) { /// @@ well we will have other protcols like DID
    if (webid.startsWith('http://') {
      webid = 'https:' + webid.slice(5) // @@ No, data won't match in store. Add the 's' on fetch()
    } else {
      throw new Error('Does not look like a webid, must start with https: ' + webid)
    }
  }
  */

  // check this is a url
  try {
    // eslint-disable-next-line no-unused-vars
    const _url = new URL(webid)
  } catch (error) {
    throw new Error(`${WEBID_NOUN}: ${webid} is not a valid url.`)
  }

  // create a person's webID
  log(`Adding to ${person} a ${WEBID_NOUN}: ${webid}.`)
  const vcardURLThing = kb.bnode()
  const insertables = [
    external_commonjs_rdflib_commonjs2_rdflib_amd_rdflib_root_$rdf_.st(person, ns.vcard('url'), vcardURLThing, person.doc()),
    external_commonjs_rdflib_commonjs2_rdflib_amd_rdflib_root_$rdf_.st(vcardURLThing, ns.rdf('type'), urlType, person.doc()),
    external_commonjs_rdflib_commonjs2_rdflib_amd_rdflib_root_$rdf_.st(vcardURLThing, ns.vcard('value'), webid, person.doc())
  ]
  // insert WebID in groups
  // replace person with WebID in vcard:hasMember (WebID may already exist)
  // insert owl:sameAs
  const groups = kb.each(null, ns.vcard('hasMember'), person)
  let deletables = []
  groups.forEach(group => {
    deletables = deletables.concat(kb.statementsMatching(group, ns.vcard('hasMember'), person, group.doc()))
    insertables.push(external_commonjs_rdflib_commonjs2_rdflib_amd_rdflib_root_$rdf_.st(group, ns.vcard('hasMember'), kb.sym(webid), group.doc())) // May exist; do we need to check?
    insertables.push(external_commonjs_rdflib_commonjs2_rdflib_amd_rdflib_root_$rdf_.st(kb.sym(webid), ns.owl('sameAs'), person, group.doc()))
  })
  try {
    await updateMany(deletables, insertables)
  } catch (err) { throw new Error(`Could not create webId ${WEBID_NOUN}: ${webid}.`) }
}

async function removeWebIDFromContacts (person, webid, urlType, kb) {
  log(`Removing from ${person} their ${WEBID_NOUN}: ${webid}.`)

  // remove webID from card
  const existing = kb.each(person, ns.vcard('url'), null, person.doc())
    .filter(urlObject => kb.holds(urlObject, ns.rdf('type'), urlType, person.doc()))
    .filter(urlObject => kb.holds(urlObject, ns.vcard('value'), webid, person.doc()))
  if (!existing.length) {
    throw new Error(`Person ${person} does not have ${WEBID_NOUN} ${webid}.`)
  }
  const vcardURLThing = existing[0]
  const deletables = [
    external_commonjs_rdflib_commonjs2_rdflib_amd_rdflib_root_$rdf_.st(person, ns.vcard('url'), vcardURLThing, person.doc()),
    external_commonjs_rdflib_commonjs2_rdflib_amd_rdflib_root_$rdf_.st(vcardURLThing, ns.rdf('type'), urlType, person.doc()),
    external_commonjs_rdflib_commonjs2_rdflib_amd_rdflib_root_$rdf_.st(vcardURLThing, ns.vcard('value'), webid, person.doc())
  ]
  await kb.updater.update(deletables, [])

  // remove webIDs from groups
  const groups = kb.each(null, ns.vcard('hasMember'), kb.sym(webid))
  let removeFromGroups = []
  const insertInGroups = []
  groups.forEach(async group => {
    removeFromGroups = removeFromGroups.concat(kb.statementsMatching(kb.sym(webid), ns.owl('sameAs'), person, group.doc()))
    insertInGroups.push(external_commonjs_rdflib_commonjs2_rdflib_amd_rdflib_root_$rdf_.st(group, ns.vcard('hasMember'), person, group.doc()))
    if (kb.statementsMatching(kb.sym(webid), ns.owl('sameAs'), null, group.doc()).length < 2) {
      removeFromGroups = removeFromGroups.concat(kb.statementsMatching(group, ns.vcard('hasMember'), kb.sym(webid), group.doc()))
    }
  })
  await updateMany(removeFromGroups, insertInGroups)
}

// Trace things the same as this - other IDs for same thing
// returns as array of node
function getSameAs (kb, thing, doc) { // Should this recurse?
  const found = new Set()
  const agenda = new Set([thing.uri])

  while (agenda.size) {
    const uri = Array.from(agenda)[0] // clumsy
    agenda.delete(uri)
    if (found.has(uri)) continue
    found.add(uri)
    const node = kb.sym(uri)
    kb.each(node, ns.owl('sameAs'), null, doc)
      .concat(kb.each(null, ns.owl('sameAs'), node, doc))
      .forEach(next => {
        log('        OWL sameAs found ' + next)
        agenda.add(next.uri)
      })
    kb.each(node, ns.schema('sameAs'), null, doc)
      .concat(kb.each(null, ns.schema('sameAs'), node, doc))
      .forEach(next => {
        log('        Schema sameAs found ' + next)
        agenda.add(next.uri)
      })
  }
  found.delete(thing.uri) // don't want the one we knew about
  return Array.from(found).map(uri => kb.sym(uri)) // return as array of nodes
}

// find person webIDs
function getPersonas (kb, person) {
  const lits = vcardWebIDs(kb, person).concat(getSameAs(kb, person, person.doc()))
  const strings = new Set(lits.map(lit => lit.value)) // remove dups
  const personas = [...strings].map(uri => kb.sym(uri)) // The UI tables do better with Named Nodes than Literals
  personas.sort() // for repeatability
  personas.filter(x => !x.sameTerm(person))
  return personas
}

function vcardWebIDs (kb, person, urlType) {
  return kb.each(person, ns.vcard('url'), null, person.doc())
    .filter(urlObject => kb.holds(urlObject, ns.rdf('type'), urlType, person.doc()))
    .map(urlObject => kb.any(urlObject, ns.vcard('value'), null, person.doc()))
    .filter(x => !!x) // remove nulls
}

function isOrganization (agent) {
  const doc = agent.doc()
  return kb.holds(agent, ns.rdf('type'), ns.vcard('Organization'), doc) ||
    kb.holds(agent, ns.rdf('type'), ns.schema('Organization'), doc)
}
/// ////////////////////////////////////////////////////////////// UI

// Utility function to render another different pane

function renderNamedPane (dom, subject, paneName, dataBrowserContext) {
  const p = dataBrowserContext.session.paneRegistry.byName(paneName)
  const d = p.render(subject, dataBrowserContext) // @@@ change some bits of context!
  d.classList.add('namedPane')
  return d
}

async function renderWebIdControl (person, dataBrowserContext) {
  const options = {
    longPrompt: `Link to a ${WEBID_NOUN}?`,
    idNoun: WEBID_NOUN,
    urlType: ns.vcard('WebID')
  }
  return renderIdControl(person, dataBrowserContext, options)
}

async function renderPublicIdControl (person, dataBrowserContext) {
  let orgClass = kb.sym('http://www.wikidata.org/wiki/Q43229')
  for (const classId in wikidataClasses) {
    if (kb.holds(person, ns.rdf('type'), ns.schema(classId), person.doc())) {
      orgClass = kb.sym(wikidataClasses[classId])
      log(`  renderPublicIdControl bingo: ${classId} -> ${orgClass}`)
    }
  }
  const options = {
    longPrompt: `Add a ${PUBLICID_NOUN}?`,
    idNoun: PUBLICID_NOUN,
    urlType: ns.vcard('PublicId'),
    dbLookup: true,
    class: orgClass, // Organization
    queryParams: wikidataParameters
  }
  return renderIdControl(person, dataBrowserContext, options)
}

// The main control rendered by this module
async function renderIdControl (person, dataBrowserContext, options) {
  // IDs which are as WebId in VCARD data
  // like  :me vcard:hasURL [ a vcard:WebId; vcard:value <https://...foo> ]
  //
  // Display the data about x specifically stored at x.doc()
  // in a fold-away thing
  //
  function renderPersona (dom, persona, kb) {
    function profileOpenHandler (_event) {
      profileIsVisible = !profileIsVisible
      main.classList.toggle('collapsed', !profileIsVisible)
      openButton.children[0].src = profileIsVisible ? UP_ARROW : DOWN_ARROW // @@ fragile
      openButton.setAttribute('aria-expanded', profileIsVisible ? 'true' : 'false')
      openButton.setAttribute('aria-label', profileIsVisible ? 'Collapse profile' : 'Expand profile')
    }
    function renderNewRow (webidObject) {
      const webid = new external_commonjs_rdflib_commonjs2_rdflib_amd_rdflib_root_$rdf_.Literal(webidObject.uri)
      async function deleteFunction () {
        try {
          await removeWebIDFromContacts(person, webid, options.urlType, kb)
        } catch (err) {
          error(`Error removing Id ${webid} from ${person}: ${err}`)
          div.appendChild(widgets.errorMessageBlock(dom, 'Error removing WebId from profile. If it persists, contact admin.'))
        }
        await refreshWebIDTable()
      }
      const isWebId = options.urlType.sameTerm(ns.vcard('WebID'))
      const delFunParam = options.editable ? deleteFunction : null
      const opts = { deleteFunction: delFunParam, draggable: true }
      if (isWebId) {
        opts.title = webidObject.uri.split('/')[2]
        opts.image = widgets.faviconOrDefault(dom, webidObject.site()) // just for domain
      }
      const row = widgets.personTR(dom, external_commonjs_solid_ui_commonjs2_solid_ui_amd_solid_ui_root_UI_.ns.foaf('knows'), webidObject, opts)
      if (isWebId) {
        row.children[1].textConent = opts.title // @@ will be overwritten
        row.classList.add('personaRow--webid')
      }
      row.classList.add('personaRow')
      return row
    }

    const div = dom.createElement('div')
    div.classList.add('fullWidth')
    const personaTable = div.appendChild(dom.createElement('table'))
    personaTable.classList.add('fullWidth')
    const nav = personaTable.appendChild(renderNewRow(persona))
    nav.classList.add('fullWidth')
    const mainRow = personaTable.appendChild(dom.createElement('tr'))
    const mainCell = mainRow.appendChild(dom.createElement('td'))
    mainCell.setAttribute('colspan', 3)
    let main

    let profileIsVisible = true

    const rhs = nav.children[2]
    const openButton = rhs.appendChild(widgets.button(dom, DOWN_ARROW, 'View', profileOpenHandler))
    openButton.classList.add('personaOpenButton')
    openButton.setAttribute('aria-expanded', 'true')
    openButton.setAttribute('aria-label', 'Collapse profile')
    const paneName = isOrganization(person) || isOrganization(persona) ? 'profile' : 'profile' // was default for org

    widgets.publicData.loadPublicDataThing(kb, person, persona).then(_resp => {
    // loadPublicDataThing(kb, person, persona).then(_resp => {
      try {
        main = renderNamedPane(dom, persona, paneName, dataBrowserContext)
        main.classList.add('fullWidth')
        // main.style.visibility = 'collapse'
        mainCell.appendChild(main)
      } catch (err) {
        error('Error displaying persona ' + persona + '. Stack: ' + err)
        main = widgets.errorMessageBlock(dom, 'Error displaying profile. If it persists, contact admin.')
        mainCell.appendChild(main)
      }
    }, err => {
      error('Error loading persona ' + persona + '. Stack: ' + err)
      main = widgets.errorMessageBlock(dom, 'Error loading profile. If it persists, contact admin.')
      mainCell.appendChild(main)
    })
    return div
  } // renderPersona

  async function refreshWebIDTable () {
    const personas = getPersonas(kb, person)
    utils.syncTableToArrayReOrdered(profileArea, personas, persona => renderPersona(dom, persona, kb))
  }
  async function addOneIdAndRefresh (person, webid) {
    try {
      await addWebIDToContacts(person, webid, options.urlType, kb)
    } catch (err) {
      error('Error adding webId ' + webid + ' to ' + person + '. Stack: ' + err)
      div.appendChild(widgets.errorMessageBlock(dom, 'This is not a valid WebID.'))
    }
    await refreshWebIDTable()
  }

  const { dom } = dataBrowserContext
  options = options || {}
  options.editable = kb.updater.editable(person.doc().uri, kb)
  const div = dom.createElement('div')
  div.classList.add('webidControl', 'webidControl--mobile')

  if (getPersonas(kb, person).length === 0 && !options.editable) {
    div.classList.add('hidden')
    return div // No point listing an empty list you can't change
  }

  const h3 = div.appendChild(dom.createElement('h3'))
  h3.textContent = 'Link to a ' + options.idNoun
  h3.classList.add('contactPanedHeading')

  const table = div.appendChild(dom.createElement('table'))
  table.classList.add('fullWidth')

  if (options.editable) { // test
    const barOptions = {
      editable: options.editable,
      manualURIEntry: true, // introduced in solid-ui 2.4.2
      idNoun: options.idNoun,
      dbLookup: options.dbLookup
    }
    const acOptions = {
      queryParams: options.queryParams || wikidataParameters,
      targetClass: options.class
    }
    try {
      div.appendChild(await widgets.renderAutocompleteControl(dom, person, barOptions, acOptions, addOneIdAndRefresh))
    } catch (err) {
      error('Render Autocomplete Control failed. Stack:', err)
      div.appendChild(widgets.errorMessageBlock(dom, 'Error rendering autocomplete. If it persists, contact admin.'))
    }
  }
  const profileArea = div.appendChild(dom.createElement('div'))
  await refreshWebIDTable()

  return div
}

// EXTERNAL MODULE: ./node_modules/css-loader/dist/cjs.js!./src/styles/localUtils.css
var localUtils = __webpack_require__(546);
;// ./src/styles/localUtils.css

      
      
      
      
      
      
      
      
      

var localUtils_options = {};

localUtils_options.styleTagTransform = (styleTagTransform_default());
localUtils_options.setAttributes = (setAttributesWithoutAttributes_default());
localUtils_options.insert = insertBySelector_default().bind(null, "head");
localUtils_options.domAPI = (styleDomAPI_default());
localUtils_options.insertStyleElement = (insertStyleElement_default());

var localUtils_update = injectStylesIntoStyleTag_default()(localUtils/* default */.A, localUtils_options);




       /* harmony default export */ const styles_localUtils = (localUtils/* default */.A && localUtils/* default */.A.locals ? localUtils/* default */.A.locals : undefined);

;// ./src/localUtils.js





const localUtils_kb = external_commonjs_solid_logic_commonjs2_solid_logic_amd_solid_logic_root_SolidLogic_.store
const localUtils_ns = external_commonjs_solid_ui_commonjs2_solid_ui_amd_solid_ui_root_UI_.ns
let dom

function setDom (d) {
  dom = d
}

// ---------- Accessible modal dialog helpers ----------
// This code was generated by Generative AI (Raptor mini in GitHub Copilot) based on the following prompt:
// Regarding accessibility, how should I replace alert()/confirm() with accessible modal dialogs?
// Let us implement the modals in the localUtils.

// alert()/confirm().  The implementation ensures focus trapping, keyboard
// support, and hides the rest of the page from screen readers while the
// dialog is visible.

let modalOverlay = null
let previousFocus = null

function ensureModalOverlay () {
  // if we previously created an overlay but it was removed from the document
  // (tests clear body), rebuild it.  Checking presence ensures our reference
  // doesn't point at a detached element.
  if (modalOverlay && document.body.contains(modalOverlay)) return modalOverlay
  // otherwise drop stale reference and create a new element
  modalOverlay = null
  // overlay container
  modalOverlay = dom.createElement('div')
  modalOverlay.id = 'contacts-modal'
  modalOverlay.className = 'focus-trap hidden'
  modalOverlay.setAttribute('role', 'presentation')

  modalOverlay.innerHTML = `
    <div class="modal" role="dialog" aria-modal="true" aria-labelledby="modal-title" aria-describedby="modal-desc">
      <h2 id="modal-title"></h2>
      <div id="modal-desc"></div>
      <div id="modal-buttons"></div>
    </div>
  `

  document.body.appendChild(modalOverlay)

  // keyboard handling (esc/tab)
  modalOverlay.addEventListener('keydown', e => {
    if (e.key === 'Escape') {
      e.stopPropagation()
      // simulate cancel if available
      const cancelBtn = modalOverlay.querySelector('button[data-cancel]')
      if (cancelBtn) cancelBtn.click()
      else closeModal(false)
    } else if (e.key === 'Tab') {
      // simple focus trap: cycle through focusable elements inside overlay
      const focusable = Array.from(modalOverlay.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')).filter(el => !el.hasAttribute('disabled'))
      if (focusable.length === 0) return
      const idx = focusable.indexOf(document.activeElement)
      if (e.shiftKey) {
        if (idx === 0) {
          focusable[focusable.length - 1].focus()
          e.preventDefault()
        }
      } else {
        if (idx === focusable.length - 1) {
          focusable[0].focus()
          e.preventDefault()
        }
      }
    }
  })

  return modalOverlay
}

function hideSiblings (hide) {
  const siblings = Array.from(document.body.children).filter(c => c !== modalOverlay)
  siblings.forEach(el => {
    if (hide) el.setAttribute('aria-hidden', 'true')
    else el.removeAttribute('aria-hidden')
  })
}

function openModal ({ title, message, buttons }) {
  const overlay = ensureModalOverlay()
  previousFocus = document.activeElement
  hideSiblings(true)
  overlay.classList.remove('hidden')

  overlay.querySelector('#modal-title').textContent = title || ''
  const descEl = overlay.querySelector('#modal-desc')
  if (typeof message === 'string') {
    descEl.textContent = message
  } else {
    // allow passing nodes
    descEl.innerHTML = ''
    descEl.appendChild(message)
  }

  const btnContainer = overlay.querySelector('#modal-buttons')
  btnContainer.innerHTML = ''

  return new Promise(resolve => {
    buttons.forEach(btn => {
      const b = dom.createElement('button')
      b.setAttribute('type', 'button')
      b.textContent = btn.label
      if (btn.primary) b.classList.add('btn-primary')
      if (btn.cancel) b.setAttribute('data-cancel', 'true')
      b.addEventListener('click', () => {
        closeModal(btn.value)
        resolve(btn.value)
      })
      btnContainer.appendChild(b)
    })
    // focus first button
    const first = btnContainer.querySelector('button')
    if (first) first.focus()
  })
}

function closeModal (result) {
  if (modalOverlay) {
    modalOverlay.classList.add('hidden')
    hideSiblings(false)
    if (previousFocus && previousFocus.focus) previousFocus.focus()
  }
}

/**
 * Show an alert-style modal that has a single OK button.
 * @param {string} message
 * @param {string} [title]
 * @returns {Promise<true>}
 */
function alertDialog (message, title = 'Information') {
  return openModal({
    title,
    message,
    buttons: [{ label: 'OK', value: true, primary: true }]
  })
}

/**
 * Show a confirm-style modal returning a boolean.
 * @param {string} message
 * @param {string} [title]
 * @returns {Promise<boolean>}
 */
function confirmDialog (message, title = 'Confirm') {
  return openModal({
    title,
    message,
    buttons: [
      { label: 'Cancel', value: false, cancel: true },
      { label: 'OK', value: true, primary: true }
    ]
  })
}

// ---------- end of modal helpers ----------

/**
 * Normalize group URIs to ensure consistent representation.
 * Groups should be referenced with fragment #this, e.g., ...Group/AnotherGroup.ttl#this
 * If a group URI ends with .ttl (without #this), add #this
 * @param {string} uri - The group URI to normalize
 * @returns {string} The normalized group URI
 */
function normalizeGroupUri (uri) {
  if (uri && uri.endsWith('.ttl')) {
    return uri + '#this'
  }
  return uri
}

function complain (div, d, message) {
  div.appendChild(external_commonjs_solid_ui_commonjs2_solid_ui_amd_solid_ui_root_UI_.widgets.errorMessageBlock(d, message, 'pink'))
}

function localUtils_getSameAs (kb, item, doc) {
  return kb.each(item, localUtils_ns.owl('sameAs'), null, doc).concat(
    kb.each(null, localUtils_ns.owl('sameAs'), item, doc))
}
//  For deleting an addressbook sub-folder eg person - use with care!
// @@ move to solid-logic
function deleteRecursive (kb, folder) {
  return new Promise(function (resolve, reject) {
    kb.fetcher.load(folder).then(function () {
      const promises = kb.each(folder, localUtils_ns.ldp('contains')).map(file => {
        if (kb.holds(file, localUtils_ns.rdf('type'), localUtils_ns.ldp('BasicContainer'))) {
          return deleteRecursive(kb, file)
        } else {
          log('Recursive delete - we delete file ' + file.uri)
          return kb.fetcher.webOperation('DELETE', file.uri)
        }
      })
      log('Recursive delete - we delete folder ' + folder.uri)
      promises.push(kb.fetcher.webOperation('DELETE', folder.uri))
      Promise.all(promises).then(_res => {
        resolve()
      }).catch(reject)
    }).catch(reject)
  })
}

// In a LDP work, deletes the whole document describing a thing
// plus patch out ALL mentiosn of it!    Use with care!
// beware of other data picked up from other places being smushed
// together and then deleted.
async function deleteThingAndDoc (x) {
  const name = nameFor(x)
  if (!(await confirmDialog('Really DELETE ' + name + '?'))) {
    throw new Error('User cancelled contact deletion')
  }
  log('deleteThingAndDoc - to be deleted ' + x)
  const ds = localUtils_kb.statementsMatching(x).concat(localUtils_kb.statementsMatching(undefined, undefined, x))
  try {
    await localUtils_kb.updater.updateMany(ds)
    await localUtils_kb.fetcher.delete(x.doc())
    log('deleteThingAndDoc - deleted')
  } catch (err) {
    error('Error deleting ' + x + '. Stack: ' + err)
    throw new Error('An error occured while deleting.')
  }
}

function compareForSort (self, other) {
  let s = nameFor(self)
  let o = nameFor(other)
  if (s && o) {
    s = s.toLowerCase()
    o = o.toLowerCase()
    if (s > o) return 1
    if (s < o) return -1
  }
  if (self.uri > other.uri) return 1
  if (self.uri < other.uri) return -1
  return 0
}

// organization-name is a hack for Mac records with no FN which is mandatory.
function nameFor (x) {
  const name =
    localUtils_kb.any(x, localUtils_ns.vcard('fn')) ||
    localUtils_kb.any(x, localUtils_ns.foaf('name')) ||
    localUtils_kb.any(x, localUtils_ns.vcard('organization-name'))
  return name ? name.value : '???'
}

/**
 * Prevent keyboard tabbing into labels/label-like links created by rdflib/solid-ui forms.
 * @param {HTMLElement} root
 */
function skipLabelsFromTabbing (root) {
  // Many Solid-UI forms render field labels as focusable links (hrefs).
  // Make sure keyboard tabbing skips these label links entirely.
  const selectors = [
    'label',
    '.formFieldName a',
    '.classifierBox-label a',
    '.choiceBox-label a',
    '.label a',
    // Skip focusable label-like links created by Solid-UI forms, including the vcard note link
    'a[href="http://www.w3.org/2006/vcard/ns#note"]',
    'a[href$="#note"]',
  ].join(', ')

  // Some environments have NodeLists without forEach (e.g., older Safari).
  const nodes = root?.querySelectorAll?.(selectors)
  if (!nodes) return

  Array.from(nodes).forEach(el => {
    // Some browsers may return null for tabIndex, and some elements may not
    // expose tabIndex at all (e.g., SVG elements), so guard before setting.
    if (typeof el.tabIndex === 'number' && el.tabIndex !== -1) {
      el.tabIndex = -1
    }
    // Ensure those label links are not announced as focusable elements
    if (el.getAttribute('aria-hidden') !== 'true') {
      el.setAttribute('aria-hidden', 'true')
    }
  })
}

function isAWebID (subject) {
  const t = localUtils_kb.findTypeURIs(subject.doc())
  return !!t[localUtils_ns.foaf('PersonalProfileDocument').uri]
}

// Make the layout stack vertically when the containing pane gets narrow
function setupResponsiveStacking (paneDiv, breakpoint = 900) {
  function updateResponsiveState () {
    const width = paneDiv.getBoundingClientRect().width
    const paneNarrow = width > 0 ? width <= breakpoint : false
    const viewportNarrow = (typeof window !== 'undefined' && typeof window.matchMedia === 'function')
      ? window.matchMedia('(max-width: ' + breakpoint + 'px)').matches
      : false
    const isNarrow = width > 0 ? paneNarrow : viewportNarrow

    if (width > 0) {
      paneDiv.dataset.paneWidth = Math.round(width).toString()
      paneDiv.dataset.paneNarrow = paneNarrow ? 'true' : 'false'
    } else {
      // If not inserted yet, apply viewport mode until placed.
      paneDiv.dataset.paneWidth = '0'
      paneDiv.dataset.paneNarrow = viewportNarrow ? 'true' : 'false'
    }

    paneDiv.classList.toggle('contactPane--narrow', isNarrow)
    paneDiv.dataset.viewportNarrow = viewportNarrow ? 'true' : 'false'

    return isNarrow
  }

  // Debounce utility
  function debounce (fn, delay) {
    let timer = null
    return function (...args) {
      clearTimeout(timer)
      timer = setTimeout(() => fn.apply(this, args), delay)
    }
  }

  const debouncedUpdate = debounce(() => {
    updateResponsiveState()
  }, 100)

  const resizeObserverAvailable = typeof ResizeObserver !== 'undefined'
  if (resizeObserverAvailable) {
    const ro = new ResizeObserver(() => {
      debouncedUpdate()
    })
    ro.observe(paneDiv)
  }

  if (typeof window !== 'undefined' && typeof window.addEventListener === 'function') {
    window.addEventListener('resize', debouncedUpdate)
  }

  // Initial state
  function ensureInitialUpdate () {
    // Call both updaters for their side effects (setting dataset attributes).
    // Return values are intentionally discarded — ESLint-safe.
    updateResponsiveState()
    // If we are not in the document yet, re-run until connected
    if (!paneDiv.isConnected) {
      requestAnimationFrame(ensureInitialUpdate)
    }
  }

  ensureInitialUpdate()
}

;// ./src/contactLogic.js







const contactLogic_ns = external_commonjs_solid_ui_commonjs2_solid_ui_amd_solid_ui_root_UI_.ns
const contactLogic_utils = external_commonjs_solid_ui_commonjs2_solid_ui_amd_solid_ui_root_UI_.utils
const contactLogic_kb = external_commonjs_solid_logic_commonjs2_solid_logic_amd_solid_logic_root_SolidLogic_.store
const updater = contactLogic_kb.updater

/** Perform updates on more than one document   @@ Move to rdflib!
*/
async function updateMany (deletions, insertions = []) {
  const docs = deletions.concat(insertions).map(st => st.why)
  const uniqueDocs = []
  docs.forEach(doc => {
    if (!uniqueDocs.find(uniqueDoc => uniqueDoc.equals(doc))) uniqueDocs.push(doc)
  })
  const updates = uniqueDocs.map(doc =>
    contactLogic_kb.updater.update(deletions.filter(st => st.why.sameTerm(doc)),
      insertions.filter(st => st.why.sameTerm(doc))))
  return Promise.all(updates)
}

/** Add a new person to the web data
*
* adds them to the given groups as well.
* @returns {NamedNode} the person
*/
async function saveNewContact (book, name, selectedGroups, klass) {
  await contactLogic_kb.fetcher.load(book.doc())
  const nameEmailIndex = contactLogic_kb.any(book, contactLogic_ns.vcard('nameEmailIndex'))

  const uuid = contactLogic_utils.genUuid()
  const person = contactLogic_kb.sym(
    book.dir().uri + 'Person/' + uuid + '/index.ttl#this'
  )
  const doc = person.doc()

  // Set of statements to different files
  const agenda = [
    // Patch the main index to add the person
    external_commonjs_rdflib_commonjs2_rdflib_amd_rdflib_root_$rdf_.st(person, contactLogic_ns.vcard('inAddressBook'), book, nameEmailIndex), // The people index
    external_commonjs_rdflib_commonjs2_rdflib_amd_rdflib_root_$rdf_.st(person, contactLogic_ns.vcard('fn'), name, nameEmailIndex),
    // The new person file
    external_commonjs_rdflib_commonjs2_rdflib_amd_rdflib_root_$rdf_.st(person, contactLogic_ns.vcard('fn'), name, doc),
    external_commonjs_rdflib_commonjs2_rdflib_amd_rdflib_root_$rdf_.st(person, contactLogic_ns.rdf('type'), klass, doc),

    external_commonjs_rdflib_commonjs2_rdflib_amd_rdflib_root_$rdf_.st(doc, contactLogic_ns.dct('created'), new Date(), doc) // Note when created - useful for triaging later
    // Note this is propert of the file -- not when the person was created!
  ]

  // `selectedGroups` may be an array (older callers) or an object map
  // (contactsPane.js tracks it as `{ uri: true }`).  Normalize and make sure
  // at least one group is selected before proceeding – otherwise we return
  // `undefined` and the caller must handle it.
  const groups = Array.isArray(selectedGroups)
    ? selectedGroups
    : Object.keys(selectedGroups || {})

  if (groups.length > 0) {
    for (const gu of groups) {
      const g = contactLogic_kb.sym(gu)
      const gd = g.doc()
      agenda.push(
        external_commonjs_rdflib_commonjs2_rdflib_amd_rdflib_root_$rdf_.st(g, contactLogic_ns.vcard('hasMember'), person, gd),
        external_commonjs_rdflib_commonjs2_rdflib_amd_rdflib_root_$rdf_.st(person, contactLogic_ns.vcard('fn'), name, gd)
      )
    }
  } else {
    alertDialog('Must be a member of at least one group. Please select or create a group.')
    return // caller should check for undefined result
  }

  try {
    await updater.updateMany([], agenda)
  } catch (e) {
    error('Cannot add group membership for ' + person + '. Stack:' + e)
    throw new Error('Save new contact')
  }
  return person
}

function sanitizeToAlpha (name) { // https://mathiasbynens.be/notes/es6-unicode-regex
  const n2 = name.replace(/\W/gu, '_') // Anything which is not a unicode word characeter
  return n2.replace(/_+/g, '_') // https://www.regular-expressions.info/shorthand.html
}

/** Write new group to web
 * Creates an empty new group file and adds it to the index
 * @returns group
*/
async function saveNewGroup (book, name) {
  await contactLogic_kb.fetcher.load(book.doc())
  const gix = contactLogic_kb.any(book, contactLogic_ns.vcard('groupIndex'))

  const gname = sanitizeToAlpha(name)
  const group = contactLogic_kb.sym(book.dir().uri + 'Group/' + gname + '.ttl#this')
  const doc = group.doc()
  // debug.log(' New group will be: ' + group + '\n')
  try {
    await contactLogic_kb.fetcher.load(gix)
  } catch (err) {
    throw new Error('Error loading group index!' + gix.uri + ': ' + err)
  }
  if (contactLogic_kb.holds(book, contactLogic_ns.vcard('includesGroup'), group, gix)) {
    return group // Already exists
  }
  const insertTriples = [
    external_commonjs_rdflib_commonjs2_rdflib_amd_rdflib_root_$rdf_.st(book, contactLogic_ns.vcard('includesGroup'), group, gix),
    external_commonjs_rdflib_commonjs2_rdflib_amd_rdflib_root_$rdf_.st(group, contactLogic_ns.rdf('type'), contactLogic_ns.vcard('Group'), gix),
    external_commonjs_rdflib_commonjs2_rdflib_amd_rdflib_root_$rdf_.st(group, contactLogic_ns.vcard('fn'), name, gix)
  ]
  try {
    await updater.update([], insertTriples)
  } catch (e) {
    throw new Error('Could not update group index ' + e) // fail
  }

  const triples = [
    external_commonjs_rdflib_commonjs2_rdflib_amd_rdflib_root_$rdf_.st(book, contactLogic_ns.vcard('includesGroup'), group, doc), // Pointer back to book
    external_commonjs_rdflib_commonjs2_rdflib_amd_rdflib_root_$rdf_.st(group, contactLogic_ns.rdf('type'), contactLogic_ns.vcard('Group'), doc),
    external_commonjs_rdflib_commonjs2_rdflib_amd_rdflib_root_$rdf_.st(group, contactLogic_ns.vcard('fn'), name, doc)
  ]
  try {
    await updater.update([], triples)
  } catch (err) {
    throw new Error('Could not update group file: ' + err) // fail
  }
  return group
}

async function addPersonToGroup (thing, group) {
  const toBeFetched = [thing.doc(), group.doc()]
  try {
    await contactLogic_kb.fetcher.load(toBeFetched)
  } catch (e) {
    error('Error adding ' + thing + ' to group ' + group + '. Stack: ' + e)
    throw new Error('Error adding to group.')
  }

  const types = contactLogic_kb.findTypeURIs(thing)

  if (!(contactLogic_ns.vcard('Individual').uri in types ||
    contactLogic_ns.vcard('Organization').uri in types)) {
    warn('Thing ' + thing + ' is not an Individual or Organization, but has types: ' + Object.keys(types))
    alertDialog('You are trying to add something else than an individual or organization.')
    return
  }
  let pname = contactLogic_kb.any(thing, contactLogic_ns.vcard('fn'))
  const gname = contactLogic_kb.any(group, contactLogic_ns.vcard('fn'))
  if (!pname) {
    warn('Thing ' + thing + ' has no vcard:fn')
    alertDialog('What you are trying to add seems to have no full name.')
    return
  }
  const already = contactLogic_kb.holds(thing, contactLogic_ns.vcard('fn'), null, group.doc())
  if (already) {
    if (pname === '') pname = 'Contact'
    alertDialog(pname + ' already exists in group ' + gname + '.')
    return
  }
  const message = 'Add ' + pname + ' to group ' + gname + '?'
  if (!await confirmDialog(message)) return
  const ins = [
    external_commonjs_rdflib_commonjs2_rdflib_amd_rdflib_root_$rdf_.st(thing, contactLogic_ns.vcard('fn'), pname, group.doc())
  ]
  // find person webIDs and insert in vcard:hasMember
  const webIDs = getPersonas(contactLogic_kb, thing).map(webid => webid.value)
  if (webIDs.length) {
    webIDs.forEach(webid => {
      ins.push(external_commonjs_rdflib_commonjs2_rdflib_amd_rdflib_root_$rdf_.st(contactLogic_kb.sym(webid), contactLogic_ns.owl('sameAs'), thing, group.doc()))
      ins.push(external_commonjs_rdflib_commonjs2_rdflib_amd_rdflib_root_$rdf_.st(group, contactLogic_ns.vcard('hasMember'), contactLogic_kb.sym(webid), group.doc()))
    })
  } else {
    ins.push(external_commonjs_rdflib_commonjs2_rdflib_amd_rdflib_root_$rdf_.st(group, contactLogic_ns.vcard('hasMember'), thing, group.doc()))
  }
  try {
    await updater.update([], ins)
    // to allow refresh of card groupList
    contactLogic_kb.fetcher.unload(group.doc())
    await contactLogic_kb.fetcher.load(group.doc())
  } catch (e) {
    error('Error adding ' + thing + ' to group ' + group + '. Stack: ' + e)
    throw new Error('Error adding to group.')
  }
  return thing
}

/**
 * Find persons member of a group
 */

function groupMembers (kb, group) {
  const a = kb.each(group, contactLogic_ns.vcard('hasMember'), null, group.doc())
  let b = []
  a.forEach(item => {
    /* const contacts = kb.each(item, ns.owl('sameAs'), null, group.doc())
    if (contacts.length) {
      if (!kb.any(contacts[0], ns.vard('fn'))) b = b.concat(item) // this is the old data model
      else b = b.concat(contacts)
    } else { b = b.concat(item) }
    b = b.concat(item) */

    // to keep compatibility with old data model
    // check if item is a contact, else it is a WebID and parse 'sameAs' for contacts
    b = kb.any(item, contactLogic_ns.vcard('fn'), null, group.doc()) ? b.concat(item) : b.concat(kb.each(item, contactLogic_ns.owl('sameAs'), null, group.doc()))
  })
  const strings = new Set(b.map(contact => contact.uri)) // remove dups
  b = [...strings].map(uri => kb.sym(uri))
  return b
}

function isLocal (group, item) {
  const tree = group.dir().dir().dir()
  const local = item.uri && item.uri.startsWith(tree.uri)
  // debug.log(`   isLocal ${local} for ${item.uri} in group ${group} tree ${tree.uri}`)
  return local
}

async function getDataModelIssues (groups) {
  const del = []
  const ins = []
  groups.forEach(group => {
    const members = contactLogic_kb.each(group, contactLogic_ns.vcard('hasMember'), null, group.doc())
    members.forEach((member) => {
      const others = localUtils_getSameAs(contactLogic_kb, member, group.doc())
      if (others.length && isLocal(group, member)) { // Problem: local ID used instead of webID
        for (const other of others) {
          if (!isLocal(group, other)) { // Let's use this one as the immediate member for CSS ACLs'
            // console.warn(`getDataModelIssues:  Need to swap ${member} to ${other}`)
            del.push(external_commonjs_rdflib_commonjs2_rdflib_amd_rdflib_root_$rdf_.st(group, contactLogic_ns.vcard('hasMember'), member, group.doc()))
            ins.push(external_commonjs_rdflib_commonjs2_rdflib_amd_rdflib_root_$rdf_.st(group, contactLogic_ns.vcard('hasMember'), other, group.doc()))
            break
          }
          // debug.log('getDataModelIssues: ??? expected id not to be local ' + other)
        } // other
      } // if
    }) // member
  }) // next group
  return { del, ins }
} // getDataModelIssues

// Ends

;// ./src/mintNewAddressBook.js






const { setACLUserPublic } = external_commonjs_solid_logic_commonjs2_solid_logic_amd_solid_logic_root_SolidLogic_.solidLogicSingleton.acl
// const mime = require('mime-types')
// const toolsPane0 = require('./toolsPane')
// const toolsPane = toolsPane0.toolsPane

// const ns = UI.ns
// const utils = UI.utils

// Mint a new address book

function mintNewAddressBook (dataBrowserContext, context) {
  return new Promise(function (resolve, reject) {
    external_commonjs_solid_ui_commonjs2_solid_ui_amd_solid_ui_root_UI_.login.ensureLoadedProfile(context).then(
      context => {
        // 20180713
        log('Logged in as ' + context.me)
        const me = context.me

        const dom = context.dom
        const div = context.div
        const kb = dataBrowserContext.session.store
        const ns = external_commonjs_solid_ui_commonjs2_solid_ui_amd_solid_ui_root_UI_.ns
        const newBase = context.newBase || context.newInstance.dir().uri
        const instanceClass = context.instanceClass || ns.vcard('AddressBook')

        if (instanceClass.sameTerm(ns.vcard('Group'))) {
          // Make a group not an address book
          const g =
            context.newInstance || kb.sym(context.newBase + 'index.ttl#this')
          const doc = g.doc()
          kb.add(g, ns.rdf('type'), ns.vcard('Group'), doc)
          kb.add(
            g,
            ns.vcard('fn'),
            context.instanceName || 'untitled group',
            doc
          ) // @@ write doc back
          kb.fetcher
            .putBack(doc, { contentType: 'text/turtle' })
            .then(function (_xhr) {
              resolve(context)
            })
            .catch(function (err) {
              error('Failed to fetch new address book. Stack: ' + err)
              reject(
                new Error('Error creating document for new group ' + err)
              )
            })
          return
        }
        const appInstanceNoun = 'address book'

        let bookContents = `@prefix vcard: <http://www.w3.org/2006/vcard/ns#>.
  @prefix ab: <http://www.w3.org/ns/pim/ab#>.
  @prefix dc: <http://purl.org/dc/elements/1.1/>.
  @prefix xsd: <http://www.w3.org/2001/XMLSchema#>.

  <#this> a vcard:AddressBook;
      dc:title "New address Book";
      vcard:nameEmailIndex <people.ttl>;
      vcard:groupIndex <groups.ttl>.
`

        bookContents +=
          '<#this> <http://www.w3.org/ns/auth/acl#owner> <' +
          me.uri +
          '>.\n\n'

        const newAppInstance = kb.sym(newBase + 'index.ttl#this')

        const toBeWritten = [
          {
            to: 'index.ttl',
            content: bookContents,
            contentType: 'text/turtle'
          },
          { to: 'groups.ttl', content: '', contentType: 'text/turtle' },
          { to: 'people.ttl', content: '', contentType: 'text/turtle' },
          { to: '', existing: true, aclOptions: { defaultForNew: true } }
        ]

        // @@ Ask user abut ACLs?

        //
        //   @@ Add header to PUT     If-None-Match: *       to prevent overwrite
        //

        function claimSuccess (newAppInstance, appInstanceNoun) {
          // @@ delete or grey other stuff
          log(`New ${appInstanceNoun} created at ${newAppInstance}`)
          const p = div.appendChild(dom.createElement('p'))
          p.classList.add('claimSuccess')
          p.innerHTML =
            'Your <a href=\'' +
            newAppInstance.uri +
            '\'><b>new ' +
            appInstanceNoun +
            '</b></a> is ready. ' +
            '<br/><br/><a href=\'' +
            newAppInstance.uri +
            '\'>Go to new ' +
            appInstanceNoun +
            '</a>'
          const newContext = Object.assign(
            { newInstance: newAppInstance },
            context
          )
          resolve(newContext)
        }

        function doNextTask () {
          function checkOKSetACL (uri, ok) {
            if (!ok) {
              return reject(new Error('Error writing new file ' + task.to))
            }

            setACLUserPublic(dest, me, aclOptions)
              .then(() => doNextTask())
              .catch(err => {
                error('Error setting access permissions for ' + task.to + '. Stack: ' + err)
                const message =
                  'Error setting access permissions for ' +
                  task.to +
                  '.'
                return reject(new Error(message))
              })
          }

          if (toBeWritten.length === 0) {
            claimSuccess(newAppInstance, appInstanceNoun)
          } else {
            var task = toBeWritten.shift() /* eslint-disable-line no-var */
            log('Creating new file ' + task.to + ' in new instance ')
            var dest = external_commonjs_rdflib_commonjs2_rdflib_amd_rdflib_root_$rdf_.uri.join(task.to, newBase) /* eslint-disable-line no-var */
            var aclOptions = task.aclOptions || {} /* eslint-disable-line no-var */

            if ('content' in task) {
              kb.fetcher
                .webOperation('PUT', dest, {
                  data: task.content,
                  saveMetadata: true,
                  contentType: task.contentType
                })
                .then(() => checkOKSetACL(dest, true))
            } else if ('existing' in task) {
              checkOKSetACL(dest, true)
            } else {
              reject(new Error('Copy not expected while buiding new app.'))
              // const from = task.from || task.to // default source to be same as dest
              // UI.widgets.webCopy(base + from, dest, task.contentType, checkOKSetACL)
            }
          }
        }
        doNextTask()
      },
      err => {
        // log in then
        warn('Error logging in. Stack: ' + err)
        complain(context.div, context.dom, 'Please log in to create a new address book.')
      }
    )
  })
}

// EXTERNAL MODULE: ./node_modules/css-loader/dist/cjs.js!./src/styles/mugshotGallery.css
var mugshotGallery = __webpack_require__(715);
;// ./src/styles/mugshotGallery.css

      
      
      
      
      
      
      
      
      

var mugshotGallery_options = {};

mugshotGallery_options.styleTagTransform = (styleTagTransform_default());
mugshotGallery_options.setAttributes = (setAttributesWithoutAttributes_default());
mugshotGallery_options.insert = insertBySelector_default().bind(null, "head");
mugshotGallery_options.domAPI = (styleDomAPI_default());
mugshotGallery_options.insertStyleElement = (insertStyleElement_default());

var mugshotGallery_update = injectStylesIntoStyleTag_default()(mugshotGallery/* default */.A, mugshotGallery_options);




       /* harmony default export */ const styles_mugshotGallery = (mugshotGallery/* default */.A && mugshotGallery/* default */.A.locals ? mugshotGallery/* default */.A.locals : undefined);

;// ./src/mugshotGallery.js







// Lightweight MIME helpers replacing the heavy mime-types/mime-db packages (~170 KiB)
const mimeMap = {
  'image/png': 'png',
  'image/jpeg': 'jpg',
  'image/gif': 'gif',
  'image/svg+xml': 'svg',
  'image/webp': 'webp',
  'image/bmp': 'bmp',
  'image/tiff': 'tiff',
  'application/pdf': 'pdf',
  'text/plain': 'txt',
  'text/html': 'html',
  'application/json': 'json',
  'application/octet-stream': 'bin'
}
const extMap = Object.fromEntries(Object.entries(mimeMap).map(([k, v]) => [v, k]))
const mime = {
  extension: (contentType) => mimeMap[contentType] || false,
  lookup: (filename) => {
    const ext = filename.split('.').pop().toLowerCase()
    return extMap[ext] || false
  }
}

const mugshotGallery_ns = external_commonjs_solid_ui_commonjs2_solid_ui_amd_solid_ui_root_UI_.ns
const mugshotGallery_utils = external_commonjs_solid_ui_commonjs2_solid_ui_amd_solid_ui_root_UI_.utils
const mugshotGallery_kb = external_commonjs_solid_logic_commonjs2_solid_logic_amd_solid_logic_root_SolidLogic_.store

/*  Mugshot Gallery
*
* A widget for managing a set of images.
* Make this a form field?
*/
function renderMugshotGallery (dom, subject) {
  function localComplain (message) {
    galleryDiv.appendChild(external_commonjs_solid_ui_commonjs2_solid_ui_amd_solid_ui_root_UI_.widgets.errorMessageBlock(dom, message, 'pink'))
  }

  async function linkToPicture (subject, pic, remove) {
    const link = [
      external_commonjs_rdflib_commonjs2_rdflib_amd_rdflib_root_$rdf_.st(subject, mugshotGallery_ns.vcard('hasPhoto'), pic, subject.doc())
    ]
    try {
      if (remove) {
        await mugshotGallery_kb.updater.update(link, [])
      } else {
        await mugshotGallery_kb.updater.update([], link)
      }
    } catch (err) {
      const msg = 'Writing back image link FAILED ' + pic + '. Stack: ' + err
      error(msg)
      throw new Error('Writing back image link FAILED')
    }
  }

  function handleDroppedThing (thing) {
    mugshotGallery_kb.fetcher.nowOrWhenFetched(thing.doc(), function (ok, mess) {
      if (!ok) {
        error('Error looking up dropped thing ' + thing + '. Stack: ' + mess)
      } else {
        const types = mugshotGallery_kb.findTypeURIs(thing)
        for (const ty in types) {
          log('drop object type includes: ' + ty) // @@ Allow email addresses and phone numbers to be dropped?
        }
        log('Default: assume web page  ' + thing) // icon was: UI.icons.iconBase + 'noun_25830.svg'
        mugshotGallery_kb.add(subject, mugshotGallery_ns.wf('attachment'), thing, subject.doc())
        // @@ refresh UI
      }
    })
  }

  function uploadFileToContact (filename, contentType, data) {
    // const fileExtension = filename.split('.').pop() // .toLowerCase()
    const extension = mime.extension(contentType)
    if (contentType !== mime.lookup(filename)) {
      filename += '_.' + extension
      warn('MIME TYPE MISMATCH -- adding extension: ' + filename)
    }
    let prefix, predicate
    const isImage = contentType.startsWith('image')
    if (isImage) {
      prefix = 'image_'
      predicate = mugshotGallery_ns.vcard('hasPhoto')
    } else {
      prefix = 'attachment_'
      predicate = mugshotGallery_ns.wf('attachment')
    }

    let n, pic
    for (n = 0; ; n++) {
      // Check filename is not used or invent new one
      pic = mugshotGallery_kb.sym(subject.dir().uri + filename)
      if (!mugshotGallery_kb.holds(subject, mugshotGallery_ns.vcard('hasPhoto'), pic)) {
        break
      }
      filename = prefix + n + '.' + extension
    }
    log(
      'Putting ' +
        data.byteLength +
        ' bytes of ' +
        contentType +
        ' to ' +
        pic
    )
    mugshotGallery_kb.fetcher
      .webOperation('PUT', pic.uri, {
        data,
        contentType
      })
      .then(function (response) {
        if (!response.ok) {
          error('Upload of ' + pic + ' failed: ' + response.status + ' ' + response.statusText)
          localComplain('Error uploading picture. If the problem persists, contact admin.')
          return
        }
        log('Upload picture put OK: ' + pic)
        mugshotGallery_kb.add(subject, predicate, pic, subject.doc())
        mugshotGallery_kb.fetcher
          .putBack(subject.doc(), { contentType: 'text/turtle' })
          .then(
            function (_response) {
              if (isImage) {
                mugshotDiv.refresh()
              }
            },
            function (err) {
              error(' Write back image link FAIL ' + pic + '. Stack: ' + err)
            }
          )
      })
  }

  // When a set of URIs are dropped on
  async function handleURIsDroppedOnMugshot (uris) {
    for (const u of uris) {
      let thing = external_commonjs_rdflib_commonjs2_rdflib_amd_rdflib_root_$rdf_.sym(u) // Attachment needs text label to disinguish I think not icon.
      log('Dropped on mugshot thing ' + thing) // icon was: UI.icons.iconBase + 'noun_25830.svg'
      if (u.startsWith('http') && u.indexOf('#') < 0) {
        // Plain document
        // Take a copy of a photo on the web:
        if (u.startsWith('http:')) { // because of browser mixed content stuff can't read http:
          thing = external_commonjs_rdflib_commonjs2_rdflib_amd_rdflib_root_$rdf_.sym('https:' + u.slice(5))
        }
        const options = { withCredentials: false, credentials: 'omit' }
        let result
        try {
          result = await mugshotGallery_kb.fetcher.webOperation('GET', thing.uri, options)
        } catch (err) {
          error('Fetch error trying to GET picture ' + thing + '. Stack: ' + err)
          handleDroppedThing(thing)
          return
        }
        const contentType = result.headers.get('Content-Type')
        let pathEnd = thing.uri.split('/').slice(-1)[0] // last segment as putative filename
        pathEnd = pathEnd.split('?')[0] // chop off any query params
        const data = await result.arrayBuffer()
        if (!result.ok) {
          error('Cant download, so will link image. ' + thing + ':' + result.status)
          handleDroppedThing(thing)
          return
        }
        uploadFileToContact(pathEnd, contentType, data)
        return
      } else {
        localComplain('Not a web document URI, cannot copy ' + thing + ' as picture.')
      }
      handleDroppedThing(thing)
    }
  }

  // Drop an image file to set up the mugshot
  function droppedFileHandler (files) {
    for (let i = 0; i < files.length; i++) {
      const f = files[i]
      log(
        ' contacts: Filename: ' +
          f.name +
          ', type: ' +
          (f.type || 'n/a') +
          ' size: ' +
          f.size +
          ' bytes, last modified: ' +
          (f.lastModifiedDate
            ? f.lastModifiedDate.toLocaleDateString()
            : 'n/a')
      ) // See e.g. https://www.html5rocks.com/en/tutorials/file/dndfiles/

      // @@ Add: progress bar(s)
      const reader = new FileReader()
      reader.onload = (function (theFile) {
        return function (e) {
          const data = e.target.result
          log(' File read byteLength : ' + data.byteLength)
          const filename = encodeURIComponent(theFile.name)
          const contentType = theFile.type
          uploadFileToContact(filename, contentType, data)
        }
      })(f)
      reader.readAsArrayBuffer(f)
    }
  }

  function elementForImage (image) {
    const img = dom.createElement('img')
    img.classList.add('mugshotImage')
    img.setAttribute('alt', image ? 'Contact photo' : 'Drop photo here')
    external_commonjs_solid_ui_commonjs2_solid_ui_amd_solid_ui_root_UI_.widgets.makeDropTarget(
      img,
      handleURIsDroppedOnMugshot,
      droppedFileHandler
    )
    if (image) {
      // img.setAttribute('src', image.uri) use token and works with NSS but not with CSS
      // we need to get image with authenticated fetch
      external_commonjs_solid_logic_commonjs2_solid_logic_amd_solid_logic_root_SolidLogic_.store.fetcher._fetch(image.uri)
        .then(function (response) {
          return response.blob()
        })
        .then(function (myBlob) {
          const objectURL = URL.createObjectURL(myBlob)
          img.setAttribute('src', objectURL)
        })
      external_commonjs_solid_ui_commonjs2_solid_ui_amd_solid_ui_root_UI_.widgets.makeDraggable(img, image)
    }
    return img
  }

  function syncMugshots () {
    let images = mugshotGallery_kb.each(subject, mugshotGallery_ns.vcard('hasPhoto')) // Priviledge vcard ones
    images.sort() // arbitrary consistency
    images = images.slice(0, 5) // max number for the space
    if (images.length === 0) {
      mugshotDiv.innerHTML = '' // strictly, don't remove it if already there
      if (editable) {
        mugshotDiv.appendChild(placeholder) // A head image to drop pictures on
      } // otherwise leave gallery empty .. nothing to see here folks
    } else {
      mugshotGallery_utils.syncTableToArray(mugshotDiv, images, elementForImage)
    }
  }

  // Good URI for a Camera picture
  function getImageDoc () {
    const imageDoc = mugshotGallery_kb.sym(
      subject.dir().uri + 'Image_' + Date.now() + '.png'
    )
    return imageDoc
  }
  // Store picture
  async function tookPicture (imageDoc) {
    if (imageDoc) {
      await linkToPicture(subject, imageDoc)
      syncMugshots()
    }
  }

  function trashCan () {
    const button = external_commonjs_solid_ui_commonjs2_solid_ui_amd_solid_ui_root_UI_.widgets.button(
      dom,
      external_commonjs_solid_ui_commonjs2_solid_ui_amd_solid_ui_root_UI_.icons.iconBase + 'noun_925021.svg',
      'Drag here to delete',
      undefined,
      { 'aria-label': 'Delete picture - drag picture here' }
    )
    async function droppedURIHandler (uris) {
      const images = mugshotGallery_kb
        .each(subject, mugshotGallery_ns.vcard('hasPhoto'))
        .map(x => x.uri)
      for (const uri of uris) {
        if (!images.includes(uri)) {
          alertDialog('Only drop pictures onto this trash can.')
          return
        }
        if (await confirmDialog('Really DELETE picture?')) {
          try {
            log('Unlinking image file ' + uri)
            await linkToPicture(subject, mugshotGallery_kb.sym(uri), true)
            log('Deleting image file ' + uri)
            await mugshotGallery_kb.fetcher.webOperation('DELETE', uri)
          } catch (err) {
            const msg = 'Error deleting picture. If it persists, contact your admin.'
            localComplain(msg)
            return
          }
        }
      }
      syncMugshots()
    }
    external_commonjs_solid_ui_commonjs2_solid_ui_amd_solid_ui_root_UI_.widgets.makeDropTarget(button, droppedURIHandler, null)
    return button
  }

  function renderImageTools () {
    const imageToolTable = dom.createElement('table')
    const row = imageToolTable.appendChild(dom.createElement('tr'))
    const left = row.appendChild(dom.createElement('td'))
    const middle = row.appendChild(dom.createElement('td'))
    const right = row.appendChild(dom.createElement('td'))

    left.appendChild(
      external_commonjs_solid_ui_commonjs2_solid_ui_amd_solid_ui_root_UI_.media.cameraButton(dom, mugshotGallery_kb, getImageDoc, tookPicture)
    )
    try {
      middle.appendChild(
        external_commonjs_solid_ui_commonjs2_solid_ui_amd_solid_ui_root_UI_.widgets.fileUploadButtonDiv(dom, droppedFileHandler)
      )
    } catch (e) {
      log('ignore fileUploadButtonDiv error for now', e)
    }
    right.appendChild(trashCan())
    return imageToolTable
  }

  // Body of renderMugshotGallery

  const editable = mugshotGallery_kb.updater.editable(subject.doc().uri, mugshotGallery_kb)
  const galleryDiv = dom.createElement('div')
  const mugshotDiv = galleryDiv.appendChild(dom.createElement('div'))
  const placeholder = elementForImage()
  external_commonjs_solid_ui_commonjs2_solid_ui_amd_solid_ui_root_UI_.widgets.setImage(placeholder, subject) // Fallback icon or get from web
  syncMugshots()
  mugshotDiv.refresh = syncMugshots
  if (editable) {
    galleryDiv.appendChild(renderImageTools())
  }
  return galleryDiv
}

// EXTERNAL MODULE: ./node_modules/css-loader/dist/cjs.js!./src/styles/groupMembership.css
var groupMembership = __webpack_require__(93);
;// ./src/styles/groupMembership.css

      
      
      
      
      
      
      
      
      

var groupMembership_options = {};

groupMembership_options.styleTagTransform = (styleTagTransform_default());
groupMembership_options.setAttributes = (setAttributesWithoutAttributes_default());
groupMembership_options.insert = insertBySelector_default().bind(null, "head");
groupMembership_options.domAPI = (styleDomAPI_default());
groupMembership_options.insertStyleElement = (insertStyleElement_default());

var groupMembership_update = injectStylesIntoStyleTag_default()(groupMembership/* default */.A, groupMembership_options);




       /* harmony default export */ const styles_groupMembership = (groupMembership/* default */.A && groupMembership/* default */.A.locals ? groupMembership/* default */.A.locals : undefined);

;// ./src/addressBookPresenter.js







const addressBookPresenter_ns = external_commonjs_solid_ui_commonjs2_solid_ui_amd_solid_ui_root_UI_.ns
const addressBookPresenter_utils = external_commonjs_solid_ui_commonjs2_solid_ui_amd_solid_ui_root_UI_.utils
const addressBookPresenter_kb = external_commonjs_solid_logic_commonjs2_solid_logic_amd_solid_logic_root_SolidLogic_.store
let addressBookPresenter_dom
let selectedGroups = {}
let selectedPeople = {}
let ulPeople = null
let ulGroups = null
let searchInput = null
let cardMain = null
let book = null
let dataBrowserContext = null
let onGroupButtonClick = null

// ######## Group presenter

function setActiveGroupButton (groupsUl, activeBtn) {
  groupsUl.querySelectorAll('button').forEach(btn => {
    btn.classList.remove('btn-primary', 'allGroupsButton--selected', 'allGroupsButton--active', 'allGroupsButton--loaded')
    btn.classList.add('btn-secondary')
  })
  if (activeBtn) {
    activeBtn.classList.remove('btn-secondary')
    activeBtn.classList.add('btn-primary')
  }
}

function renderGroupButtons (currentBook, groupsUl, options, domElement, groupsSelected, peopleUl, searchEl, cardMainEl, context, groupClickCallback) {
  addressBookPresenter_dom = domElement
  selectedGroups = groupsSelected || {}
  if (peopleUl) ulPeople = peopleUl
  if (searchEl) searchInput = searchEl
  if (cardMainEl) cardMain = cardMainEl
  if (context) dataBrowserContext = context
  if (groupClickCallback) onGroupButtonClick = groupClickCallback
  book = currentBook
  ulGroups = groupsUl
  const groups = groupsInOrder(book, options)
  addressBookPresenter_utils.syncTableToArrayReOrdered(ulGroups, groups, renderGroupLi)
}

/** Create the common DOM structure for a group list item (li + button).
 * Returns { groupLi, groupButton, name } so callers can attach their own handlers.
 */
function createGroupLi (group) {
  const name = addressBookPresenter_kb.any(group, addressBookPresenter_ns.vcard('fn'))
  const groupLi = addressBookPresenter_dom.createElement('li')
  groupLi.setAttribute('role', 'listitem')
  groupLi.setAttribute('aria-label', name ? name.value : 'Some group')
  groupLi.subject = group
  external_commonjs_solid_ui_commonjs2_solid_ui_amd_solid_ui_root_UI_.widgets.makeDraggable(groupLi, group)

  const groupButton = groupLi.appendChild(addressBookPresenter_dom.createElement('button'))
  groupButton.setAttribute('type', 'button')
  groupButton.innerHTML = name ? name.value : 'Some group'
  groupButton.classList.add('allGroupsButton', 'actionButton', 'btn-secondary', 'action-button-focus')

  return { groupLi, groupButton, name }
}

async function handleURIsDroppedOnGroup (uris, group) {
  for (const u of uris) {
    let thing = addressBookPresenter_kb.sym(u)
    try {
      thing = await addPersonToGroup(thing, group)
    } catch (_e) {
      const msg = 'Error adding to group. Make sure you are adding a contact URI.'
      alertDialog(msg)
    }
    if (thing) refreshNames(ulPeople)
  }
}

function renderGroupLi (group) {
  function groupLiClickListener (event) {
    event.preventDefault()
    setActiveGroupButton(ulGroups, groupButton)
    if (onGroupButtonClick) onGroupButtonClick()
    if (!event.metaKey) {
      for (const key in selectedGroups) delete selectedGroups[key] // If Command key pressed, accumulate multiple
    }
    selectedGroups[group.uri] = !selectedGroups[group.uri]
    refreshThingsSelected(ulGroups, selectedGroups)
    // Load group members and refresh people list
    addressBookPresenter_kb.fetcher.nowOrWhenFetched(group.doc(), undefined, function (ok, message) {
      if (!ok) {
        error('Cannot load one group: ' + group + '. Stack: ' + message)
      }
      refreshNames(ulPeople, null, false)
    })
  }

  const { groupLi, groupButton } = createGroupLi(group)

  groupButton.addEventListener('click', groupLiClickListener, false)
  external_commonjs_solid_ui_commonjs2_solid_ui_amd_solid_ui_root_UI_.widgets.makeDropTarget(groupLi, uris => handleURIsDroppedOnGroup(uris, group))
  groupLi.addEventListener('click', groupLiClickListener, true)
  return groupLi
} // renderGroupLi

function selectAllGroups (
  selectedGroups,
  ulGroups,
  callbackFunction
) {
  function fetchGroupAndSelect (group, groupLi) {
    return new Promise((resolve, reject) => {
      groupLi.classList.add('group-loading')
      groupLi.setAttribute('aria-busy', 'true')
      addressBookPresenter_kb.fetcher.nowOrWhenFetched(group.doc(), undefined, function (
        ok,
        message
      ) {
        if (!ok) {
          const msg = 'Cannot load group ' + group + '. Stack: ' + message
          error(msg)
          if (callbackFunction) callbackFunction(false, msg)
          reject(msg)
          return
        }
        groupLi.classList.remove('group-loading')
        groupLi.setAttribute('aria-busy', 'false')
        groupLi.classList.add('selected')
        selectedGroups[group.uri] = true
        refreshThingsSelected(ulGroups, selectedGroups)
        refreshNames(ulPeople, null) // @@ every time??
        if (callbackFunction) callbackFunction(true)
        resolve(true)
      })
    })
  }

  for (let k = 0; k < ulGroups.children.length; k++) {
    const groupLi = ulGroups.children[k]
    const group = groupLi.subject
    if (!group) continue // Skip non-group items (e.g. All contacts, New group)
    fetchGroupAndSelect(group, groupLi)
      .catch(err => {
        if (callbackFunction) callbackFunction(false, err)
      })
  } // for each row
}

function refreshThingsSelected (ul, selectionArray) {
  for (let i = 0; i < ul.children.length; i++) {
    const li = ul.children[i]
    if (li.subject) {
      li.classList.toggle('selected', !!selectionArray[li.subject.uri])
    }
  }
}

function syncGroupUl (book, options, groupsUl, domElement, groupsSelected, peopleUl, searchEl) {
  addressBookPresenter_dom = domElement
  if (groupsSelected) selectedGroups = groupsSelected
  if (peopleUl) ulPeople = peopleUl
  if (searchEl) searchInput = searchEl
  ulGroups = groupsUl
  const groups = groupsInOrder(book, options)
  if (groups.length > 0) {
    renderGroupLi(groups[0]) // pre-render one to get the style right, then throw it away
  }
  addressBookPresenter_utils.syncTableToArrayReOrdered(groupsUl, groups, renderGroupLi)
  // refreshThingsSelected(groupsUl, selectedGroups)
}

function groupsInOrder (book, options) {
  let sortMe = []
  if (options.foreignGroup) {
    sortMe.push([
      '',
      addressBookPresenter_kb.any(options.foreignGroup, addressBookPresenter_ns.vcard('fn')),
      options.foreignGroup
    ])
  }
  if (book) {
    const groupIndex = addressBookPresenter_kb.any(book, addressBookPresenter_ns.vcard('groupIndex'))
    const gs = book ? addressBookPresenter_kb.each(book, addressBookPresenter_ns.vcard('includesGroup'), null, groupIndex) : []
    const gs2 = gs.map(function (g) {
      return [book, addressBookPresenter_kb.any(g, addressBookPresenter_ns.vcard('fn')), g]
    })
    sortMe = sortMe.concat(gs2)
    sortMe.sort()
  }
  return sortMe.map(tuple => tuple[2])
}

async function loadAllGroups (book) {
  const groupIndex = addressBookPresenter_kb.any(book, addressBookPresenter_ns.vcard('groupIndex'))
  if (groupIndex) {
    await addressBookPresenter_kb.fetcher.load(groupIndex)
    const gs = book ? addressBookPresenter_kb.each(book, addressBookPresenter_ns.vcard('includesGroup'), null, groupIndex) : []
    await addressBookPresenter_kb.fetcher.load(gs)
    return gs
  } else {
    return [] // no groups
  }
}

// The book could be the main subject, or linked from a group we are dealing with
function findBookFromGroups (book) {
  if (book) {
    return book
  }
  let g
  for (const gu in selectedGroups) {
    g = addressBookPresenter_kb.sym(gu)
    const b = addressBookPresenter_kb.any(undefined, addressBookPresenter_ns.vcard('includesGroup'), g)
    if (b) return b
  }
  throw new Error(
    'findBookFromGroups: Cant find address book which this group is part of'
  )
}
// ######## Group presenter - END

// ######## Person presenter
/** Refresh the list of names */
function refreshNames (ulPeopleArg, detailsView, autoSelect = true) {
  // If the caller did not explicitly pass a list element, fall back to the
  // global variable that other helpers (renderGroupButtons, syncGroupUl, etc.)
  // keep up to date.  This allows callers that don't have easy access to the
  // element to simply invoke `refreshNames()` and get the behaviour they
  // expect when the address-book UI is present.
  const ul = ulPeopleArg || ulPeople

  // Guard: ul must be a DOM element with children.  Callers sometimes pass the
  // wrong thing (e.g. a person object) which leads to the
  // "Cannot read properties of undefined (reading 'length')" error in
  // syncTableToArrayReOrdered.  Bail out early if the value is not valid.
  if (!ul || !ul.children || typeof ul.children.length !== 'number') {
    warn('refreshNames called with invalid ulPeople:', ul)
    return
  }

  function setPersonListener (personLi, person) {
    function handleSelect (event) {
      event.preventDefault()
      selectPerson(ul, person, cardMain)
    }
    personLi.addEventListener('click', handleSelect)
    personLi.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault()
        handleSelect(event)
      }
    })
  }

  let cards = []
  const groups = Object.keys(selectedGroups).map(groupURI => addressBookPresenter_kb.sym(groupURI))
  groups.forEach(group => {
    if (selectedGroups[group.value]) {
      cards = cards.concat(groupMembers(addressBookPresenter_kb, group))
    }
  })
  cards.sort(compareForSort) // @@ sort by name not UID later
  for (let k = 0; k < cards.length - 1;) {
    if (cards[k].uri === cards[k + 1].uri) {
      cards.splice(k, 1) // Eliminate duplicates from more than one group
    } else {
      k++
    }
  }

  function renderNameInGroupList (person, ul) {
    const personLi = addressBookPresenter_dom.createElement('li')
    personLi.setAttribute('role', 'listitem')
    personLi.setAttribute('tabindex', '0')
    personLi.classList.add('personLi')
    personLi.subject = person
    external_commonjs_solid_ui_commonjs2_solid_ui_amd_solid_ui_root_UI_.widgets.makeDraggable(personLi, person)

    // Container for the row
    const rowDiv = addressBookPresenter_dom.createElement('div')
    rowDiv.classList.add('personLi-row')

    // Left: Avatar
    const avatarDiv = addressBookPresenter_dom.createElement('div')
    avatarDiv.classList.add('personLi-avatar')
    // Placeholder avatar (shown initially while person doc loads)
    const placeholderEl = addressBookPresenter_dom.createElement('div')
    placeholderEl.classList.add('avatar-placeholder')
    placeholderEl.innerHTML = '<svg aria-hidden="true" width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="18" cy="18" r="18" fill="#e0e0e0"/><text x="50%" y="58%" text-anchor="middle" fill="#595959" font-size="16" font-family="Arial" dy=".3em">?</text></svg>'
    avatarDiv.appendChild(placeholderEl)

    // Get name early so it can be used in trySetAvatar
    const name = nameFor(person) || 'Unknown Name'

    // Try to set avatar from already-loaded data, or fetch the person's doc
    function trySetAvatar () {
      const avatarUrl = addressBookPresenter_kb.any(person, addressBookPresenter_ns.vcard('hasPhoto'))
      if (avatarUrl && avatarUrl.value) {
        const img = addressBookPresenter_dom.createElement('img')
        img.src = avatarUrl.value
        img.alt = name + ' avatar'
        avatarDiv.replaceChild(img, avatarDiv.firstChild)
      }
    }
    trySetAvatar() // check if already in store

    // Load person's own document in background to get hasPhoto
    addressBookPresenter_kb.fetcher.nowOrWhenFetched(person.doc(), undefined, function (ok, message) {
      if (!ok) {
        error('Cannot load contact: ' + person + '. Stack: ' + message)
        personLi.classList.add('personLi--error')
        return // skip avatar – doc is unavailable
      }
      trySetAvatar()
    })

    // Center: Name
    const infoDiv = addressBookPresenter_dom.createElement('div')
    infoDiv.classList.add('personLi-info')

    personLi.setAttribute('aria-label', name)
    const nameDiv = addressBookPresenter_dom.createElement('div')
    nameDiv.classList.add('personLi-name')
    nameDiv.textContent = name

    infoDiv.appendChild(nameDiv)

    // Right: Arrow icon
    const arrowDiv = addressBookPresenter_dom.createElement('div')
    arrowDiv.classList.add('personLi-arrow')
    arrowDiv.innerHTML = '<svg aria-hidden="true" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 4.5L11.25 9L6 13.5" stroke="#595959" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'

    // Assemble
    rowDiv.appendChild(avatarDiv)
    rowDiv.appendChild(infoDiv)
    rowDiv.appendChild(arrowDiv)
    personLi.appendChild(rowDiv)

    setPersonListener(personLi, person)
    return personLi
  }

  addressBookPresenter_utils.syncTableToArrayReOrdered(ul, cards, person => renderNameInGroupList(person, ul))
  refreshFilteredPeople(ul, autoSelect, detailsView || cardMain)
} // refreshNames

function selectPerson (ulPeople, person, detailsView) {
  if (!detailsView) return
  if (detailsView.parentNode) detailsView.parentNode.classList.remove('hidden')
  detailsView.innerHTML = 'Loading...'
  detailsView.setAttribute('aria-busy', 'true')
  detailsView.classList.add('detailsSectionContent--wide')
  selectedPeople = {}
  selectedPeople[person.uri] = true
  refreshFilteredPeople(ulPeople, false, detailsView) // Color to remember which one you picked
  let local
  try {
    local = book ? localNode(person) : person
  } catch (err) {
    detailsView.innerHTML = ''
    detailsView.setAttribute('aria-busy', 'false')
    complain(detailsView, addressBookPresenter_dom, 'Cannot load contact: ' + err.message)
    return
  }
  addressBookPresenter_kb.fetcher.nowOrWhenFetched(local.doc(), undefined, function (
    ok,
    message
  ) {
    detailsView.innerHTML = ''
    detailsView.setAttribute('aria-busy', 'false')
    if (!ok) {
      error('Failed to load contact card: ' + local + '. Stack: ' + message)
      complain(detailsView, addressBookPresenter_dom, 'Failed to load contact. If it persists, contact your admin.')
      return
    }
    // debug.log("Loaded card " + local + '\n')

    // Top-right toolbar with link icon and delete button
    const toolbar = addressBookPresenter_dom.createElement('div')
    toolbar.classList.add('contact-toolbar')
    const linkEl = external_commonjs_solid_ui_commonjs2_solid_ui_amd_solid_ui_root_UI_.widgets.linkIcon(addressBookPresenter_dom, local)
    linkEl.setAttribute('title', 'Uri of contact')
    toolbar.appendChild(linkEl)

    if (external_commonjs_solid_logic_commonjs2_solid_logic_amd_solid_logic_root_SolidLogic_.authn.currentUser()) {
      // Add in a delete button to delete from AB
      const deleteButton = external_commonjs_solid_ui_commonjs2_solid_ui_amd_solid_ui_root_UI_.widgets.deleteButtonWithCheck(
        addressBookPresenter_dom,
        toolbar, // appends it to toolbar.appendChild(deleteButton)
        'contact',
        async function () {
          const container = person.dir() // ASSUMPTION THAT CARD IS IN ITS OWN DIRECTORY

          const pname = addressBookPresenter_kb.any(person, addressBookPresenter_ns.vcard('fn'))
          log('We are about to delete the contact ' + pname)
          await loadAllGroups() // need to wait for all groups to be loaded in case they have a link to this person
          // load people.ttl
          const nameEmailIndex = addressBookPresenter_kb.any(book, addressBookPresenter_ns.vcard('nameEmailIndex'))
          await addressBookPresenter_kb.fetcher.load(nameEmailIndex)

          //  - delete person's WebID's in each Group
          //  - delete the references to it in group files and save them back
          //  - delete the reference in people.ttl and save it back

          // find all Groups
          const groups = groupMembershipControl_groupMembership(person)
          let removeFromGroups = []
          // find person WebID's
          groups.forEach(group => {
            const webids = localUtils_getSameAs(addressBookPresenter_kb, person, group.doc())
            // for each check in each Group that it is not used by an other person then delete
            webids.forEach(webid => {
              if (localUtils_getSameAs(addressBookPresenter_kb, webid, group.doc()).length === 1) {
                removeFromGroups = removeFromGroups.concat(addressBookPresenter_kb.statementsMatching(group, addressBookPresenter_ns.vcard('hasMember'), webid, group.doc()))
              }
            })
          })

          // Only if folder deletion succeeds, proceed with person deletion
          await addressBookPresenter_kb.updater.updateMany(removeFromGroups)

          try {
            await deleteThingAndDoc(person)
          } catch (err) {
            complain(detailsView, addressBookPresenter_dom, 'Failed to delete contact. If it persists, contact your admin.')
            return
          }

          try {
            await deleteRecursive(addressBookPresenter_kb, container, toolbar, addressBookPresenter_dom)
          } catch (err) {
            const msg = 'Failed to delete contact. If it persists, contact your admin.'
            complain(detailsView, addressBookPresenter_dom, msg)
            return
          }
          refreshNames(ulPeople, detailsView)
          detailsView.innerHTML = 'Contact data deleted.'
        }
      )
      deleteButton.classList.add('deleteButton')
    }
    detailsView.appendChild(toolbar)

    detailsView.classList.add('detailsSectionContent--wide')
    detailsView.appendChild(renderPane(local, 'contact'))
  })
}

function deselectAllPeople (ulPeople) {
  selectedPeople = {}
  if (ulPeople) {
    for (let i = 0; i < ulPeople.children.length; i++) {
      ulPeople.children[i].classList.remove('selected')
    }
  }
}

function refreshFilteredPeople (ulPeople, active, detailsView) {
  let count = 0
  let lastRow = null
  for (let i = 0; i < ulPeople.children.length; i++) {
    const liElement = ulPeople.children[i]
    const matches = filterName(nameFor(liElement.subject))
    if (matches) {
      count++
      lastRow = liElement
    }
    liElement.classList.toggle('selected', matches && !!selectedPeople[liElement.subject.uri])
    liElement.classList.toggle('hidden', !matches)
  }
  if (count === 1 && active) {
    const unique = lastRow.subject
    selectPerson(ulPeople, unique, detailsView)
  }
}

function filterName (name) {
  const filter = searchInput.value.trim().toLowerCase()
  if (filter.length === 0) return true
  const parts = filter.split(' ') // Each name part must be somewhere
  for (let j = 0; j < parts.length; j++) {
    const word = parts[j]
    if (name.toLowerCase().indexOf(word) < 0) return false
  }
  return true
}

function renderPane (subject, paneName) {
  const p = dataBrowserContext.session.paneRegistry.byName(paneName)
  const d = p.render(subject, dataBrowserContext)
  d.classList.add('renderPane')
  return d
}

function localNode (person) {
  const aliases = addressBookPresenter_kb.allAliases(person)
  const prefix = book.dir().uri
  for (let i = 0; i < aliases.length; i++) {
    if (aliases[i].uri.slice(0, prefix.length) === prefix) {
      return aliases[i]
    }
  }
  throw new Error('No local URI for ' + person)
}

// Check every group is in the list and add it if not.
async function checkDataModel (book, detailsSectionContent) {
  // await kb.fetcher.load(groups) // asssume loaded already
  const groups = await loadAllGroups(book)

  if (groups && groups.length > 0) {
    const { del, ins } = await getDataModelIssues(groups)

    if (external_commonjs_solid_logic_commonjs2_solid_logic_amd_solid_logic_root_SolidLogic_.authn.currentUser()) {
      if (del.length) {
        external_commonjs_solid_ui_commonjs2_solid_ui_amd_solid_ui_root_UI_.widgets.deleteButtonWithCheck(
          addressBookPresenter_dom,
          detailsSectionContent, // where it appends it to
          'contact',
          async function () {
            await addressBookPresenter_kb.updater.updateMany(del, ins)
            log('Deleted ' + del.length + ' bad statements from groups')
          })
      }
    }
  }
}

// Prepare book data once so askName forms load instantly
async function ensureBookLoaded () {
  const ourBook = findBookFromGroups(book)
  try {
    await addressBookPresenter_kb.fetcher.load(ourBook)
  } catch (err) {
    throw new Error('Book won\'t load:' + ourBook)
  }
  const nameEmailIndex = addressBookPresenter_kb.any(ourBook, addressBookPresenter_ns.vcard('nameEmailIndex'))
  if (!nameEmailIndex) throw new Error('No nameEmailIndex')
  await addressBookPresenter_kb.fetcher.load(nameEmailIndex)
}

;// ./src/groupMembershipControl.js
// Render a control to record the group memberships we have for this agent








const groupMembershipControl_ns = external_commonjs_solid_ui_commonjs2_solid_ui_amd_solid_ui_root_UI_.ns
const groupMembershipControl_kb = external_commonjs_solid_logic_commonjs2_solid_logic_amd_solid_logic_root_SolidLogic_.store

// Groups the person is a member of
function groupMembershipControl_groupMembership (person, store = groupMembershipControl_kb) {
  let groups = store.statementsMatching(null, groupMembershipControl_ns.owl('sameAs'), person).map(st => st.why)
    .concat(store.each(null, groupMembershipControl_ns.vcard('hasMember'), person))
  const strings = new Set(groups.map(group => normalizeGroupUri(group.uri))) // remove dups with normalized URIs
  groups = [...strings].map(uri => store.sym(uri))
  return groups
}

/**
 * Render the group membership section for a given person.
 *
 * @param person - the contact whose memberships are being edited
 * @param context - the Data Browser context used by the pane registry
 * @param ulPeople - **optional** the `<ul>` element containing the master
 *   people list.  When provided (e.g. by the contacts pane) the control will
 *   automatically call `refreshNames(ulPeople)` after removing a membership so
 *   that the list on the left reflects the change.  If `null` this behaviour
 *   is skipped.
 */
async function renderGroupMemberships (person, context, ulPeople) {
  // keep a reference to the people list (if any) so callers can ask us to
  // refresh it when group membership changes.  The callers that render an
  // address-book view pass their `ulPeople` element; other consumers may not
  // have one and can simply ignore it.
  const peopleUl = ulPeople || null

  // Remove a person from a group
  async function removeFromGroup (person, group) {
    const pname = kb.any(person, groupMembershipControl_ns.vcard('fn'))
    const gname = kb.any(group, groupMembershipControl_ns.vcard('fn'))
    // find all WebIDs of thing
    const thingwebids = kb.each(null, groupMembershipControl_ns.owl('sameAs'), person, group.doc())
    // WebID can be deleted only if not used in another thing
    let webids = []
    thingwebids.forEach(webid => {
      if (kb.statementsMatching(webid, groupMembershipControl_ns.owl('sameAs'), person, group.doc())) webids = webids.concat(webid)
    })
    webids = vcardWebIDs(kb, person).map(webid => webid.value)
    // When checking how many groups this entity belongs to we should look
    // at the person **and** any of their webID nodes.  Build an array of
    // named nodes so we can query all of them.
    const webidNodes = webids.map(u => kb.sym(u))
    const members = [person].concat(webidNodes)
    // collect all groups for any of these members, dedupe by URI
    let groups = members
      .flatMap(m => kb.each(null, groupMembershipControl_ns.vcard('hasMember'), m))
    groups = [...new Set(groups.map(g => g.uri))].map(u => kb.sym(u))
    if (groups.length < 2) {
      alertDialog(
        'Must be a member of at least one group.  Add to another group first.'
      )
      return
    }
    const message = 'Remove ' + pname + ' from group ' + gname + '?'
    if (await confirmDialog(message)) {
      let del = kb
        .statementsMatching(person, undefined, undefined, group.doc())
        .concat(kb.statementsMatching(undefined, undefined, person, group.doc()))
      webids.forEach(webid => {
        if (kb.statementsMatching(webid, groupMembershipControl_ns.owl('sameAs'), undefined, group.doc()).length < 2) {
          del = del.concat(kb.statementsMatching(undefined, undefined, webid, group.doc()))
        }
      })
      try {
        await kb.updater.update(del, [])
      } catch (err) {
        const message = 'Error removing member from group ' + group + ': ' + err
        container.appendChild(external_commonjs_solid_ui_commonjs2_solid_ui_amd_solid_ui_root_UI_.widgets.errorMessageBlock(dom, message, 'pink'))
        return
      }
      log('Removed ' + pname + ' from group ' + gname)
      // to allow refresh of card groupList
      kb.fetcher.unload(group.doc())
      await kb.fetcher.load(group.doc())
      syncGroupPills()
      // also update the people list if one exists (or via global fallback)
      refreshNames(peopleUl)
    }
  }

  function createGroupItem (group) {
    const gname = kb.any(group, groupMembershipControl_ns.vcard('fn'))
    const label = gname ? gname.value : group.uri

    const li = dom.createElement('li')
    li.classList.add('group-membership-item')

    // Main group button
    const btn = dom.createElement('button')
    btn.setAttribute('type', 'button')
    btn.classList.add('allGroupsButton', 'actionButton', 'btn-secondary', 'action-button-focus')
    btn.textContent = label
    btn.title = label
    li.appendChild(btn)

    // Toolbar below the button: link icon + delete button
    const toolbar = dom.createElement('div')
    toolbar.classList.add('group-membership-toolbar')

    // Link icon
    const linkEl = external_commonjs_solid_ui_commonjs2_solid_ui_amd_solid_ui_root_UI_.widgets.linkIcon(dom, group)
    linkEl.setAttribute('title', 'Link to ' + label)
    toolbar.appendChild(linkEl)

    if (external_commonjs_solid_logic_commonjs2_solid_logic_amd_solid_logic_root_SolidLogic_.authn.currentUser()) {
      // Delete button
      external_commonjs_solid_ui_commonjs2_solid_ui_amd_solid_ui_root_UI_.widgets.deleteButtonWithCheck(
        dom,
        toolbar,
        'membership in ' + label,
        async function () {
          // async operation handles its own refresh once the group doc has
          // been reloaded
          await removeFromGroup(person, group)
        }
      )
    }

    li.appendChild(toolbar)
    return li
  }

  function syncGroupPills (groups = null) {
    // Clear previous render so we don't keep appending duplicate headers / lists
    container.innerHTML = ''

    const header = dom.createElement('h3')
    header.classList.add('group-membership-header')
    header.textContent = 'Part of groups'
    container.appendChild(header)

    const pillsWrapper = dom.createElement('ul')
    pillsWrapper.classList.add('group-pills-wrapper')
    container.appendChild(pillsWrapper)

    groups = groups || groupMembershipControl_groupMembership(person, kb)

    if (groups.length === 0) {
      pillsWrapper.innerHTML = '<span>Not part of any Address Book group.</span>'
    } else {
      pillsWrapper.innerHTML = ''
    }

    groups.forEach(group => {
      pillsWrapper.appendChild(createGroupItem(group))
    })
  }

  async function loadGroupsFromBook (book = null) {
    if (!book) {
      book = kb.any(undefined, groupMembershipControl_ns.vcard('includesGroup'))
      if (!book) {
        return [] // no book => no groups
      }
    }
    const groupIndex = kb.any(book, groupMembershipControl_ns.vcard('groupIndex'))
    const gs = book ? kb.each(book, groupMembershipControl_ns.vcard('includesGroup'), null, groupIndex) : []
    await kb.fetcher.load(gs)
    return gs
  }

  const { dom } = context
  const kb = context.session.store

  const container = dom.createElement('div')
  container.classList.add('group-membership-container')

  // find book any group and load all groups (so membership checks have the data they need)
  await loadGroupsFromBook()

  // renders the Part of Group
  container.refresh = syncGroupPills
  syncGroupPills()
  return container
}

;// ./src/ontology/individualAndOrganizationForm.ttl
const individualAndOrganizationForm_namespaceObject = "# This turtle file defines the forms used in the contacts management\n#\n# Individuals and orgs are in one file as they both\n# share some forms (address etc) and also interactions (roles)\n\n# Forms documentation: https://solidos.github.io/solid-ui/docs/forms-intro.html\n\n@prefix rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>.\n@prefix dct: <http://purl.org/dc/terms/>.\n@prefix foaf: <http://xmlns.com/foaf/0.1/>.\n@prefix owl: <http://www.w3.org/2002/07/owl#>.\n@prefix prov: <http://www.w3.org/ns/prov#>.\n@prefix ui: <http://www.w3.org/ns/ui#>.\n@prefix schema: <http://schema.org/>.\n@prefix solid: <http://www.w3.org/ns/solid/terms#>.\n@prefix vcard: <http://www.w3.org/2006/vcard/ns#>.\n@prefix : <#>.\n\n\n############# For individual:\n:individualForm a ui:Form ;\n    dct:title \"Contact details for a person\" ;\n    ui:parts (\n        :fullNameField\n        :nicknameGroup\n        :pronounsGroup\n        :roleField\n        :orgNameField\n        # :addressesComment\n        :addresses\n        # :emailComment\n        :eMails\n        # :telephoneComment\n        :telephones\n        :birthdayField\n        # :noteComment\n        :noteField \n        ) .\n\n    :fullNameField\n        a ui:SingleLineTextField ;\n        ui:label \"Name\";\n        ui:maxLength \"128\" ;\n        ui:property vcard:fn .\n\n    # Nickname\n\n    :nicknameGroup a ui:Group; ui:weight 0; \n        ui:parts (:nicknameField) .\n\n    :nicknameField a ui:SingleLineTextField; \n        ui:property foaf:nick;\n        ui:label \"Nickname\"@en, \"Nom court\"@fr.\n\n    # Pronouns\n\n    :pronounsGroup a ui:Group; ui:weight 0; \n        ui:parts ( :subjectPronounForm :objectPronounForm :relativePronounForm) .\n\n    :subjectPronounForm a ui:SingleLineTextField; ui:property solid:preferredSubjectPronoun;\n        ui:label \"he/she/they\" .\n    :objectPronounForm a ui:SingleLineTextField; ui:property solid:preferredObjectPronoun;\n        ui:label \"him/her/them\" .\n    :relativePronounForm a ui:SingleLineTextField; ui:property solid:preferredRelativePronoun;\n        ui:label \"his/hers/theirs\" .\n        \n    :roleField\n        a ui:SingleLineTextField ;\n        ui:suppressEmptyUneditable true;\n        ui:maxLength \"128\" ;\n        ui:property vcard:role .\n\n    :orgNameField\n        a ui:SingleLineTextField ;\n        ui:suppressEmptyUneditable true;\n        ui:maxLength \"128\" ;\n        ui:property vcard:organization-name .\n\n    :addresses a ui:Multiple ;\n        dct:title \"Address details\" ;\n        ui:part :oneAddress ;\n        ui:property vcard:hasAddress .\n\n        :oneAddress a ui:Group ;\n            ui:parts ( \n                :id1409437207443 :id1409437292400 \n                :id1409437421996 :id1409437467649 \n                :id1409437569420 ). \n\n            :id1409437207443\n                a ui:SingleLineTextField ;\n                ui:maxLength \"128\" ;\n                ui:property vcard:street-address .\n\n            :id1409437292400\n                a ui:SingleLineTextField ;\n                ui:maxLength \"128\" ;\n                ui:property vcard:locality .\n\n            :id1409437421996\n                a ui:SingleLineTextField ;\n                ui:maxLength \"25\" ;\n                ui:property vcard:postal-code .\n\n            :id1409437467649\n                a ui:SingleLineTextField ;\n                ui:maxLength \"128\" ;\n                ui:property vcard:region .\n\n            :id1409437569420\n                a ui:SingleLineTextField ;\n                ui:maxLength \"128\" ;\n                ui:property vcard:country-name .\n\n\n    :eMails a ui:Multiple ;\n        ui:part :oneEMail ;\n        ui:property vcard:hasEmail .\n\n        :oneEMail a ui:Group ; # hint: side by side is good\n            ui:part :emailValue, :emailType ;\n            ui:parts ( :emailType  :emailValue ).\n\n            :emailValue\n                a ui:EmailField ; ui:label \"email\";\n                ui:property vcard:value .\n\n            :emailType\n                a ui:Classifier ;\n                ui:canMintNew \"0\" ;\n                ui:category vcard:Type ;\n                ui:from vcard:Type ;\n                ui:property rdf:type .\n\n    :telephones a ui:Multiple ;\n        ui:part :onetelephone ;\n        ui:property vcard:hasTelephone .\n\n        :onetelephone\n            a ui:Group ;\n            ui:part :telephoneValue, :telephoneType ;\n            ui:parts (  :telephoneType :telephoneValue ).\n\n            :telephoneValue\n                a ui:PhoneField ;\n                ui:property vcard:value .\n\n            :telephoneType\n                a ui:Classifier ;\n                ui:canMintNew \"0\" ;\n                ui:category vcard:TelephoneType ;\n                ui:from vcard:Type ;\n                ui:property rdf:type .\n\n    :birthdayField a ui:DateField;\n        ui:label \"Born\"@en;\n        ui:suppressEmptyUneditable true;\n        ui:property vcard:bday .\n\n    :noteField\n        a ui:MultiLineTextField ;\n        ui:suppressEmptyUneditable true;\n        ui:property vcard:note .\n\n# Ontology additions or interpretations needed for the form to work well\n\n# The ontology file doesn't make them disjoint. This makes the selector be a choice.\nvcard:TelephoneType   owl:disjointUnionOf ( vcard:Cell vcard:Home vcard:Work) .\nvcard:Type   owl:disjointUnionOf (vcard:Home vcard:Work) . # for email\n\n# Better field labels\nvcard:Cell ui:label \"mobile\"@en . # app will make initial caps if necessary\nvcard:hasAddress ui:label \"address\"@en .\nvcard:bday ui:label \"born\"@en.\nvcard:hasEmail ui:label \"email\"@en .\nvcard:hasTelephone ui:label \"phone\"@en .\nvcard:note ui:label \"notes\"@en .\n\n\n############ For organizations\n\n:organizationForm a ui:Form ; \n    dct:title \"Contact details for an organization\";\n    ui:parts (\n        :OrgClassifier\n        :fullNameField\n        :homePageURIField\n        :addresses\n        :eMails\n        :telephones\n        :noteField ) .\n\n    :OrgClassifier a ui:Classifier; \n        ui:label \"What sort of organization?\"@en;\n        ui:category solid:InterestingOrganization .\n\n    :homePageURIField a ui:NamedNodeURIField;\n        ui:label \"Homepage\"@en;\n        ui:property schema:url .\n\n# Ontology data to drive the :OrgClassifier classifier\n    solid:InterestingOrganization owl:disjointUnionOf  (\n        # Airline - a Corporation\n        # Consortium - a Corporation or a NGO\n        schema:Corporation\n        schema:EducationalOrganization\n        schema:ResearchOrganization  # Proposed. https://github.com/schemaorg/schemaorg/issues/2877\n        # FundingScheme - eh?\n        schema:GovernmentOrganization\n        # LibrarySystem\n        # LocalBusiness - Corporation\n        # MedicalOrganization - a Corporation or a NGO\n        schema:NGO\n        # NewsMediaOrganization - a Corporation or a NGO\n        schema:PerformingGroup # a band\n        schema:Project # like Solid\n        schema:SportsOrganization) .\n";
;// ./src/ontology/vcard.ttl
const vcard_namespaceObject = "@prefix : <http://www.w3.org/2006/vcard/ns#> .\n@prefix owl: <http://www.w3.org/2002/07/owl#> .\n@prefix rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#> .\n@prefix rdfs: <http://www.w3.org/2000/01/rdf-schema#> .\n@prefix xml: <http://www.w3.org/XML/1998/namespace> .\n@prefix xsd: <http://www.w3.org/2001/XMLSchema#> .\n\n:Acquaintance a owl:Class ;\n    rdfs:label \"Acquaintance\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    rdfs:subClassOf :RelatedType .\n\n:Agent a owl:Class ;\n    rdfs:label \"Agent\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    rdfs:subClassOf :RelatedType .\n\n:BBS a owl:Class ;\n    rdfs:label \"BBS\"@en ;\n    rdfs:comment \"This class is deprecated\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    rdfs:subClassOf :TelephoneType ;\n    owl:deprecated true .\n\n:Car a owl:Class ;\n    rdfs:label \"Car\"@en ;\n    rdfs:comment \"This class is deprecated\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    rdfs:subClassOf :TelephoneType ;\n    owl:deprecated true .\n\n:Cell a owl:Class ;\n    rdfs:label \"Cell\"@en ;\n    rdfs:comment \"Also called mobile telephone\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    rdfs:subClassOf :TelephoneType .\n\n:Child a owl:Class ;\n    rdfs:label \"Child\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    rdfs:subClassOf :RelatedType .\n\n:Colleague a owl:Class ;\n    rdfs:label \"Colleague\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    rdfs:subClassOf :RelatedType .\n\n:Contact a owl:Class ;\n    rdfs:label \"Contact\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    rdfs:subClassOf :RelatedType .\n\n:Coresident a owl:Class ;\n    rdfs:label \"Coresident\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    rdfs:subClassOf :RelatedType .\n\n:Coworker a owl:Class ;\n    rdfs:label \"Coworker\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    rdfs:subClassOf :RelatedType .\n\n:Crush a owl:Class ;\n    rdfs:label \"Crush\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    rdfs:subClassOf :RelatedType .\n\n:Date a owl:Class ;\n    rdfs:label \"Date\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    rdfs:subClassOf :RelatedType .\n\n:Dom a owl:Class ;\n    rdfs:label \"Dom\"@en ;\n    rdfs:comment \"This class is deprecated\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    rdfs:subClassOf :Type ;\n    owl:deprecated true .\n\n:Emergency a owl:Class ;\n    rdfs:label \"Emergency\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    rdfs:subClassOf :RelatedType .\n\n:Fax a owl:Class ;\n    rdfs:label \"Fax\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    rdfs:subClassOf :TelephoneType .\n\n:Female a owl:Class ;\n    rdfs:label \"Female\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    rdfs:subClassOf :Gender .\n\n:Friend a owl:Class ;\n    rdfs:label \"Friend\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    rdfs:subClassOf :RelatedType .\n\n:Home a owl:Class ;\n    rdfs:label \"Home\"@en ;\n    rdfs:comment \"This implies that the property is related to an individual's personal life\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    rdfs:subClassOf :Type .\n\n:ISDN a owl:Class ;\n    rdfs:label \"ISDN\"@en ;\n    rdfs:comment \"This class is deprecated\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    rdfs:subClassOf :Type ;\n    owl:deprecated true .\n\n:Internet a owl:Class ;\n    rdfs:label \"Internet\"@en ;\n    rdfs:comment \"This class is deprecated\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    rdfs:subClassOf :Type ;\n    owl:deprecated true .\n\n:Intl a owl:Class ;\n    rdfs:label \"Intl\"@en ;\n    rdfs:comment \"This class is deprecated\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    rdfs:subClassOf :Type ;\n    owl:deprecated true .\n\n:Kin a owl:Class ;\n    rdfs:label \"Kin\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    rdfs:subClassOf :RelatedType .\n\n:Label a owl:Class ;\n    rdfs:label \"Label\"@en ;\n    rdfs:comment \"This class is deprecated\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    rdfs:subClassOf :Type ;\n    owl:deprecated true .\n\n:Male a owl:Class ;\n    rdfs:label \"Male\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    rdfs:subClassOf :Gender .\n\n:Me a owl:Class ;\n    rdfs:label \"Me\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    rdfs:subClassOf :RelatedType .\n\n:Met a owl:Class ;\n    rdfs:label \"Met\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    rdfs:subClassOf :RelatedType .\n\n:Modem a owl:Class ;\n    rdfs:label \"Modem\"@en ;\n    rdfs:comment \"This class is deprecated\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    rdfs:subClassOf :TelephoneType ;\n    owl:deprecated true .\n\n:Msg a owl:Class ;\n    rdfs:label \"Msg\"@en ;\n    rdfs:comment \"This class is deprecated\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    rdfs:subClassOf :TelephoneType ;\n    owl:deprecated true .\n\n:Muse a owl:Class ;\n    rdfs:label \"Muse\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    rdfs:subClassOf :RelatedType .\n\n:Neighbor a owl:Class ;\n    rdfs:label \"Neighbor\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    rdfs:subClassOf :RelatedType .\n\n:None a owl:Class ;\n    rdfs:label \"None\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    rdfs:subClassOf :Gender .\n\n:Other a owl:Class ;\n    rdfs:label \"Other\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    rdfs:subClassOf :Gender .\n\n:PCS a owl:Class ;\n    rdfs:label \"PCS\"@en ;\n    rdfs:comment \"This class is deprecated\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    rdfs:subClassOf :TelephoneType ;\n    owl:deprecated true .\n\n:Pager a owl:Class ;\n    rdfs:label \"Pager\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    rdfs:subClassOf :TelephoneType .\n\n:Parcel a owl:Class ;\n    rdfs:label \"Parcel\"@en ;\n    rdfs:comment \"This class is deprecated\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    rdfs:subClassOf :Type ;\n    owl:deprecated true .\n\n:Parent a owl:Class ;\n    rdfs:label \"Parent\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    rdfs:subClassOf :RelatedType .\n\n:Postal a owl:Class ;\n    rdfs:label \"Postal\"@en ;\n    rdfs:comment \"This class is deprecated\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    rdfs:subClassOf :Type ;\n    owl:deprecated true .\n\n:Pref a owl:Class ;\n    rdfs:label \"Pref\"@en ;\n    rdfs:comment \"This class is deprecated\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    rdfs:subClassOf :Type ;\n    owl:deprecated true .\n\n:Sibling a owl:Class ;\n    rdfs:label \"Sibling\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    rdfs:subClassOf :RelatedType .\n\n:Spouse a owl:Class ;\n    rdfs:label \"Spouse\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    rdfs:subClassOf :RelatedType .\n\n:Sweetheart a owl:Class ;\n    rdfs:label \"Sweetheart\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    rdfs:subClassOf :RelatedType .\n\n:Tel a owl:Class ;\n    rdfs:label \"Tel\"@en ;\n    rdfs:comment \"This class is deprecated. Use the hasTelephone object property.\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    owl:deprecated true .\n\n:Text a owl:Class ;\n    rdfs:label \"Text\"@en ;\n    rdfs:comment \"Also called sms telephone\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    rdfs:subClassOf :TelephoneType .\n\n:TextPhone a owl:Class ;\n    rdfs:label \"Text phone\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    rdfs:subClassOf :TelephoneType .\n\n:Unknown a owl:Class ;\n    rdfs:label \"Unknown\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    rdfs:subClassOf :Gender .\n\n:Video a owl:Class ;\n    rdfs:label \"Video\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    rdfs:subClassOf :TelephoneType .\n\n:Voice a owl:Class ;\n    rdfs:label \"Voice\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    rdfs:subClassOf :TelephoneType .\n\n:Work a owl:Class ;\n    rdfs:label \"Work\"@en ;\n    rdfs:comment \"This implies that the property is related to an individual's work place\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    rdfs:subClassOf :Type .\n\n:X400 a owl:Class ;\n    rdfs:label \"X400\"@en ;\n    rdfs:comment \"This class is deprecated\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    rdfs:subClassOf :Type ;\n    owl:deprecated true .\n\n:adr a owl:ObjectProperty ;\n    rdfs:label \"address\"@en ;\n    rdfs:comment \"This object property has been mapped\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    owl:equivalentProperty :hasAddress .\n\n:agent a owl:ObjectProperty ;\n    rdfs:label \"agent\"@en ;\n    rdfs:comment \"This object property has been deprecated\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    owl:deprecated true .\n\n:anniversary a owl:DatatypeProperty ;\n    rdfs:label \"anniversary\"@en ;\n    rdfs:comment \"The date of marriage, or equivalent, of the object\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    rdfs:range [ a rdfs:Datatype ;\n            owl:unionOf ( xsd:dateTime xsd:gYear ) ] .\n\n:bday a owl:DatatypeProperty ;\n    rdfs:label \"birth date\"@en ;\n    rdfs:comment \"To specify the birth date of the object\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    rdfs:range [ a rdfs:Datatype ;\n            owl:unionOf ( xsd:dateTime xsd:dateTimeStamp xsd:gYear ) ] .\n\n:category a owl:DatatypeProperty ;\n    rdfs:label \"category\"@en ;\n    rdfs:comment \"The category information about the object, also known as tags\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    rdfs:range xsd:string .\n\n:class a owl:DatatypeProperty ;\n    rdfs:label \"class\"@en ;\n    rdfs:comment \"This data property has been deprecated\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    owl:deprecated true .\n\n:email a owl:ObjectProperty ;\n    rdfs:label \"email\"@en ;\n    rdfs:comment \"This object property has been mapped\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    owl:equivalentProperty :hasEmail .\n\n:extended-address a owl:DatatypeProperty ;\n    rdfs:label \"extended address\"@en ;\n    rdfs:comment \"This data property has been deprecated\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    owl:deprecated true .\n\n:geo a owl:ObjectProperty ;\n    rdfs:label \"geo\"@en ;\n    rdfs:comment \"This object property has been mapped\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    owl:equivalentProperty :hasGeo .\n\n:hasAdditionalName a owl:ObjectProperty ;\n    rdfs:label \"has additional name\"@en ;\n    rdfs:comment \"Used to support property parameters for the additional name data property\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> .\n\n:hasCalendarBusy a owl:ObjectProperty ;\n    rdfs:label \"has calendar busy\"@en ;\n    rdfs:comment \"To specify the busy time associated with the object. (Was called FBURL in RFC6350)\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> .\n\n:hasCalendarLink a owl:ObjectProperty ;\n    rdfs:label \"has calendar link\"@en ;\n    rdfs:comment \"To specify the calendar associated with the object. (Was called CALURI in RFC6350)\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> .\n\n:hasCalendarRequest a owl:ObjectProperty ;\n    rdfs:label \"has calendar request\"@en ;\n    rdfs:comment \"To specify the calendar user address to which a scheduling request be sent for the object. (Was called CALADRURI in RFC6350)\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> .\n\n:hasCategory a owl:ObjectProperty ;\n    rdfs:label \"has category\"@en ;\n    rdfs:comment \"Used to support property parameters for the category data property\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> .\n\n:hasCountryName a owl:ObjectProperty ;\n    rdfs:label \"has country name\"@en ;\n    rdfs:comment \"Used to support property parameters for the country name data property\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> .\n\n:hasFN a owl:ObjectProperty ;\n    rdfs:label \"has formatted name\"@en ;\n    rdfs:comment \"Used to support property parameters for the formatted name data property\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> .\n\n:hasFamilyName a owl:ObjectProperty ;\n    rdfs:label \"has family name\"@en ;\n    rdfs:comment \"Used to support property parameters for the family name data property\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> .\n\n:hasGender a owl:ObjectProperty ;\n    rdfs:label \"has gender\"@en ;\n    rdfs:comment \"To specify  the sex or gender identity of the object. URIs are recommended to enable interoperable sex and gender codes to be used.\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> .\n\n:hasGivenName a owl:ObjectProperty ;\n    rdfs:label \"has given name\"@en ;\n    rdfs:comment \"Used to support property parameters for the given name data property\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> .\n\n:hasHonorificPrefix a owl:ObjectProperty ;\n    rdfs:label \"has honorific prefix\"@en ;\n    rdfs:comment \"Used to support property parameters for the honorific prefix data property\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> .\n\n:hasHonorificSuffix a owl:ObjectProperty ;\n    rdfs:label \"has honorific suffix\"@en ;\n    rdfs:comment \"Used to support property parameters for the honorific suffix data property\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> .\n\n:hasInstantMessage a owl:ObjectProperty ;\n    rdfs:label \"has messaging\"@en ;\n    rdfs:comment \"To specify the instant messaging and presence protocol communications with the object. (Was called IMPP in RFC6350)\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> .\n\n:hasLanguage a owl:ObjectProperty ;\n    rdfs:label \"has language\"@en ;\n    rdfs:comment \"Used to support property parameters for the language data property\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> .\n\n:hasLocality a owl:ObjectProperty ;\n    rdfs:label \"has locality\"@en ;\n    rdfs:comment \"Used to support property parameters for the locality data property\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> .\n\n:hasNickname a owl:ObjectProperty ;\n    rdfs:label \"has nickname\"@en ;\n    rdfs:comment \"Used to support property parameters for the nickname data property\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    rdfs:seeAlso :nickname .\n\n:hasNote a owl:ObjectProperty ;\n    rdfs:label \"has note\"@en ;\n    rdfs:comment \"Used to support property parameters for the note data property\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> .\n\n:hasOrganizationName a owl:ObjectProperty ;\n    rdfs:label \"has organization name\"@en ;\n    rdfs:comment \"Used to support property parameters for the organization name data property\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> .\n\n:hasOrganizationUnit a owl:ObjectProperty ;\n    rdfs:label \"has organization unit name\"@en ;\n    rdfs:comment \"Used to support property parameters for the organization unit name data property\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> .\n\n:hasPostalCode a owl:ObjectProperty ;\n    rdfs:label \"has postal code\"@en ;\n    rdfs:comment \"Used to support property parameters for the postal code data property\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> .\n\n:hasRegion a owl:ObjectProperty ;\n    rdfs:label \"has region\"@en ;\n    rdfs:comment \"Used to support property parameters for the region data property\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> .\n\n:hasRelated a owl:ObjectProperty ;\n    rdfs:label \"has related\"@en ;\n    rdfs:comment \"To specify a relationship between another entity and the entity represented by this object\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> .\n\n:hasRole a owl:ObjectProperty ;\n    rdfs:label \"has role\"@en ;\n    rdfs:comment \"Used to support property parameters for the role data property\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> .\n\n:hasSource a owl:ObjectProperty ;\n    rdfs:label \"has source\"@en ;\n    rdfs:comment \"To identify the source of directory information of the object\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> .\n\n:hasStreetAddress a owl:ObjectProperty ;\n    rdfs:label \"has street address\"@en ;\n    rdfs:comment \"Used to support property parameters for the street address data property\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> .\n\n:hasTitle a owl:ObjectProperty ;\n    rdfs:label \"has title\"@en ;\n    rdfs:comment \"Used to support property parameters for the title data property\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> .\n\n:hasUID a owl:ObjectProperty ;\n    rdfs:label \"has uid\"@en ;\n    rdfs:comment \"To specify a value that represents a globally unique identifier corresponding to the object\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> .\n\n:hasValue a owl:ObjectProperty ;\n    rdfs:label \"has value\"@en ;\n    rdfs:comment \"Used to indicate the resource value of an object property that requires property parameters\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> .\n\n:label a owl:DatatypeProperty ;\n    rdfs:label \"label\"@en ;\n    rdfs:comment \"This data property has been deprecated\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    owl:deprecated true .\n\n:language a owl:DatatypeProperty ;\n    rdfs:label \"language\"@en ;\n    rdfs:comment \"To specify the language that may be used for contacting the object. May also be used as a property parameter.\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> .\n\n:latitude a owl:DatatypeProperty ;\n    rdfs:label \"latitude\"@en ;\n    rdfs:comment \"This data property has been deprecated. See hasGeo\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    owl:deprecated true .\n\n:longitude a owl:DatatypeProperty ;\n    rdfs:label \"longitude\"@en ;\n    rdfs:comment \"This data property has been deprecated. See hasGeo\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    owl:deprecated true .\n\n:mailer a owl:DatatypeProperty ;\n    rdfs:label \"mailer\"@en ;\n    rdfs:comment \"This data property has been deprecated\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    owl:deprecated true .\n\n:note a owl:DatatypeProperty ;\n    rdfs:label \"note\"@en ;\n    rdfs:comment \"A note associated with the object\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    rdfs:range xsd:string .\n\n:org a owl:ObjectProperty ;\n    rdfs:label \"organization\"@en ;\n    rdfs:comment \"This object property has been mapped. Use the organization-name data property.\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    owl:equivalentProperty :organization-name .\n\n:organization-unit a owl:DatatypeProperty ;\n    rdfs:label \"organizational unit name\"@en ;\n    rdfs:comment \"To specify the organizational unit name associated with the object\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    rdfs:range xsd:string ;\n    rdfs:subPropertyOf :organization-name .\n\n:post-office-box a owl:DatatypeProperty ;\n    rdfs:label \"post office box\"@en ;\n    rdfs:comment \"This data property has been deprecated\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    owl:deprecated true .\n\n:prodid a owl:DatatypeProperty ;\n    rdfs:label \"product id\"@en ;\n    rdfs:comment \"To specify the identifier for the product that created the object\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    rdfs:range xsd:string .\n\n:rev a owl:DatatypeProperty ;\n    rdfs:label \"revision\"@en ;\n    rdfs:comment \"To specify revision information about the object\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    rdfs:range xsd:dateTime .\n\n:role a owl:DatatypeProperty ;\n    rdfs:label \"role\"@en ;\n    rdfs:comment \"To specify the function or part played in a particular situation by the object\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    rdfs:range xsd:string .\n\n:sort-string a owl:DatatypeProperty ;\n    rdfs:label \"sort as\"@en ;\n    rdfs:comment \"To specify the string to be used for national-language-specific sorting. Used as a property parameter only.\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    rdfs:range xsd:string .\n\n:title a owl:DatatypeProperty ;\n    rdfs:label \"title\"@en ;\n    rdfs:comment \"To specify the position or job of the object\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    rdfs:range xsd:string .\n\n:tz a owl:DatatypeProperty ;\n    rdfs:label \"time zone\"@en ;\n    rdfs:comment \"To indicate time zone information that is specific to the object. May also be used as a property parameter.\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    rdfs:range xsd:string .\n\n:value a owl:DatatypeProperty ;\n    rdfs:label \"value\"@en ;\n    rdfs:comment \"Used to indicate the literal value of a data property that requires property parameters\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> .\n\n:Address a owl:Class ;\n    rdfs:label \"Address\"@en ;\n    rdfs:comment \"To specify the components of the delivery address for the  object\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    owl:equivalentClass [ a owl:Class ;\n            owl:unionOf ( [ a owl:Class ;\n                        owl:intersectionOf ( [ a owl:Restriction ;\n                                    owl:onProperty :country-name ;\n                                    owl:someValuesFrom xsd:string ] [ a owl:Restriction ;\n                                    owl:maxCardinality \"1\"^^xsd:nonNegativeInteger ;\n                                    owl:onProperty :country-name ] ) ] [ a owl:Class ;\n                        owl:intersectionOf ( [ a owl:Restriction ;\n                                    owl:onProperty :locality ;\n                                    owl:someValuesFrom xsd:string ] [ a owl:Restriction ;\n                                    owl:maxCardinality \"1\"^^xsd:nonNegativeInteger ;\n                                    owl:onProperty :locality ] ) ] [ a owl:Class ;\n                        owl:intersectionOf ( [ a owl:Restriction ;\n                                    owl:onProperty :postal-code ;\n                                    owl:someValuesFrom xsd:string ] [ a owl:Restriction ;\n                                    owl:maxCardinality \"1\"^^xsd:nonNegativeInteger ;\n                                    owl:onProperty :postal-code ] ) ] [ a owl:Class ;\n                        owl:intersectionOf ( [ a owl:Restriction ;\n                                    owl:onProperty :region ;\n                                    owl:someValuesFrom xsd:string ] [ a owl:Restriction ;\n                                    owl:maxCardinality \"1\"^^xsd:nonNegativeInteger ;\n                                    owl:onProperty :region ] ) ] [ a owl:Class ;\n                        owl:intersectionOf ( [ a owl:Restriction ;\n                                    owl:onProperty :street-address ;\n                                    owl:someValuesFrom xsd:string ] [ a owl:Restriction ;\n                                    owl:maxCardinality \"1\"^^xsd:nonNegativeInteger ;\n                                    owl:onProperty :street-address ] ) ] ) ] .\n\n:Email a owl:Class ;\n    rdfs:label \"Email\"@en ;\n    rdfs:comment \"To specify the electronic mail address for communication with the object the vCard represents. Use the hasEmail object property.\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    owl:deprecated true .\n\n:Group a owl:Class ;\n    rdfs:label \"Group\"@en ;\n    rdfs:comment \"Object representing a group of persons or entities.  A group object will usually contain hasMember properties to specify the members of the group.\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    rdfs:subClassOf :Kind ;\n    owl:disjointWith :Individual,\n        :Location,\n        :Organization ;\n    owl:equivalentClass [ a owl:Class ;\n            owl:intersectionOf ( [ a owl:Restriction ;\n                        owl:onProperty :hasMember ;\n                        owl:someValuesFrom :Kind ] [ a owl:Restriction ;\n                        owl:minQualifiedCardinality \"1\"^^xsd:nonNegativeInteger ;\n                        owl:onClass :Kind ;\n                        owl:onProperty :hasMember ] ) ] .\n\n:Individual a owl:Class ;\n    rdfs:label \"Individual\"@en ;\n    rdfs:comment \"An object representing a single person or entity\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    rdfs:subClassOf :Kind ;\n    owl:disjointWith :Location,\n        :Organization .\n\n:Name a owl:Class ;\n    rdfs:label \"Name\"@en ;\n    rdfs:comment \"To specify the components of the name of the object\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    owl:equivalentClass [ a owl:Class ;\n            owl:unionOf ( [ a owl:Class ;\n                        owl:intersectionOf ( [ a owl:Restriction ;\n                                    owl:onProperty :additional-name ;\n                                    owl:someValuesFrom xsd:string ] [ a owl:Restriction ;\n                                    owl:minCardinality \"0\"^^xsd:nonNegativeInteger ;\n                                    owl:onProperty :additional-name ] ) ] [ a owl:Class ;\n                        owl:intersectionOf ( [ a owl:Restriction ;\n                                    owl:onProperty :family-name ;\n                                    owl:someValuesFrom xsd:string ] [ a owl:Restriction ;\n                                    owl:maxCardinality \"1\"^^xsd:nonNegativeInteger ;\n                                    owl:onProperty :family-name ] ) ] [ a owl:Class ;\n                        owl:intersectionOf ( [ a owl:Restriction ;\n                                    owl:onProperty :given-name ;\n                                    owl:someValuesFrom xsd:string ] [ a owl:Restriction ;\n                                    owl:maxCardinality \"1\"^^xsd:nonNegativeInteger ;\n                                    owl:onProperty :given-name ] ) ] [ a owl:Class ;\n                        owl:intersectionOf ( [ a owl:Restriction ;\n                                    owl:onProperty :honorific-prefix ;\n                                    owl:someValuesFrom xsd:string ] [ a owl:Restriction ;\n                                    owl:minCardinality \"0\"^^xsd:nonNegativeInteger ;\n                                    owl:onProperty :honorific-prefix ] ) ] [ a owl:Class ;\n                        owl:intersectionOf ( [ a owl:Restriction ;\n                                    owl:onProperty :honorific-suffix ;\n                                    owl:someValuesFrom xsd:string ] [ a owl:Restriction ;\n                                    owl:minCardinality \"0\"^^xsd:nonNegativeInteger ;\n                                    owl:onProperty :honorific-suffix ] ) ] ) ] .\n\n:VCard a owl:Class ;\n    rdfs:label \"VCard\"@en ;\n    rdfs:comment \"The vCard class is  equivalent to the new Kind class, which is the parent for the four explicit types of vCards (Individual, Organization, Location, Group)\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    owl:equivalentClass :Kind .\n\n:fn a owl:DatatypeProperty ;\n    rdfs:label \"formatted name\"@en ;\n    rdfs:comment \"The formatted text corresponding to the name of the object\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    rdfs:range xsd:string .\n\n:hasAddress a owl:ObjectProperty ;\n    rdfs:label \"has address\"@en ;\n    rdfs:comment \"To specify the components of the delivery address for the object\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    rdfs:range :Address .\n\n:hasEmail a owl:ObjectProperty ;\n    rdfs:label \"has email\"@en ;\n    rdfs:comment \"To specify the electronic mail address for communication with the object\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    rdfs:range :Email .\n\n:hasGeo a owl:ObjectProperty ;\n    rdfs:label \"has geo\"@en ;\n    rdfs:comment \"To specify information related to the global positioning of the object. May also be used as a property parameter.\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> .\n\n:hasKey a owl:ObjectProperty ;\n    rdfs:label \"has key\"@en ;\n    rdfs:comment \"To specify a public key or authentication certificate associated with the object\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    owl:equivalentProperty :key .\n\n:hasLogo a owl:ObjectProperty ;\n    rdfs:label \"has logo\"@en ;\n    rdfs:comment \"To specify a graphic image of a logo associated with the object \"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    owl:equivalentProperty :logo .\n\n:hasName a owl:ObjectProperty ;\n    rdfs:label \"has name\"@en ;\n    rdfs:comment \"To specify the components of the name of the object\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    rdfs:range :Name ;\n    owl:equivalentProperty :n .\n\n:hasPhoto a owl:ObjectProperty ;\n    rdfs:label \"has photo\"@en ;\n    rdfs:comment \"To specify an image or photograph information that annotates some aspect of the object\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    owl:equivalentProperty :photo .\n\n:hasSound a owl:ObjectProperty ;\n    rdfs:label \"has sound\"@en ;\n    rdfs:comment \"To specify a digital sound content information that annotates some aspect of the object\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    owl:equivalentProperty :sound .\n\n:hasTelephone a owl:ObjectProperty ;\n    rdfs:label \"has telephone\"@en ;\n    rdfs:comment \"To specify the telephone number for telephony communication with the object\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    owl:equivalentProperty :tel .\n\n:hasURL a owl:ObjectProperty ;\n    rdfs:label \"has url\"@en ;\n    rdfs:comment \"To specify a uniform resource locator associated with the object\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    owl:equivalentProperty :url .\n\n:key a owl:ObjectProperty ;\n    rdfs:label \"key\"@en ;\n    rdfs:comment \"This object property has been mapped\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    owl:equivalentProperty :hasKey .\n\n:logo a owl:ObjectProperty ;\n    rdfs:label \"logo\"@en ;\n    rdfs:comment \"This object property has been mapped\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    owl:equivalentProperty :hasLogo .\n\n:n a owl:ObjectProperty ;\n    rdfs:label \"name\"@en ;\n    rdfs:comment \"This object property has been mapped\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    owl:equivalentProperty :hasName .\n\n:nickname a owl:DatatypeProperty ;\n    rdfs:label \"nickname\"@en ;\n    rdfs:comment \"The nick name associated with the object\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    rdfs:range xsd:string .\n\n:photo a owl:ObjectProperty ;\n    rdfs:label \"photo\"@en ;\n    rdfs:comment \"This object property has been mapped\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    owl:equivalentProperty :hasPhoto .\n\n:sound a owl:ObjectProperty ;\n    rdfs:label \"sound\"@en ;\n    rdfs:comment \"This object property has been mapped\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    owl:equivalentProperty :hasSound .\n\n:tel a owl:ObjectProperty ;\n    rdfs:label \"telephone\"@en ;\n    rdfs:comment \"This object property has been mapped\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    owl:equivalentProperty :hasTelephone .\n\n:url a owl:ObjectProperty ;\n    rdfs:label \"url\"@en ;\n    rdfs:comment \"This object property has been mapped\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    owl:equivalentProperty :hasURL .\n\n:Location a owl:Class ;\n    rdfs:label \"Location\"@en ;\n    rdfs:comment \"An object representing a named geographical place\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    rdfs:subClassOf :Kind ;\n    owl:disjointWith :Organization .\n\n:additional-name a owl:DatatypeProperty ;\n    rdfs:label \"additional name\"@en ;\n    rdfs:comment \"The additional name associated with the object\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    rdfs:range xsd:string .\n\n:country-name a owl:DatatypeProperty ;\n    rdfs:label \"country name\"@en ;\n    rdfs:comment \"The country name associated with the address of the object\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    rdfs:range xsd:string .\n\n:family-name a owl:DatatypeProperty ;\n    rdfs:label \"family name\"@en ;\n    rdfs:comment \"The family name associated with the object\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    rdfs:range xsd:string .\n\n:given-name a owl:DatatypeProperty ;\n    rdfs:label \"given name\"@en ;\n    rdfs:comment \"The given name associated with the object\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    rdfs:range xsd:string .\n\n:hasMember a owl:ObjectProperty ;\n    rdfs:label \"has member\"@en ;\n    rdfs:comment \"To include a member in the group this object represents. (This property can only be used by Group individuals)\"@en ;\n    rdfs:domain :Group ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    rdfs:range :Kind .\n\n:honorific-prefix a owl:DatatypeProperty ;\n    rdfs:label \"honorific prefix\"@en ;\n    rdfs:comment \"The honorific prefix of the name associated with the object\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    rdfs:range xsd:string .\n\n:honorific-suffix a owl:DatatypeProperty ;\n    rdfs:label \"honorific suffix\"@en ;\n    rdfs:comment \"The honorific suffix of the name associated with the object\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    rdfs:range xsd:string .\n\n:locality a owl:DatatypeProperty ;\n    rdfs:label \"locality\"@en ;\n    rdfs:comment \"The locality (e.g. city or town) associated with the address of the object\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    rdfs:range xsd:string .\n\n:organization-name a owl:DatatypeProperty ;\n    rdfs:label \"organization name\"@en ;\n    rdfs:comment \"To specify the organizational name associated with the object\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    rdfs:range xsd:string .\n\n:postal-code a owl:DatatypeProperty ;\n    rdfs:label \"postal code\"@en ;\n    rdfs:comment \"The postal code associated with the address of the object\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    rdfs:range xsd:string .\n\n:region a owl:DatatypeProperty ;\n    rdfs:label \"region\"@en ;\n    rdfs:comment \"The region (e.g. state or province) associated with the address of the object\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    rdfs:range xsd:string .\n\n:street-address a owl:DatatypeProperty ;\n    rdfs:label \"street address\"@en ;\n    rdfs:comment \"The street address associated with the address of the object\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    rdfs:range xsd:string .\n\n:Organization a owl:Class ;\n    rdfs:label \"Organization\"@en ;\n    rdfs:comment \"\"\"An object representing an organization.  An organization is a single entity, and might represent a business or government, a department or division within a business or government, a club, an association, or the like.\n\"\"\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    rdfs:subClassOf :Kind .\n\n:Gender a owl:Class ;\n    rdfs:label \"Gender\"@en ;\n    rdfs:comment \"Used for gender codes. The URI of the gender code must be used as the value for Gender.\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> .\n\n:Kind a owl:Class ;\n    rdfs:label \"Kind\"@en ;\n    rdfs:comment \"The parent class for all objects\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> ;\n    owl:equivalentClass [ a owl:Restriction ;\n            owl:minQualifiedCardinality \"1\"^^xsd:nonNegativeInteger ;\n            owl:onDataRange xsd:string ;\n            owl:onProperty :fn ],\n        :VCard .\n\n:Type a owl:Class ;\n    rdfs:label \"Type\"@en ;\n    rdfs:comment \"Used for type codes. The URI of the type code must be used as the value for Type.\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> .\n\n:TelephoneType a owl:Class ;\n    rdfs:label \"Phone\"@en ;\n    rdfs:comment \"Used for telephone type codes. The URI of the telephone type code must be used as the value for the Telephone Type.\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> .\n\n:RelatedType a owl:Class ;\n    rdfs:label \"Relation Type\"@en ;\n    rdfs:comment \"Used for relation type codes. The URI of the relation type code must be used as the value for the Relation Type.\"@en ;\n    rdfs:isDefinedBy <http://www.w3.org/2006/vcard/ns> .\n\n<http://www.w3.org/2006/vcard/ns> a owl:Ontology ;\n    rdfs:label \"Ontology for vCard\"@en ;\n    rdfs:comment \"Ontology for vCard based on RFC6350\"@en ;\n    owl:versionInfo \"Final\"@en .\n\n\n";
// EXTERNAL MODULE: ./node_modules/css-loader/dist/cjs.js!./src/styles/individual.css
var individual = __webpack_require__(479);
;// ./src/styles/individual.css

      
      
      
      
      
      
      
      
      

var individual_options = {};

individual_options.styleTagTransform = (styleTagTransform_default());
individual_options.setAttributes = (setAttributesWithoutAttributes_default());
individual_options.insert = insertBySelector_default().bind(null, "head");
individual_options.domAPI = (styleDomAPI_default());
individual_options.insertStyleElement = (insertStyleElement_default());

var individual_update = injectStylesIntoStyleTag_default()(individual/* default */.A, individual_options);




       /* harmony default export */ const styles_individual = (individual/* default */.A && individual/* default */.A.locals ? individual/* default */.A.locals : undefined);

// EXTERNAL MODULE: ./node_modules/css-loader/dist/cjs.js!./src/styles/contactsRDFFormsEnforced.css
var contactsRDFFormsEnforced = __webpack_require__(686);
;// ./src/styles/contactsRDFFormsEnforced.css

      
      
      
      
      
      
      
      
      

var contactsRDFFormsEnforced_options = {};

contactsRDFFormsEnforced_options.styleTagTransform = (styleTagTransform_default());
contactsRDFFormsEnforced_options.setAttributes = (setAttributesWithoutAttributes_default());
contactsRDFFormsEnforced_options.insert = insertBySelector_default().bind(null, "head");
contactsRDFFormsEnforced_options.domAPI = (styleDomAPI_default());
contactsRDFFormsEnforced_options.insertStyleElement = (insertStyleElement_default());

var contactsRDFFormsEnforced_update = injectStylesIntoStyleTag_default()(contactsRDFFormsEnforced/* default */.A, contactsRDFFormsEnforced_options);




       /* harmony default export */ const styles_contactsRDFFormsEnforced = (contactsRDFFormsEnforced/* default */.A && contactsRDFFormsEnforced/* default */.A.locals ? contactsRDFFormsEnforced/* default */.A.locals : undefined);

;// ./src/rdfFormsHelper.js



const baseUri = 'https://solidos.github.io/contacts-pane/src/ontology/'

function renderForm (
  div,
  subject, // Represents the RDF that fills the form
  formSource, // The imported form Turtle source
  formName,   // The name of the form file (e.g., 'socialMedia.ttl')
  store,
  dom,
  editableProfile,
  whichForm) {
  // --- Form resource setup ---
  const formUri = baseUri + formName                   // Full URI to the form file
  const exactForm = whichForm || 'this'                // If there are more 'a ui:Form' elements in a form file
  const formThis = (0,external_commonjs_rdflib_commonjs2_rdflib_amd_rdflib_root_$rdf_.Namespace)(formUri + '#')(exactForm) // NamedNode for #this in the form

  loadDocument(store, formSource, formName, formUri)

  external_commonjs_solid_ui_commonjs2_solid_ui_amd_solid_ui_root_UI_.widgets.appendForm(
    dom,
    div,
    {},
    subject,
    formThis,
    editableProfile,
    (ok, mes) => {
      if (!ok) external_commonjs_solid_ui_commonjs2_solid_ui_amd_solid_ui_root_UI_.widgets.errorMessageBlock(dom, mes)
    }
  )
} // renderForm

// we need to load into the store some additional information about Social Media accounts
function loadDocument (
  store,
  documentSource,
  documentName,
  documentURI
) {
  const finalDocumentUri = documentURI || baseUri + documentName   // Full URI to the file
  const document = (0,external_commonjs_rdflib_commonjs2_rdflib_amd_rdflib_root_$rdf_.sym)(finalDocumentUri)      // rdflib NamedNode for the document

  if (!store.holds(undefined, undefined, undefined, document)) {
    // we are using the social media form because it contains the information we need
    // the form can be used for both use cases: create UI  for edit and render UI for display
    (0,external_commonjs_rdflib_commonjs2_rdflib_amd_rdflib_root_$rdf_.parse)(documentSource, store, finalDocumentUri, 'text/turtle', () => null) // Load doc directly
  }
}

;// ./src/individual.js













const individual_ns = external_commonjs_solid_ui_commonjs2_solid_ui_amd_solid_ui_root_UI_.ns
const individual_kb = external_commonjs_solid_logic_commonjs2_solid_logic_amd_solid_logic_root_SolidLogic_.store

const formsName = 'individualAndOrganizationForm.ttl' // The name of the form file
const vcardName = 'vcard.ttl' // The name of the vcard file

async function renderIndividual (dom, div, subject, dataBrowserContext) {
  const t = individual_kb.findTypeURIs(subject)
  const isOrganization = !!(t[individual_ns.vcard('Organization').uri] || t[individual_ns.schema('Organization').uri])
  const editable = individual_kb.updater.editable(subject.doc().uri, individual_kb)

  // We load the local form document
  loadDocument(individual_kb, individualAndOrganizationForm_namespaceObject, formsName)

  // We need to make sure VCARD ontology is loaded in the store
  const vcardOntUri = external_commonjs_solid_ui_commonjs2_solid_ui_amd_solid_ui_root_UI_.ns.vcard('Type').doc().uri // URI to VCARD
  loadDocument(individual_kb, vcard_namespaceObject, vcardName, vcardOntUri)

  try {
    await individual_kb.fetcher.load(subject.doc())
  } catch (err) {
    error('Error loading profile card. Stack: ' + err)
    throw new Error('Failed to load profile card.')
  } // end of try catch on load

  div.classList.add('individualPane')

  external_commonjs_solid_logic_commonjs2_solid_logic_amd_solid_logic_root_SolidLogic_.authn.checkUser() // kick off async operation @@@ use async version

  div.appendChild(renderMugshotGallery(dom, subject))

  const whichForm = isOrganization ? 'organizationForm' : 'individualForm'

  renderForm(div, subject, individualAndOrganizationForm_namespaceObject, formsName, external_commonjs_solid_logic_commonjs2_solid_logic_amd_solid_logic_root_SolidLogic_.store, dom, subject.doc(), whichForm)
  // Improve keyboard navigation: prevent tabbing into label links created by rdflib/solid-ui forms
  skipLabelsFromTabbing(div)

  // forward list element from context if available; some callers (such as
  // the contacts pane) attach `ulPeople` so that group membership control can
  // refresh the master list when a membership is removed.
  if (!isAWebID(subject)) {
    div.appendChild(await renderGroupMemberships(
      subject,
      dataBrowserContext,
      dataBrowserContext.ulPeople
    ))
  }

  if (external_commonjs_solid_logic_commonjs2_solid_logic_amd_solid_logic_root_SolidLogic_.authn.currentUser()) {
    // Allow to attach documents etc to the profile card
    // creates a
    const h3 = div.appendChild(dom.createElement('h3'))
    h3.textContent = 'Attach a link to any file'
    h3.classList.add('contactPanedHeading')

    external_commonjs_solid_ui_commonjs2_solid_ui_amd_solid_ui_root_UI_.widgets.attachmentList(dom, subject, div, {
      modify: editable
      // promptIcon: UI.icons.iconBase +  'noun_681601.svg',
      // predicate: default <http://www.w3.org/2005/01/wf/flow#attachment>
    })
  }

  if (isOrganization) {
    div.appendChild(await renderPublicIdControl(subject, dataBrowserContext))
  } else if (!isAWebID(subject)) {
    // Only render WebID control for a contact and not. WebID.
    div.appendChild(await renderWebIdControl(subject, dataBrowserContext))
  }
} // renderIndividual

// EXTERNAL MODULE: ./node_modules/css-loader/dist/cjs.js!./src/styles/toolsPane.css
var toolsPane = __webpack_require__(295);
;// ./src/styles/toolsPane.css

      
      
      
      
      
      
      
      
      

var toolsPane_options = {};

toolsPane_options.styleTagTransform = (styleTagTransform_default());
toolsPane_options.setAttributes = (setAttributesWithoutAttributes_default());
toolsPane_options.insert = insertBySelector_default().bind(null, "head");
toolsPane_options.domAPI = (styleDomAPI_default());
toolsPane_options.insertStyleElement = (insertStyleElement_default());

var toolsPane_update = injectStylesIntoStyleTag_default()(toolsPane/* default */.A, toolsPane_options);




       /* harmony default export */ const styles_toolsPane = (toolsPane/* default */.A && toolsPane/* default */.A.locals ? toolsPane/* default */.A.locals : undefined);

;// ./src/toolsPane.js
//  The tools pane is for managing and debugging and maintaining solid contacts databases








const toolsPane_kb = external_commonjs_solid_logic_commonjs2_solid_logic_amd_solid_logic_root_SolidLogic_.store
const toolsPane_ns = external_commonjs_solid_ui_commonjs2_solid_ui_amd_solid_ui_root_UI_.ns
const VCARD = toolsPane_ns.vcard

let toolsPane_book
let toolsPane_selectedGroups
let logSpace
let refreshGroupsFn

function toolsPane_toolsPane (
  selectAllGroups,
  selectedGroupsParam,
  groupsMainTable,
  bookParam,
  dataBrowserContext,
  me,
  refreshGroups
) {
  toolsPane_book = bookParam
  toolsPane_selectedGroups = selectedGroupsParam
  refreshGroupsFn = refreshGroups
  const dom = dataBrowserContext.dom

  const pane = dom.createElement('div')
  pane.classList.add('toolsPane')

  const settingsHeader = dom.createElement('h3')
  settingsHeader.textContent = 'Tools'
  pane.appendChild(settingsHeader)

  const divStatistics = pane.appendChild(dom.createElement('div'))
  divStatistics.classList.add('statsLog')

  logSpace = divStatistics.appendChild(dom.createElement('pre'))
  logSpace.setAttribute('id', 'logSpace')

  const buttonsContainer = pane.appendChild(dom.createElement('div'))
  buttonsContainer.classList.add('toolsButtonsContainer')

  function setActiveButton (activeBtn) {
    const wasActive = activeBtn.classList.contains('btn-primary')
    buttonsContainer.querySelectorAll('button').forEach(btn => {
      btn.classList.remove('btn-primary', 'toolsButton--loading', 'toolsButton--error', 'toolsButton--success')
      btn.classList.add('btn-secondary')
    })
    if (!wasActive) {
      activeBtn.classList.remove('btn-secondary')
      activeBtn.classList.add('btn-primary')
    }
  }

  const loadIndexButton = buttonsContainer.appendChild(dom.createElement('button'))
  loadIndexButton.textContent = 'Load main index'
  loadIndexButton.classList.add('actionButton', 'btn-secondary', 'action-button-focus')
  loadIndexButton.addEventListener('click', () => {
    setActiveButton(loadIndexButton)
    logSpace.textContent = ''
    loadIndexHandler(loadIndexButton, logSpace)
  })

  const statButton = buttonsContainer.appendChild(dom.createElement('button'))
  statButton.textContent = 'Statistics'
  statButton.classList.add('actionButton', 'btn-secondary', 'action-button-focus')
  statButton.addEventListener('click', () => {
    setActiveButton(statButton)
    logSpace.textContent = ''
    stats(logSpace)
  })

  const checkAccessButton = buttonsContainer.appendChild(dom.createElement('button'))
  checkAccessButton.textContent =
    'Check individual contact access of selected groups'
  checkAccessButton.classList.add('actionButton', 'btn-secondary', 'action-button-focus')
  checkAccessButton.addEventListener('click', (event) => {
    setActiveButton(checkAccessButton)
    logSpace.textContent = ''
    checkAcces(event)
  })

  // DUPLICATES CHECK
  const checkDuplicates = buttonsContainer.appendChild(dom.createElement('button'))
  checkDuplicates.textContent = 'Find duplicate contacts'
  checkDuplicates.classList.add('actionButton', 'btn-secondary', 'action-button-focus')
  checkDuplicates.addEventListener('click', function (_event) {
    setActiveButton(checkDuplicates)
    logSpace.textContent = ''
    const stats = {} // global god context

    stats.book = toolsPane_book
    stats.nameEmailIndex = toolsPane_kb.any(toolsPane_book, toolsPane_ns.vcard('nameEmailIndex'))
    toolsPane_log(logSpace, 'Loading name index...')

    external_commonjs_solid_logic_commonjs2_solid_logic_amd_solid_logic_root_SolidLogic_.store.fetcher.nowOrWhenFetched(
      stats.nameEmailIndex,
      undefined,
      function (_ok, _message) {
        toolsPane_log(logSpace, 'Loaded name index.')

        stats.cards = []
        stats.duplicates = []
        stats.definitive = []
        stats.nameless = []

        stats.exactDuplicates = []
        stats.nameOnlyDuplicates = []

        stats.uniquesSet = []
        stats.groupProblems = []

        // Erase one card and all its files  -> (err)
        //
        /*
        function eraseOne (card) {
          return new Promise(function (resolve, reject) {
            function removeFromMainIndex () {
              var indexBit = kb.connectedStatements(card, stats.nameEmailIndex)
              log(logSpace, 'Bits of the name index file:' + indexBit)
              log(logSpace, 'Patching main index file...')
              kb.updater.update(indexBit, [], function (uri, ok, body) {
                if (ok) {
                  log(logSpace, 'Success')
                  resolve(null)
                } else {
                  log(logSpace, 'Error patching index file! ' + body)
                  reject('Error patching index file! ' + body)
                }
              })
            }
            var filesToDelete = [ card.doc() ]
            var photos = kb.each(card, ns.vcard('hasPhoto')) // could be > 1
            if (photos.length) {
              filesToDelete = filesToDelete.concat(photos)
            }
            filesToDelete.push(card.dir()) // the folder last
            log(logSpace, 'Files to delete: ' + filesToDelete)
            if (!await confirmDialog('DELETE card ' + card.dir() + ' for "' + kb.any(card, VCARD('fn')) + '", with ' + kb.each(card).length + 'statements?')) {
              return resolve('Cancelled by user')
            }

            function deleteNextFile () {
              var resource = filesToDelete.shift()
              if (!resource) {
                log(logSpace, 'All deleted')
                removeFromMainIndex()
                resolve()
              }
              log(logSpace, 'Deleting ... ' + resource)
              kb.fetcher.delete(resource)
                .then(function () {
                  log(logSpace, 'Deleted ok: ' + resource)
                  deleteNextFile()
                })
                .catch(function (e) {
                  var err = '*** ERROR deleting ' + resource + ': ' + e
                  log(logSpace, err)
                  if (await confirmDialog('Patch out index file for card ' + card.dir() + ' EVEN THOUGH card DELETE errors?')) {
                    removeFromMainIndex()
                  } else {
                    reject(err)
                  }
                })
            }
            deleteNextFile()
          }) // Promise
        } // erase one
*/
        //   Check actual records to see which are exact matches - slow
        stats.nameDupLog = toolsPane_kb.sym(toolsPane_book.dir().uri + 'dedup-nameDupLog.ttl')
        stats.exactDupLog = toolsPane_kb.sym(toolsPane_book.dir().uri + 'dedup-exactDupLog.ttl')
        /*
        function checkOne (card) {
          return new Promise(function (resolve, reject) {
            var name = kb.anyValue(card, ns.vcard('fn'))
            var other = stats.definitive[name]
            kb.fetcher.load([card, other]).then(function (xhrs) {
              var exclude = {}
              exclude[ns.vcard('hasUID').uri] = true
              exclude[ns.dc('created').uri] = true
              exclude[ns.dc('modified').uri] = true
              function filtered (x) {
                return kb.statementsMatching(null, null, null, x.doc()).filter(function (st) {
                  return !exclude[st.predicate.uri]
                })
              }
              var desc = filtered(card)
              var desc2 = filtered(other)
              // var desc = connectedStatements(card, card.doc(), exclude)
              // var desc2 = connectedStatements(other, other.doc(), exclude)
              if (desc.length !== desc2.length) {
                log(logSpace, 'CARDS to NOT match lengths ')
                stats.nameOnlyDuplicates.push(card)
                return resolve(false)
              }
              if (!desc.length) {
                log(logSpace, '@@@@@@  Zero length ')
                stats.nameOnlyDuplicates.push(card)
                return resolve(false)
              }
              // //////// Compare the two
              // Cheat: serialize and compare
              // var cardText = $rdf.serialize(card.doc(), kb, card.doc().uri, 'text/turtle')
              // var otherText = $rdf.serialize(other.doc(), kb, other.doc().uri, 'text/turtle')
              var cardText = (new $rdf.Serializer(kb)).setBase(card.doc().uri).statementsToN3(desc)
              var otherText = (new $rdf.Serializer(kb)).setBase(other.doc().uri).statementsToN3(desc2)
              //
              //              log('Name: ' + name + ', statements: ' + desc.length)
              //              log('___________________________________________')
              //              log('KEEPING: ' + other.doc() + '\n' + cardText)
              //              log('___________________________________________')
              //              log('DELETING: '+ card.doc() + '\n' + otherText)
              //              log('___________________________________________')
              //
              if (cardText !== otherText) {
                log(logSpace, 'Texts differ')
                stats.nameOnlyDuplicates.push(card)
                return resolve(false)
              }
              var cardGroups = kb.each(null, ns.vcard('hasMember'), card)
              var otherGroups = kb.each(null, ns.vcard('hasMember'), other)
              for (var j = 0; j < cardGroups.length; j++) {
                var found = false
                for (var k = 0; k < otherGroups.length; k++) {
                  if (otherGroups[k].sameTerm(cardGroups[j])) { found = true }
                }
                if (!found) {
                  log(logSpace, 'This one groups: ' + cardGroups)
                  log(logSpace, 'Other one groups: ' + otherGroups)
                  log(logSpace, 'Cant delete this one because it has a group, ' + cardGroups[j] + ', which the other does not.')
                  stats.nameOnlyDuplicates.push(card)
                  return resolve(false)
                }
              }
              debug.log('Group check done -- exact duplicate: ' + card)
              stats.exactDuplicates.push(card)
              resolve(true)
            }).catch(function (e) {
              log(logSpace, 'Cant load a card! ' + [card, other] + ': ' + e)
              stats.nameOnlyDuplicates.push(card)
              resolve(false)
            // if (await confirmDialog('Patch out index file for card ' + card.dir() + ' EVEN THOUGH card READ errors?')){
            //  removeFromMainIndex()
            // }
            })
          })
        } // checkOne
*/
        stats.nameOnlyErrors = []
        stats.nameLessZeroData = []
        stats.nameLessIndex = []
        stats.namelessUniques = []
        stats.nameOnlyDuplicatesGroupDiff = []

        function checkOneNameless (card) {
          return new Promise(function (resolve) {
            toolsPane_kb.fetcher
              .load(card)
              .then(function (_xhr) {
                toolsPane_log(logSpace, ' Nameless check ' + card)
                const exclude = {}
                exclude[toolsPane_ns.vcard('hasUID').uri] = true
                exclude[toolsPane_ns.dc('created').uri] = true
                exclude[toolsPane_ns.dc('modified').uri] = true
                function filtered (x) {
                  return toolsPane_kb
                    .statementsMatching(null, null, null, x.doc())
                    .filter(function (st) {
                      return !exclude[st.predicate.uri]
                    })
                }

                const desc = filtered(card)
                // var desc = connectedStatements(card, card.doc(), exclude)
                // var desc2 = connectedStatements(other, other.doc(), exclude)
                if (!desc.length) {
                  toolsPane_log(logSpace, '  Zero length ' + card)
                  stats.nameLessZeroData.push(card)
                  return resolve(false)
                }
                // Compare the two
                // Cheat: serialize and compare
                // var cardText = $rdf.serialize(card.doc(), kb, card.doc().uri, 'text/turtle')
                // var otherText = $rdf.serialize(other.doc(), kb, other.doc().uri, 'text/turtle')
                const cardText = new external_commonjs_rdflib_commonjs2_rdflib_amd_rdflib_root_$rdf_.Serializer(toolsPane_kb)
                  .setBase(card.doc().uri)
                  .statementsToN3(desc)
                const other = stats.nameLessIndex[cardText]
                if (other) {
                  toolsPane_log(logSpace, '  Matches with ' + other)
                  // alain not sure it works we may need to concat with 'sameAs' group.doc (.map(st => st.why))
                  const cardGroups = toolsPane_kb.each(null, toolsPane_ns.vcard('hasMember'), card)
                  const otherGroups = toolsPane_kb.each(null, toolsPane_ns.vcard('hasMember'), other)
                  for (let j = 0; j < cardGroups.length; j++) {
                    let found = false
                    for (let k = 0; k < otherGroups.length; k++) {
                      if (otherGroups[k].sameTerm(cardGroups[j])) found = true
                    }
                    if (!found) {
                      toolsPane_log(logSpace, 'This one groups: ' + cardGroups)
                      toolsPane_log(logSpace, 'Other one groups: ' + otherGroups)
                      toolsPane_log(
                        logSpace,
                        'Cant skip this one because it has a group, ' +
                          cardGroups[j] +
                          ', which the other does not.'
                      )
                      stats.nameOnlyDuplicatesGroupDiff.push(card)
                      return resolve(false)
                    }
                  }
                  log('Group check done -- exact duplicate: ' + card)
                } else {
                  toolsPane_log(logSpace, 'First nameless like: ' + card.doc())
                  toolsPane_log(logSpace, '___________________________________________')
                  toolsPane_log(logSpace, cardText)
                  toolsPane_log(logSpace, '___________________________________________')
                  stats.nameLessIndex[cardText] = card
                  stats.namelessUniques.push(card)
                }
                resolve(true)
              })
              .catch(function (e) {
                toolsPane_log(logSpace, 'Cant load a nameless card!: ' + e)
                stats.nameOnlyErrors.push(card)
                resolve(false)
              })
          })
        } // checkOneNameless

        function checkAllNameless () {
          stats.namelessToCheck =
            stats.namelessToCheck || stats.nameless.slice()
          toolsPane_log(logSpace, 'Nameless check left: ' + stats.namelessToCheck.length)
          return new Promise(function (resolve) {
            const x = stats.namelessToCheck.shift()
            if (!x) {
              toolsPane_log(logSpace, 'namelessUniques: ' + stats.namelessUniques.length)
              toolsPane_log(logSpace, 'namelessUniques: ' + stats.namelessUniques)
              if (stats.namelessUniques.length > 0) {
                const msg = dom.createElement('p')
                msg.textContent = 'Add all ' + stats.namelessUniques.length + ' nameless contacts to the rescued set?'
                divStatistics.appendChild(msg)
                const confirmButton = external_commonjs_solid_ui_commonjs2_solid_ui_amd_solid_ui_root_UI_.widgets.continueButton(dom, function () {
                  stats.uniques = stats.uniques.concat(stats.namelessUniques)
                  for (let k = 0; k < stats.namelessUniques.length; k++) {
                    stats.uniqueSet[stats.namelessUniques[k].uri] = true
                  }
                  msg.remove()
                  confirmButton.remove()
                  resolve(true)
                })
                divStatistics.appendChild(confirmButton)
              } else {
                return resolve(true)
              }
              return
            }
            checkOneNameless(x).then(function (exact) {
              toolsPane_log(logSpace, '    Nameless check returns ' + exact)
              checkAllNameless() // loop
            })
          })
        }

        function checkGroupMembers () {
          return new Promise(function (resolve) {
            // var inUniques = 0
            toolsPane_log(logSpace, 'Groups loaded')
            for (let i = 0; i < stats.uniques.length; i++) {
              stats.uniquesSet[stats.uniques[i].uri] = true
            }
            stats.groupMembers = []
            toolsPane_kb.each(null, toolsPane_ns.vcard('hasMember'))
              .forEach(group => { stats.groupMembers = stats.groupMembers.concat(groupMembers(toolsPane_kb, group)) })
            toolsPane_log(logSpace, '  Naive group members ' + stats.groupMembers.length)
            stats.groupMemberSet = []
            for (let j = 0; j < stats.groupMembers.length; j++) {
              stats.groupMemberSet[stats.groupMembers[j].uri] =
                stats.groupMembers[j]
            }
            stats.groupMembers2 = []
            for (const g in stats.groupMemberSet) {
              stats.groupMembers2.push(stats.groupMemberSet[g])
            }
            toolsPane_log(logSpace, '  Compact group members ' + stats.groupMembers2.length)

            // LINT NOTE: Block below disabled to fix 'no-constant-condition' ESLint error. Restore or refactor if needed.
            /*
            if (false) {
              // Don't inspect as seems groups membership is complete
              for (let i = 0; i < stats.groupMembers.length; i++) {
                const card = stats.groupMembers[i]
                if (stats.uniquesSet[card.uri]) {
                  // inUniques += 1
                } else {
                  log(logSpace, '  Not in uniques: ' + card)
                  stats.groupProblems.push(card)
                  if (stats.duplicateSet[card.uri]) {
                    log(logSpace, '    ** IN duplicates alas:' + card)
                  } else {
                    log(logSpace, '   **** WTF?')
                  }
                }
              }
              log(logSpace, 'Problem contacts: ' + stats.groupProblems.length)
            }
            */
            resolve(true)
          })
        } //  checkGroupMembers

        function scanForDuplicates () {
          return new Promise(function (resolve) {
            stats.cards = toolsPane_kb.each(undefined, VCARD('inAddressBook'), stats.book)
            toolsPane_log(logSpace, '' + stats.cards.length + ' total contacts')

            let c, card, name
            for (c = 0; c < stats.cards.length; c++) {
              card = stats.cards[c]
              name = toolsPane_kb.anyValue(card, toolsPane_ns.vcard('fn'))
              if (!name) {
                stats.nameless.push(card)
                continue
              }
              if (stats.definitive[name] === card) {
                // pass
              } else if (stats.definitive[name]) {
                const n = stats.duplicates.length
                if (n < 100 || (n < 1000 && n % 10 === 0) || n % 100 === 0) {
                  // log('' + n + ') Possible duplicate ' + card + ' of: ' + definitive[name])
                }
                stats.duplicates.push(card)
              } else {
                stats.definitive[name] = card
              }
            }

            stats.duplicateSet = []
            for (let i = 0; i < stats.duplicates.length; i++) {
              stats.duplicateSet[stats.duplicates[i].uri] = stats.duplicates[i]
            }
            stats.namelessSet = []
            for (let i = 0; i < stats.nameless.length; i++) {
              stats.namelessSet[stats.nameless[i].uri] = stats.nameless[i]
            }
            stats.uniques = []
            stats.uniqueSet = []
            for (let i = 0; i < stats.cards.length; i++) {
              const uri = stats.cards[i].uri
              if (!stats.duplicateSet[uri] && !stats.namelessSet[uri]) {
                stats.uniques.push(stats.cards[i])
                stats.uniqueSet[uri] = stats.cards[i]
              }
            }
            toolsPane_log(logSpace, 'Uniques: ' + stats.uniques.length)

            toolsPane_log(logSpace, '' + stats.nameless.length + ' nameless contacts.')
            toolsPane_log(
              logSpace,
              '' +
                stats.duplicates.length +
                ' name-duplicate contacts, leaving ' +
                (stats.cards.length - stats.duplicates.length)
            )
            resolve(true)
          })
        }

        // Save a new clean version
        function saveCleanPeople () {
          let cleanPeople

          return Promise.resolve()
            .then(() => {
              cleanPeople = toolsPane_kb.sym(stats.book.dir().uri + 'clean-people.ttl')
              let sts = []
              for (let i = 0; i < stats.uniques.length; i++) {
                sts = sts.concat(
                  toolsPane_kb.connectedStatements(stats.uniques[i], stats.nameEmailIndex)
                )
              }
              const sz = new external_commonjs_rdflib_commonjs2_rdflib_amd_rdflib_root_$rdf_.Serializer(toolsPane_kb).setBase(stats.nameEmailIndex.uri)
              toolsPane_log(logSpace, 'Serializing index of uniques...')
              const data = sz.statementsToN3(sts)

              return toolsPane_kb.fetcher.webOperation('PUT', cleanPeople, {
                data,
                contentType: 'text/turtle'
              })
            })
            .then(function () {
              toolsPane_log(logSpace, 'Done uniques log ' + cleanPeople)
              return true
            })
            .catch(function (e) {
              toolsPane_log(logSpace, 'Error saving uniques: ' + e)
            })
        }

        function saveCleanGroup (g) {
          let cleanGroup

          return Promise.resolve()
            .then(() => {
              const s = g.uri.replace('/Group/', '/NewGroup/')
              cleanGroup = toolsPane_kb.sym(s)
              let sts = []
              for (let i = 0; i < stats.uniques.length; i++) {
                sts = sts.concat(
                  toolsPane_kb.connectedStatements(stats.uniques[i], g.doc())
                )
              }
              const sz = new external_commonjs_rdflib_commonjs2_rdflib_amd_rdflib_root_$rdf_.Serializer(toolsPane_kb).setBase(g.uri)
              toolsPane_log(logSpace, '   Regenerating group of uniques...' + cleanGroup)
              const data = sz.statementsToN3(sts)

              return toolsPane_kb.fetcher.webOperation('PUT', cleanGroup, {
                data,
                contentType: 'text/turtle'
              })
            })
            .then(() => {
              toolsPane_log(logSpace, '     Done uniques group ' + cleanGroup)
              return true
            })
            .catch(e => {
              toolsPane_log(logSpace, 'Error saving : ' + e)
            })
        }

        function saveAllGroups () {
          toolsPane_log(logSpace, 'Saving ALL GROUPS')
          return Promise.all(stats.groupObjects.map(saveCleanGroup))
        }

        const getAndSortGroups = function () {
          let groups = []
          if (stats.book) {
            const books = [stats.book]
            books.forEach(function (book) {
              const gs = book ? toolsPane_kb.each(book, toolsPane_ns.vcard('includesGroup')) : []
              const gs2 = gs.map(function (g) {
                return [book, toolsPane_kb.any(g, toolsPane_ns.vcard('fn')), g]
              })
              groups = groups.concat(gs2)
            })
            groups.sort()
          }
          return groups
        }
        const groups = getAndSortGroups() // Needed?

        stats.groupObjects = groups.map(gstr => gstr[2])
        toolsPane_log(logSpace, 'Loading ' + stats.groupObjects.length + ' groups... ')
        toolsPane_kb.fetcher
          .load(stats.groupObjects)
          .then(scanForDuplicates)
          .then(checkGroupMembers)
          .then(checkAllNameless)
          .then(saveCleanPeople)
          .then(saveAllGroups)
          .then(function () {
            toolsPane_log(logSpace, 'Done!')
          })
      }
    )
  })

  const checkGroupless = buttonsContainer.appendChild(dom.createElement('button'))
  checkGroupless.classList.add('actionButton', 'btn-secondary', 'action-button-focus')
  checkGroupless.textContent = 'Find contacts with no group'
  checkGroupless.addEventListener('click', function (_event) {
    setActiveButton(checkGroupless)
    logSpace.textContent = ''
    toolsPane_log(logSpace, 'Loading groups...')
    selectAllGroups(toolsPane_selectedGroups, groupsMainTable, async function (ok, message) {
      if (!ok) {
        toolsPane_log(logSpace, 'Loading all groups failed. If it persists, contact your admin.')
        return
      }

      const nameEmailIndex = toolsPane_kb.any(toolsPane_book, toolsPane_ns.vcard('nameEmailIndex'))
      try {
        await toolsPane_kb.fetcher.load(nameEmailIndex)
      } catch (e) {
        error('Error loading name index (vcard(nameEmailIndex)). Stack: ' + e)
        toolsPane_log(logSpace, 'Loading name index failed. If it persists, contact your admin.')
        return
      }
      toolsPane_log(logSpace, 'Loaded groups and name index.')
      getGroupless(toolsPane_book)
      toolsPane_log(logSpace, 'Groupless list finished.')
    }) // select all groups then
  })

  const fixGrouplessButton = buttonsContainer.appendChild(dom.createElement('button'))
  fixGrouplessButton.classList.add('actionButton', 'btn-secondary', 'action-button-focus')
  fixGrouplessButton.textContent = 'Put all individuals with no group in a new group'
  fixGrouplessButton.addEventListener('click', _event => {
    setActiveButton(fixGrouplessButton)
    logSpace.textContent = ''
    fixGroupless(toolsPane_book)
  })

  // this is an old not needed anymore fix from https://github.com/SolidOS/contacts-pane/issues/81
  /*
  const fixToOldDataModelButton = buttonsContainer.appendChild(dom.createElement('button'))
  fixToOldDataModelButton.classList.add('actionButton', 'btn-secondary', 'action-button-focus')
  fixToOldDataModelButton.textContent = 'Revert groups to old data model'
  fixToOldDataModelButton.addEventListener('click', _event => {
    setActiveButton(fixToOldDataModelButton)
    logSpace.textContent = ''
    fixToOldDataModel(book)
  })
  */
  return pane
}

async function checkAcces (_event) {
  function doCard (card) {
    external_commonjs_solid_ui_commonjs2_solid_ui_amd_solid_ui_root_UI_.acl.fixIndividualCardACL(card, (msg) => toolsPane_log(logSpace, msg), function (ok, message) {
      if (ok) {
        toolsPane_log(logSpace, 'Success for ' + external_commonjs_solid_ui_commonjs2_solid_ui_amd_solid_ui_root_UI_.utils.label(card))
      } else {
        error('Failure for ' + card + ': ' + message)
        toolsPane_log(logSpace, 'Failure for ' + card + ': ' + message)
      }
    })
  }
  const gg = []
  for (const g in toolsPane_selectedGroups) {
    gg.push(g)
  }

  for (let i = 0; i < gg.length; i++) {
    const g = toolsPane_kb.sym(gg[i])
    const a = groupMembers(toolsPane_kb, g)
    toolsPane_log(logSpace, external_commonjs_solid_ui_commonjs2_solid_ui_amd_solid_ui_root_UI_.utils.label(g) + ': ' + a.length + ' members')
    for (let j = 0; j < a.length; j++) {
      const card = a[j]
      toolsPane_log(logSpace, external_commonjs_solid_ui_commonjs2_solid_ui_amd_solid_ui_root_UI_.utils.label(card))
      doCard(card)
    }
  }
}

function toolsPane_log (logSpace, message) {
  logSpace.textContent += message + '\n'
}

function stats (logSpace) {
  const totalContacts = toolsPane_kb.each(undefined, VCARD('inAddressBook'), toolsPane_book).length
  toolsPane_log(logSpace, '' + totalContacts + ' contacts loaded. ')
  let groups = toolsPane_kb.each(toolsPane_book, VCARD('includesGroup'))
  const strings = new Set(groups.map(group => normalizeGroupUri(group.uri))) // remove dups with normalized URIs
  groups = [...strings].map(uri => toolsPane_kb.sym(uri))
  toolsPane_log(logSpace, '' + groups.length + ' total groups. ')
  const gg = []
  for (const g in toolsPane_selectedGroups) {
    gg.push(g)
  }
  toolsPane_log(logSpace, '' + gg.length + ' selected groups. ')
}

async function loadIndexHandler (loadIndexButton, logSpace) {
  loadIndexButton.classList.add('toolsButton--loading')
  loadIndexButton.classList.remove('toolsButton--error', 'toolsButton--success')
  const nameEmailIndex = toolsPane_kb.any(toolsPane_book, toolsPane_ns.vcard('nameEmailIndex'))
  try {
    await toolsPane_kb.fetcher.load(nameEmailIndex)
  } catch (e) {
    loadIndexButton.classList.remove('toolsButton--loading')
    loadIndexButton.classList.add('toolsButton--error')
    toolsPane_log(logSpace, 'Error: People index has NOT been loaded' + e + '\n')
  }
  loadIndexButton.classList.remove('toolsButton--loading')
  loadIndexButton.classList.add('toolsButton--success')
  toolsPane_log(logSpace, ' People index has been loaded\n')
} // loadIndexHandler

async function fixGroupless (book) {
  const groupless = await getGroupless(book)
  if (groupless.length === 0) {
    toolsPane_log(logSpace, 'No groupless contacts found.')
    return
  }
  let groupOfUngrouped = null
  try {
    groupOfUngrouped = await saveNewGroup(book, 'No group')
  } catch (_e) {
    // do nothing
  }

  const dom = logSpace.ownerDocument
  return new Promise(function (resolve) {
    const msg = dom.createElement('p')
    msg.textContent = `Add the ${groupless.length} contacts without groups to a 'No group' group?`
    logSpace.appendChild(msg)
    const confirmButton = external_commonjs_solid_ui_commonjs2_solid_ui_amd_solid_ui_root_UI_.widgets.continueButton(dom, async function () {
      msg.remove()
      confirmButton.remove()
      for (const person of groupless) {
        if (groupOfUngrouped) {
          toolsPane_log(logSpace, '   adding ' + external_commonjs_solid_ui_commonjs2_solid_ui_amd_solid_ui_root_UI_.utils.label(person))
          await addPersonToGroup(person, groupOfUngrouped)
        }
      }
      toolsPane_log(logSpace, 'People moved to group.')
      if (refreshGroupsFn) refreshGroupsFn()
      resolve()
    })
    logSpace.appendChild(confirmButton)
  })
}

async function getGroupless (book) {
  const groupIndex = toolsPane_kb.any(book, toolsPane_ns.vcard('groupIndex'))
  const nameEmailIndex = toolsPane_kb.any(book, toolsPane_ns.vcard('nameEmailIndex'))
  try {
    await toolsPane_kb.fetcher.load([nameEmailIndex, groupIndex])
    const groups = toolsPane_kb.each(book, toolsPane_ns.vcard('includesGroup'))
    await toolsPane_kb.fetcher.load(groups)
  } catch (e) {
    error('Error loading groups. Stack: ' + e)
    toolsPane_log(logSpace, 'Error loading groups or name index. If it persists, contact your admin.')
  }

  const reverseIndex = {}
  const groupless = []
  let groups = toolsPane_kb.each(book, VCARD('includesGroup'))
  const strings = new Set(groups.map(group => normalizeGroupUri(group.uri))) // remove dups with normalized URIs
  groups = [...strings].map(uri => toolsPane_kb.sym(uri))
  toolsPane_log(logSpace, '' + groups.length + ' total groups. ')

  for (let i = 0; i < groups.length; i++) {
    const g = groups[i]
    const a = groupMembers(toolsPane_kb, g)

    toolsPane_log(logSpace, external_commonjs_solid_ui_commonjs2_solid_ui_amd_solid_ui_root_UI_.utils.label(g) + ': ' + a.length + ' members')
    for (let j = 0; j < a.length; j++) {
      toolsPane_kb.allAliases(a[j]).forEach(function (y) {
        reverseIndex[y.uri] = g
      })
    }
  }

  const cards = toolsPane_kb.each(undefined, VCARD('inAddressBook'), book)
  toolsPane_log(logSpace, '' + cards.length + ' total contatcs')
  for (let c = 0; c < cards.length; c++) {
    if (!reverseIndex[cards[c].uri]) {
      groupless.push(cards[c])
      toolsPane_log(logSpace, '   groupless ' + external_commonjs_solid_ui_commonjs2_solid_ui_amd_solid_ui_root_UI_.utils.label(cards[c]))
    }
  }
  toolsPane_log(logSpace, '' + groupless.length + ' groupless contacts.')
  return groupless
}

/*
async function fixToOldDataModel (book) {
  async function updateToOldDataModel (groups) {
    let ds = []
    let ins = []
    groups.forEach(group => {
      let vcardOrWebids = kb.statementsMatching(null, ns.owl('sameAs'), null, group.doc()).map(st => st.subject)
      const strings = new Set(vcardOrWebids.map(contact => contact.uri)) // remove dups
      vcardOrWebids = [...strings].map(uri => kb.sym(uri))
      vcardOrWebids.forEach(item => {
        if (!kb.each(item, ns.vcard('fn'), null, group.doc()).length) {
          // delete item this is a new data model,  item is a webid not a card.
          ds = ds.concat(kb
            .statementsMatching(item, ns.owl('sameAs'), null, group.doc())
            .concat(kb.statementsMatching(undefined, undefined, item, group.doc())))
          // add webid card to group
          const cards = kb.each(item, ns.owl('sameAs'), null, group.doc())
          cards.forEach(card => {
            ins = ins.concat($rdf.st(card, ns.owl('sameAs'), item, group.doc()))
              .concat($rdf.st(group, ns.vcard('hasMember'), card, group.doc()))
          })
        }
      })
    })
    if (ds.length) {
      const dom = logSpace.ownerDocument
      return new Promise(function (resolve) {
        const msg = dom.createElement('p')
        msg.textContent = 'Groups can be updated to old data model?'
        logSpace.appendChild(msg)
        const confirmButton = UI.widgets.continueButton(dom, async function () {
          msg.remove()
          confirmButton.remove()
          await kb.updater.updateMany(ds, ins)
          log(logSpace, 'Update done')
          resolve()
        })
        logSpace.appendChild(confirmButton)
      })
    } else {
      log(logSpace, 'Nothing to update.\nAll groups already use the old data model.')
    }
  }
  let groups = kb.each(book, VCARD('includesGroup'))
  const strings = new Set(groups.map(group => normalizeGroupUri(group.uri))) // remove dups with normalized URIs
  groups = [...strings].map(uri => kb.sym(uri))
  updateToOldDataModel(groups)
}
  */

// EXTERNAL MODULE: ./node_modules/css-loader/dist/cjs.js!./src/styles/utilities.css
var utilities = __webpack_require__(92);
;// ./src/styles/utilities.css

      
      
      
      
      
      
      
      
      

var utilities_options = {};

utilities_options.styleTagTransform = (styleTagTransform_default());
utilities_options.setAttributes = (setAttributesWithoutAttributes_default());
utilities_options.insert = insertBySelector_default().bind(null, "head");
utilities_options.domAPI = (styleDomAPI_default());
utilities_options.insertStyleElement = (insertStyleElement_default());

var utilities_update = injectStylesIntoStyleTag_default()(utilities/* default */.A, utilities_options);




       /* harmony default export */ const styles_utilities = (utilities/* default */.A && utilities/* default */.A.locals ? utilities/* default */.A.locals : undefined);

// EXTERNAL MODULE: ./node_modules/css-loader/dist/cjs.js!./src/styles/contactsPane.css
var contactsPane = __webpack_require__(903);
;// ./src/styles/contactsPane.css

      
      
      
      
      
      
      
      
      

var contactsPane_options = {};

contactsPane_options.styleTagTransform = (styleTagTransform_default());
contactsPane_options.setAttributes = (setAttributesWithoutAttributes_default());
contactsPane_options.insert = insertBySelector_default().bind(null, "head");
contactsPane_options.domAPI = (styleDomAPI_default());
contactsPane_options.insertStyleElement = (insertStyleElement_default());

var contactsPane_update = injectStylesIntoStyleTag_default()(contactsPane/* default */.A, contactsPane_options);




       /* harmony default export */ const styles_contactsPane = (contactsPane/* default */.A && contactsPane/* default */.A.locals ? contactsPane/* default */.A.locals : undefined);

;// ./src/contactsPane.js
/*   Contact AddressBook Pane
**
**  This outline pane allows a user to interact with a contact,
to change its state according to an ontology, comment on it, etc.
**
** See also things like
**  http://www.w3.org/TR/vcard-rdf/
**  http://tools.ietf.org/html/rfc6350
**  http://www.iana.org/assignments/vcard-elements/vcard-elements.xhtml
**
*/














const contactsPane_ns = external_commonjs_solid_ui_commonjs2_solid_ui_amd_solid_ui_root_UI_.ns
const contactsPane_utils = external_commonjs_solid_ui_commonjs2_solid_ui_amd_solid_ui_root_UI_.utils

/* harmony default export */ const src_contactsPane = ({
  icon: external_commonjs_solid_ui_commonjs2_solid_ui_amd_solid_ui_root_UI_.icons.iconBase + 'noun_99101.svg', // changed from embedded icon 2016-05-01

  name: 'contact',

  global: false,

  // Does the subject deserve a contact pane?
  label: function (subject, context) {
    const t = context.session.store.findTypeURIs(subject)
    // with the new design we only display Address Books
    // individuals are rendered through the profile-pane but not Organizations
    if (t[contactsPane_ns.vcard('Organization').uri]) return 'Contact'
    /*
    if (t[ns.vcard('Individual').uri]) return 'Contact'
    if (t[ns.foaf('Person').uri]) return 'Person'
    if (t[ns.schema('Person').uri]) return 'Person'
    if (t[ns.vcard('Group').uri]) return 'Group'
    */
    if (t[contactsPane_ns.vcard('AddressBook').uri]) return 'Address book'
    return null // No, under other circumstances
  },

  mintClass: external_commonjs_solid_ui_commonjs2_solid_ui_amd_solid_ui_root_UI_.ns.vcard('AddressBook'),

  mintNew: mintNewAddressBook, // Make a new address book

  //  Render the pane
  render: function (subject, dataBrowserContext, paneOptions = {}) {
    /*
    function newAddressBookButton (thisAddressBook) {
      return UI.login.newAppInstance(
        dom,
        { noun: 'address book', appPathSegment: 'contactorator.timbl.com' },
        function (ws, newBase) {
          thisPane.mintNew(thisAddressBook, newBase, {
            me,
            div,
            dom
          })
        }
      )
    } */

    const dom = dataBrowserContext.dom
    const kb = dataBrowserContext.session.store
    const div = dom.createElement('div')
    setDom(dom) // set dom for ana error handling in other modules

    external_commonjs_solid_ui_commonjs2_solid_ui_amd_solid_ui_root_UI_.aclControl.preventBrowserDropEvents(dom) // protect drag and drop

    div.setAttribute('class', 'contactPane')
    // Make the pane stack vertically (sidebar -> details) when narrow
    // Set breakpoint to 1000 so it triggers at 980 width too.
    setupResponsiveStacking(div, 1000)

    asyncRender().then(
      () => log('Contacts pane rendered for ' + subject),
      err => complain(div, dom, err.message || '' + err)
    ).catch(err => {
      complain(div, dom, err.message || '' + err)
    })
    return div

    // Async part of render. Maybe API will later allow render to be async
    async function asyncRender () {
      external_commonjs_solid_ui_commonjs2_solid_ui_amd_solid_ui_root_UI_.aclControl.preventBrowserDropEvents(dom)

      const t = kb.findTypeURIs(subject)

      // Render a single contact Individual
      if (
        t[contactsPane_ns.vcard('Individual').uri] ||
        t[contactsPane_ns.foaf('Person').uri] ||
        t[contactsPane_ns.schema('Person').uri] ||
        t[contactsPane_ns.vcard('Organization').uri] ||
        t[contactsPane_ns.schema('Organization').uri]
      ) {
        try {
          await renderIndividual(dom, div, subject, dataBrowserContext)
        } catch (err) {
          error('Error rendering contact. Stack: ' + err)
          throw new Error('Failed to render contact: ' + (err.message || err))
        }
      /*
        //          Render a Group instance
      }
        else if (t[ns.vcard('Group').uri]) {
        // If we have a main address book, then render this group as a guest group within it
        UI.login
          .findAppInstances(context, ns.vcard('AddressBook'))
          .then(function (context) {
            const addressBooks = context.instances
            const options = { foreignGroup: subject }
            if (addressBooks.length > 0) {
              // const book = addressBooks[0]
              renderAddressBook(addressBooks, options)
            } else {
              renderAddressBook([], options)
              // @@ button to Make a new addressBook
            }
          })
          .catch(function (e) {
            complain(div, dom, '' + e)
          })
        */
      // Render a AddressBook instance
      } else if (t[contactsPane_ns.vcard('AddressBook').uri]) {
        renderAddressBook([subject], {})
      } else {
        error('No evidence that ' + subject + ' is anything to do with contacts.')
        throw new Error('This does not seem to be a contact or address book.')
      }

      let me = external_commonjs_solid_logic_commonjs2_solid_logic_amd_solid_logic_root_SolidLogic_.authn.currentUser()

      //  Render AddressBook instance
      function renderAddressBook (books, options) {
        kb.fetcher
          .load(books)
          .then(function (_xhr) {
            renderAddressBookDetails(books, options)
          })
          .catch(function (err) {
            error('Error loading address book. Stack: ' + err)
            throw new Error('Failed to load address book.')
          })
      }

      function renderAddressBookDetails (books, options) {
        const classLabel = contactsPane_utils.label(contactsPane_ns.vcard('AddressBook'))

        let book = options.foreignGroup // in case we have only a Grouo
        let title = ''
        if (books && books.length > 0) {
          book = books[0] // if we have an Address Book, we prefer this
          title = contactsPane_utils.label(book.dir())
        } else {
          kb.any(book, contactsPane_ns.dc('title')) || kb.any(book, contactsPane_ns.vcard('fn'))
          if (paneOptions.solo && title && typeof document !== 'undefined') {
            document.title = title.value // @@ only when the outermmost pane
          }
          title = title ? title.value : classLabel
        }

        const groupIndex = kb.any(book, contactsPane_ns.vcard('groupIndex'))
        const selectedGroups = {}
        let selectedPeople = {} // Actually prob max 1

        let allGroupsLi = null
        let newGroupLi = null

        // Centralized active-button tracking across all action buttons
        const actionButtons = []
        function setActiveActionButton (activeBtn) {
          actionButtons.forEach(btn => {
            btn.classList.remove('btn-primary')
            btn.classList.add('btn-secondary')
          })
          if (activeBtn) {
            activeBtn.classList.remove('btn-secondary')
            activeBtn.classList.add('btn-primary')
          }
        }

        // Shared context passed to all builder functions
        const ctx = {
          dom,
          kb,
          ns: contactsPane_ns,
          book,
          options,
          title,
          groupIndex,
          selectedGroups,
          get selectedPeople () { return selectedPeople },
          set selectedPeople (v) { selectedPeople = v },
          get allGroupsLi () { return allGroupsLi },
          set allGroupsLi (v) { allGroupsLi = v },
          get newGroupLi () { return newGroupLi },
          set newGroupLi (v) { newGroupLi = v },
          actionButtons,
          setActiveActionButton,
          dataBrowserContext,
          div,
          me,
          setMe (v) { me = v },
          paneOptions,
        }

        // ── Build layout ────────────────────────────────────────────
        const { main, addressBookSection, detailsSection } = buildMainLayout(ctx)
        div.appendChild(main)

        function showDetailsSection () {
          detailsSection.classList.remove('hidden')
        }
        ctx.showDetailsSection = showDetailsSection
        ctx.detailsSection = detailsSection

        // Create shared DOM elements needed by multiple builders
        const ulPeople = dom.createElement('ul')
        ulPeople.setAttribute('role', 'list')
        ulPeople.setAttribute('aria-label', 'People list')
        ctx.ulPeople = ulPeople
        // make the element available on the dataBrowserContext too; other
        // modules (individual/group membership) look for this property when
        // they need to refresh the master list after a mutation.
        if (ctx.dataBrowserContext) ctx.dataBrowserContext.ulPeople = ulPeople

        const detailsSectionContent = dom.createElement('div')
        detailsSectionContent.classList.add('detailsSectionContent')
        detailsSectionContent.setAttribute('role', 'region')
        detailsSectionContent.setAttribute('aria-labelledby', 'detailsSectionContent')
        detailsSectionContent.setAttribute('aria-live', 'polite')
        ctx.detailsSectionContent = detailsSectionContent

        // ── Header (title + New Contact button) ─────────────────────
        const headerSection = buildHeaderSection(ctx)
        addressBookSection.appendChild(headerSection)

        const dottedHr = dom.createElement('hr')
        dottedHr.classList.add('dottedHr')
        addressBookSection.appendChild(dottedHr)

        // ── Search ──────────────────────────────────────────────────
        const { searchSection, searchInput } = buildSearchSection(ctx)
        ctx.searchInput = searchInput
        addressBookSection.appendChild(searchSection)

        // ── Group bar ───────────────────────────────────────────────
        const { buttonSection, ulGroups } = buildGroupBar(ctx)
        ctx.ulGroups = ulGroups
        addressBookSection.appendChild(buttonSection)

        // ── People list ─────────────────────────────────────────────
        const peopleListSection = dom.createElement('section')
        peopleListSection.classList.add('peopleSection')
        addressBookSection.appendChild(peopleListSection)
        peopleListSection.appendChild(ulPeople)

        // ── Details content section ─────────────────────────────────
        detailsSection.appendChild(detailsSectionContent)

        // ── Footer buttons ──────────────────────────────────────────
        const cardFooter = buildFooterButtons(ctx)
        addressBookSection.appendChild(cardFooter)

        checkDataModel(book, detailsSectionContent).then(() => { log('Async checkDataModel done.') })
      }

      // /////////////// Fix user when testing on a plane

      if (
        typeof document !== 'undefined' &&
        document.location &&
        ('' + document.location).slice(0, 16) === 'http://localhost'
      ) {
        const inferredOwner = kb.any(subject, external_commonjs_solid_ui_commonjs2_solid_ui_amd_solid_ui_root_UI_.ns.acl('owner')) // when testing on plane with no webid
        if (inferredOwner) {
          me = inferredOwner
        }
      }

      return div
    } // asyncRender
  } // render function
}); // pane object

// ── Helper: handle "New group" button click ──────────────────────────
async function handleNewGroupClick (ctx) {
  const { dom, kb, ns, book, options, selectedGroups, dataBrowserContext } = ctx
  ctx.showDetailsSection()
  ctx.detailsSectionContent.innerHTML = ''
  const groupIndex = kb.any(book, ns.vcard('groupIndex'))
  try {
    await kb.fetcher.load(groupIndex)
  } catch (e) {
    log('Error: Group index  NOT loaded:' + e + '\n')
  }
  log(' Group index has been loaded\n')

  const name = await external_commonjs_solid_ui_commonjs2_solid_ui_amd_solid_ui_root_UI_.widgets.askName(
    dom, kb, ctx.detailsSectionContent, external_commonjs_solid_ui_commonjs2_solid_ui_amd_solid_ui_root_UI_.ns.foaf('name'), ns.vcard('Group'), 'group')
  if (!name) return // cancelled by user
  let group
  try {
    group = await saveNewGroup(book, name)
  } catch (err) {
    log('Error: can\'t save new group:' + err)
    ctx.detailsSectionContent.innerHTML = 'Failed to save group' + err
    return
  }
  for (const key in selectedGroups) delete selectedGroups[key]
  selectedGroups[group.uri] = true

  // Refresh the group buttons list
  const allGroupsLi = ctx.allGroupsLi
  const newGroupLi = ctx.newGroupLi
  if (allGroupsLi.parentNode) allGroupsLi.parentNode.removeChild(allGroupsLi)
  if (newGroupLi.parentNode) newGroupLi.parentNode.removeChild(newGroupLi)
  syncGroupUl(book, options, ctx.ulGroups, dom, selectedGroups, ctx.ulPeople, ctx.searchInput)
  ctx.ulGroups.insertBefore(allGroupsLi, ctx.ulGroups.firstChild)
  ctx.ulGroups.appendChild(newGroupLi)
  refreshThingsSelected(ctx.ulGroups, selectedGroups)
  // Highlight the new group button in ulGroups and show empty people list
  const matchingLi = Array.from(ctx.ulGroups.children).find(li => li.subject && li.subject.uri === group.uri)
  setActiveGroupButton(ctx.ulGroups, matchingLi ? matchingLi.querySelector('button') : null)
  refreshNames(ctx.ulPeople, null, false)

  ctx.detailsSectionContent.innerHTML = ''
  ctx.detailsSectionContent.appendChild(external_commonjs_solid_ui_commonjs2_solid_ui_amd_solid_ui_root_UI_.aclControl.ACLControlBox5(
    group.doc(), dataBrowserContext, 'group', kb,
    function (ok, body) {
      if (!ok) {
        ctx.detailsSectionContent.innerHTML =
            'Group sharing setup failed: ' + body
      }
    }))
}

// ── Helper: render askName form for person or organization ───────────
function createNewPersonOrOrganization (ctx, formContainer, klass) {
  const { dom, kb, book, selectedGroups, dataBrowserContext } = ctx
  formContainer.innerHTML = ''
  external_commonjs_solid_ui_commonjs2_solid_ui_amd_solid_ui_root_UI_.widgets
    .askName(dom, kb, formContainer, external_commonjs_solid_ui_commonjs2_solid_ui_amd_solid_ui_root_UI_.ns.foaf('name'), klass)
    .then(async (name) => {
      if (!name) return // cancelled by user
      ctx.detailsSectionContent.innerHTML = 'Indexing...'
      let person
      try {
        person = await saveNewContact(book, name, selectedGroups, klass)
      } catch (err) {
        const msg = 'Error saving contact. If it persists, contact your admin.'
        alertDialog(msg)
        return
      }
      // It’s possible `saveNewContact` returned `undefined` when no group was
      // selected.  In that case we already alerted the user and nothing more
      // should happen.
      if (!person) {
        ctx.detailsSectionContent.innerHTML = ''
        return
      }
      ctx.selectedPeople = {}
      ctx.selectedPeople[person.uri] = true
      refreshNames(ctx.ulPeople, null) // Add name to list of group
      ctx.detailsSectionContent.innerHTML = '' // Clear 'indexing'
      ctx.detailsSectionContent.classList.add('detailsSectionContent--wide')
      const contactPane = dataBrowserContext.session.paneRegistry.byName('contact')
      const paneDiv = contactPane.render(person, dataBrowserContext)
      paneDiv.classList.add('renderPane')
      ctx.detailsSectionContent.appendChild(paneDiv)
    })
}

// ── Builder: main layout skeleton ────────────────────────────────────
function buildMainLayout (ctx) {
  const { dom } = ctx
  const main = dom.createElement('main')
  main.id = 'main-content'
  main.classList.add('addressBook-grid')
  main.setAttribute('role', 'main')
  main.setAttribute('aria-label', 'Address Book')
  main.setAttribute('tabindex', '-1')

  const addressBookSection = dom.createElement('section')
  addressBookSection.setAttribute('aria-labelledby', 'addressBook-section')
  addressBookSection.classList.add('addressBookSection', 'section-bg')
  addressBookSection.setAttribute('role', 'region')
  addressBookSection.setAttribute('tabindex', '-1')
  main.appendChild(addressBookSection)

  const detailsSection = dom.createElement('section')
  detailsSection.classList.add('detailSection')
  detailsSection.setAttribute('role', 'region')
  detailsSection.setAttribute('aria-label', 'Details section')
  detailsSection.classList.add('hidden')
  main.appendChild(detailsSection)

  return { main, addressBookSection, detailsSection }
}

// ── Builder: header with title and New Contact button ────────────────
function buildHeaderSection (ctx) {
  const { dom, ns, title, me, setMe, setActiveActionButton } = ctx

  const headerSection = dom.createElement('section')
  headerSection.classList.add('headerSection')

  const header = dom.createElement('header')
  header.classList.add('mb-md')
  const h2 = dom.createElement('h2')
  h2.id = 'addressBook-heading'
  h2.setAttribute('tabindex', '-1')
  h2.textContent = title

  // New Contact button
  const newContactButton = dom.createElement('button')
  const container = dom.createElement('div')
  newContactButton.setAttribute('type', 'button')
  if (!me) newContactButton.setAttribute('disabled', 'true')
  external_commonjs_solid_logic_commonjs2_solid_logic_amd_solid_logic_root_SolidLogic_.authn.checkUser().then(webId => {
    if (webId) {
      setMe(webId)
      newContactButton.removeAttribute('disabled')
    }
  })
  container.appendChild(newContactButton)
  newContactButton.innerHTML = '+ New contact'
  newContactButton.classList.add('actionButton', 'btn-primary', 'action-button-focus')
  let newContactClickGeneration = 0
  newContactButton.addEventListener('click', async function (_event) {
    setActiveActionButton(null)
    deselectAllPeople(ctx.ulPeople)
    const thisGeneration = ++newContactClickGeneration
    ctx.showDetailsSection()
    ctx.detailsSectionContent.innerHTML = ''
    ctx.detailsSectionContent.classList.remove('detailsSectionContent--wide')
    await ensureBookLoaded()
    // Bail out if a newer click has taken over
    if (thisGeneration !== newContactClickGeneration) return
    ctx.detailsSectionContent.innerHTML = ''

    const chooserDiv = dom.createElement('div')
    chooserDiv.classList.add('contactTypeChooser')

    const selectLabel = dom.createElement('label')
    selectLabel.textContent = 'Contact type: '
    selectLabel.setAttribute('for', 'contactTypeSelect')
    chooserDiv.appendChild(selectLabel)

    const select = dom.createElement('select')
    select.id = 'contactTypeSelect'
    select.classList.add('contactTypeSelect')
    const optIndividual = dom.createElement('option')
    optIndividual.value = 'Individual'
    optIndividual.textContent = 'New person'
    select.appendChild(optIndividual)
    const optOrganization = dom.createElement('option')
    optOrganization.value = 'Organization'
    optOrganization.textContent = 'New organization'
    select.appendChild(optOrganization)
    chooserDiv.appendChild(select)

    ctx.detailsSectionContent.appendChild(chooserDiv)

    const remark = dom.createElement('p')
    remark.classList.add('contactCreationRemark')
    remark.textContent = 'The new contact is added to the already selected group.'
    ctx.detailsSectionContent.appendChild(remark)

    // Container for the askName form, placed below the select
    const formContainer = dom.createElement('div')
    formContainer.classList.add('contactFormContainer')
    ctx.detailsSectionContent.appendChild(formContainer)

    function currentKlass () {
      return select.value === 'Organization'
        ? ns.vcard('Organization')
        : ns.vcard('Individual')
    }

    // Render person form immediately as default
    createNewPersonOrOrganization(ctx, formContainer, currentKlass())

    // Switch form when dropdown changes
    select.addEventListener('change', function () {
      createNewPersonOrOrganization(ctx, formContainer, currentKlass())
    })
  }, false)

  // TODO we should also add if it is public or private
  header.appendChild(h2)
  header.appendChild(container)
  headerSection.appendChild(header)
  return headerSection
}

// ── Builder: search input section ────────────────────────────────────
function buildSearchSection (ctx) {
  const { dom } = ctx
  const searchSection = dom.createElement('section')
  searchSection.classList.add('searchSection')
  const searchDiv = dom.createElement('div')
  searchDiv.classList.add('searchDiv')
  // container for input + clear button
  searchSection.appendChild(searchDiv)
  const searchInput = dom.createElement('input')
  searchInput.setAttribute('type', 'text')
  searchInput.setAttribute('aria-label', 'Search contacts')
  searchInput.classList.add('searchInput')
  searchInput.setAttribute('placeholder', 'Search by name in selected group')
  searchDiv.appendChild(searchInput)

  // clear button that appears when there is text
  const clearBtn = dom.createElement('button')
  clearBtn.setAttribute('type', 'button')
  clearBtn.setAttribute('aria-label', 'Clear search')
  clearBtn.classList.add('searchClearButton', 'hidden')
  clearBtn.textContent = '\u2715' // multiplication sign ×
  searchDiv.appendChild(clearBtn)

  searchInput.addEventListener('input', function (_event) {
    const hasText = searchInput.value.length > 0
    // show/hide using the shared "hidden" utility class instead of direct
    // style manipulation
    clearBtn.classList.toggle('hidden', !hasText)
    refreshFilteredPeople(ctx.ulPeople, true, ctx.detailsSectionContent)
  })

  clearBtn.addEventListener('click', function () {
    searchInput.value = ''
    clearBtn.classList.add('hidden')
    searchInput.focus()
    refreshFilteredPeople(ctx.ulPeople, true, ctx.detailsSectionContent)
  })

  return { searchSection, searchInput }
}

// ── Builder: group buttons bar ───────────────────────────────────────
function buildGroupBar (ctx) {
  const {
    dom, kb, book, options, groupIndex, selectedGroups,
    actionButtons, setActiveActionButton
  } = ctx

  const buttonSection = dom.createElement('section')
  buttonSection.classList.add('buttonSection')

  const ulGroups = dom.createElement('ul')
  ulGroups.classList.add('groupButtonsList')
  ulGroups.setAttribute('role', 'list')
  ulGroups.setAttribute('aria-label', 'Groups list')

  if (options.foreignGroup) {
    selectedGroups[options.foreignGroup.uri] = true
  }

  if (book) {
    // All groups button — leftmost, initially selected
    ctx.allGroupsLi = dom.createElement('li')
    const allGroupsButton = dom.createElement('button')
    allGroupsButton.textContent = 'All groups'
    allGroupsButton.classList.add('allGroupsButton', 'actionButton', 'btn-primary', 'action-button-focus', 'allGroupsButton--selected')
    allGroupsButton.addEventListener('click', function (_event) {
      setActiveGroupButton(ulGroups, allGroupsButton)
      setActiveActionButton(null)
      // Check if all groups are currently selected
      const allSelected = Array.from(ulGroups.children).every(function (li) {
        if (!li.subject) return true // skip non-group items (All groups, New group)
        return !!selectedGroups[li.subject.uri]
      })

      if (!allSelected) {
        allGroupsButton.classList.add('allGroupsButton--loading')
        allGroupsButton.setAttribute('aria-busy', 'true')
        selectAllGroups(selectedGroups, ulGroups, function (ok, message) {
          if (!ok) return alertDialog('Failed to select all groups. If it persists, contact admin.')
          allGroupsButton.classList.remove('allGroupsButton--loading')
          allGroupsButton.setAttribute('aria-busy', 'false')
          allGroupsButton.classList.add('allGroupsButton--active')
          refreshThingsSelected(ulGroups, selectedGroups)
          refreshNames(ctx.ulPeople, null)
        })
      } else {
        allGroupsButton.classList.remove('allGroupsButton--loading', 'allGroupsButton--active')
        allGroupsButton.setAttribute('aria-busy', 'false')
        allGroupsButton.classList.add('allGroupsButton--loaded') // pale green hint groups loaded
        for (const key in selectedGroups) delete selectedGroups[key]
        refreshThingsSelected(ulGroups, selectedGroups)
      }
    }) // on button click
    ctx.allGroupsLi.appendChild(allGroupsButton)
    ulGroups.appendChild(ctx.allGroupsLi) // First item in the list

    // New group button — rightmost (appended after group buttons are rendered)
    ctx.newGroupLi = dom.createElement('li')
    const newGroupButton = dom.createElement('button')
    newGroupButton.setAttribute('type', 'button')
    newGroupButton.innerHTML = '+ New group'
    newGroupButton.classList.add('allGroupsButton', 'actionButton', 'btn-secondary', 'action-button-focus')
    actionButtons.push(newGroupButton)
    newGroupButton.addEventListener(
      'click', function (event) {
        setActiveGroupButton(ulGroups, newGroupButton)
        setActiveActionButton(null)
        deselectAllPeople(ctx.ulPeople)
        handleNewGroupClick(ctx)
      },
      false
    )
    ctx.newGroupLi.appendChild(newGroupButton)

    // Append ulGroups to buttonSection, then add New group at the end
    buttonSection.appendChild(ulGroups)

    if (groupIndex) {
      kb.fetcher.nowOrWhenFetched(groupIndex.uri, book, function (ok, body) {
        if (!ok) {
          error('Error loading group index. Stack: ' + body)
          alertDialog('Error loading group index. If it persists, contact admin.')
          return
        }
        // Remove special items before sync (syncTableToArrayReOrdered expects .subject on all children)
        if (ctx.allGroupsLi.parentNode) ctx.allGroupsLi.parentNode.removeChild(ctx.allGroupsLi)
        if (ctx.newGroupLi.parentNode) ctx.newGroupLi.parentNode.removeChild(ctx.newGroupLi)
        syncGroupUl(book, options, ulGroups, dom, selectedGroups, ctx.ulPeople, ctx.searchInput) // Refresh list of groups
        ulGroups.insertBefore(ctx.allGroupsLi, ulGroups.firstChild) // Keep All contacts first
        ulGroups.appendChild(ctx.newGroupLi) // Keep New group last

        // Auto-select all groups and display all contacts on load
        allGroupsButton.classList.add('allGroupsButton--loading')
        allGroupsButton.setAttribute('aria-busy', 'true')
        selectAllGroups(selectedGroups, ulGroups, function (ok, message) {
          if (!ok) return alertDialog('Failed to select all groups. If it persists, contact admin.')
          allGroupsButton.classList.remove('allGroupsButton--loading')
          allGroupsButton.setAttribute('aria-busy', 'false')
          allGroupsButton.classList.add('allGroupsButton--active')
          refreshThingsSelected(ulGroups, selectedGroups)
          refreshNames(ctx.ulPeople, null)
        })
      })
    }

    // Remove special items before initial render too
    if (ctx.allGroupsLi.parentNode) ctx.allGroupsLi.parentNode.removeChild(ctx.allGroupsLi)
    if (ctx.newGroupLi.parentNode) ctx.newGroupLi.parentNode.removeChild(ctx.newGroupLi)
    renderGroupButtons(book, ulGroups, options, dom, selectedGroups, ctx.ulPeople, ctx.searchInput, ctx.detailsSectionContent, ctx.dataBrowserContext, function () {
      setActiveActionButton(null)
      // Keep the details section open when a contact or New contact form is showing
      if (!ctx.detailsSectionContent.querySelector('.contactTypeChooser, .contactFormContainer, .renderPane')) {
        ctx.detailsSectionContent.innerHTML = ''
        ctx.detailsSection.classList.add('hidden')
      }
    })
    ulGroups.insertBefore(ctx.allGroupsLi, ulGroups.firstChild) // Keep All contacts first
    ulGroups.appendChild(ctx.newGroupLi) // Ensure New group is last after initial render
  } else {
    syncGroupUl(book, options, ulGroups, dom, selectedGroups, ctx.ulPeople, ctx.searchInput) // Refresh list of groups (will be empty)
    refreshNames(ctx.ulPeople, null)
    log('No book, only one group -> hide list of groups')
  } // if not book

  return { buttonSection, ulGroups }
}

// ── Builder: footer action buttons (Groups / Sharing / Tools) ────────
function buildFooterButtons (ctx) {
  const {
    dom, kb, ns, book, options, selectedGroups,
    actionButtons, setActiveActionButton, dataBrowserContext, div, me
  } = ctx

  const cardFooter = dom.createElement('div')
  cardFooter.classList.add('cardFooter')

  if (book) {
    // Groups button
    const groupsButton = cardFooter.appendChild(dom.createElement('button'))
    groupsButton.setAttribute('type', 'button')
    groupsButton.innerHTML = 'Groups'
    groupsButton.classList.add('actionButton', 'btn-secondary', 'action-button-focus')
    actionButtons.push(groupsButton)
    groupsButton.addEventListener('click', async function (_event) {
      setActiveActionButton(groupsButton)
      deselectAllPeople(ctx.ulPeople)
      ctx.showDetailsSection()
      ctx.detailsSectionContent.innerHTML = ''
      ctx.detailsSectionContent.classList.remove('detailsSectionContent--wide')

      // Header
      const groupsHeader = dom.createElement('h3')
      groupsHeader.textContent = 'Your groups'
      ctx.detailsSectionContent.appendChild(groupsHeader)

      let groupRemark = dom.createElement('p')
      groupRemark.textContent = 'When you delete a group it can happen that some contacts end up groupless.'
      ctx.detailsSectionContent.appendChild(groupRemark)

      groupRemark = dom.createElement('p')
      groupRemark.textContent = 'To move contacts around, simply drag and drop them onto a group.'
      ctx.detailsSectionContent.appendChild(groupRemark)

      // Load all groups and display them in a list
      let groups
      try {
        groups = await loadAllGroups(book)
      } catch (err) {
        ctx.detailsSectionContent.appendChild(dom.createTextNode('Failed to load groups: ' + err))
        return
      }

      const groupsList = dom.createElement('ul')
      groupsList.setAttribute('role', 'list')
      groupsList.setAttribute('aria-label', 'All groups')
      groupsList.classList.add('groupButtonsList')

      // Sort groups by name
      if (groups) {
        groups.sort((a, b) => {
          const nameA = (kb.any(a, ns.vcard('fn')) || '').toString().toLowerCase()
          const nameB = (kb.any(b, ns.vcard('fn')) || '').toString().toLowerCase()
          return nameA < nameB ? -1 : nameA > nameB ? 1 : 0
        })
        groups.forEach(function (group) {
          const { groupLi, groupButton: groupBtn, name } = createGroupLi(group)
          groupBtn.addEventListener('click', function (event) {
            event.preventDefault()
            if (!event.metaKey) {
              for (const key in selectedGroups) delete selectedGroups[key]
            }
            selectedGroups[group.uri] = !selectedGroups[group.uri]
            refreshThingsSelected(ctx.ulGroups, selectedGroups)
            // Highlight the matching group button in the sidebar ulGroups
            const matchingLi = Array.from(ctx.ulGroups.children).find(li => li.subject && li.subject.uri === group.uri)
            setActiveGroupButton(ctx.ulGroups, matchingLi ? matchingLi.querySelector('button') : null)
            kb.fetcher.nowOrWhenFetched(group.doc(), undefined, function (ok, message) {
              if (!ok) {
                error('Cannot load group: ' + group + '. Stack: ' + message)
                return alertDialog('Failed to load group details. If it persists, contact your admin.')
              }
              refreshNames(ctx.ulPeople, null, false)
            })
          }, false)
          external_commonjs_solid_ui_commonjs2_solid_ui_amd_solid_ui_root_UI_.widgets.makeDropTarget(groupLi, uris => handleURIsDroppedOnGroup(uris, group))

          if (me) {
            external_commonjs_solid_ui_commonjs2_solid_ui_amd_solid_ui_root_UI_.widgets.deleteButtonWithCheck(
              dom,
              groupLi,
              'group ' + name,
              async function () {
                await deleteThingAndDoc(group)
                delete selectedGroups[group.uri]
                // Refresh the group buttons list
                const allGroupsLi = ctx.allGroupsLi
                const newGroupLi = ctx.newGroupLi
                if (allGroupsLi.parentNode) allGroupsLi.parentNode.removeChild(allGroupsLi)
                if (newGroupLi.parentNode) newGroupLi.parentNode.removeChild(newGroupLi)
                syncGroupUl(book, options, ctx.ulGroups, dom, selectedGroups, ctx.ulPeople, ctx.searchInput)
                ctx.ulGroups.insertBefore(allGroupsLi, ctx.ulGroups.firstChild)
                ctx.ulGroups.appendChild(newGroupLi)
                refreshThingsSelected(ctx.ulGroups, selectedGroups)
                // Refresh the people list to reflect the deleted group
                refreshNames(ctx.ulPeople, null, false)
                // Refresh the groups detail view
                groupsButton.click()
              }
            )
          }

          groupsList.appendChild(groupLi)
        })
      }

      ctx.detailsSectionContent.appendChild(groupsList)

      // New group button at the bottom
      const newGroupBtn = dom.createElement('button')
      newGroupBtn.setAttribute('type', 'button')
      newGroupBtn.innerHTML = '+ New group'
      newGroupBtn.classList.add('actionButton', 'btn-primary', 'action-button-focus', 'newGroupBtn')
      newGroupBtn.addEventListener('click', function () { handleNewGroupClick(ctx) }, false)
      ctx.detailsSectionContent.appendChild(newGroupBtn)
    })

    // Sharing button
    const sharingButton = cardFooter.appendChild(dom.createElement('button'))
    sharingButton.setAttribute('type', 'button')
    sharingButton.innerHTML = 'Sharing'
    sharingButton.classList.add('actionButton', 'btn-secondary', 'action-button-focus')
    actionButtons.push(sharingButton)
    sharingButton.addEventListener('click', function (_event) {
      setActiveActionButton(sharingButton)
      deselectAllPeople(ctx.ulPeople)
      ctx.showDetailsSection()
      ctx.detailsSectionContent.innerHTML = ''
      ctx.detailsSectionContent.classList.remove('detailsSectionContent--wide')

      const sharingHeader = dom.createElement('h3')
      sharingHeader.textContent = 'Sharing'
      ctx.detailsSectionContent.appendChild(sharingHeader)

      ctx.detailsSectionContent.appendChild(
        external_commonjs_solid_ui_commonjs2_solid_ui_amd_solid_ui_root_UI_.aclControl.ACLControlBox5(
          book.dir(),
          dataBrowserContext,
          'book',
          kb,
          function (ok, body) {
            if (!ok) {
              error('ACL control box Failed. Stack: ' + body)
              complain(ctx.detailsSectionContent, dom, 'Problem displaying sharing controls. If persists, contact admin.')
            }
          }
        )
      )

      const sharingContext = {
        target: book,
        me,
        noun: 'address book',
        div: ctx.detailsSectionContent,
        dom,
        statusRegion: div
      }
      external_commonjs_solid_ui_commonjs2_solid_ui_amd_solid_ui_root_UI_.login.registrationControl(sharingContext, book, ns.vcard('AddressBook'))
        .then(() => log('Registration control finished.'))
        .catch(e => {
          error('Error in registration control. Stack: ' + e)
          complain(ctx.detailsSectionContent, dom, 'Problem displaying findable controls. If persists, contact admin.')
        })
    })

    // Settings button
    const toolsButton = cardFooter.appendChild(dom.createElement('button'))
    toolsButton.setAttribute('type', 'button')
    toolsButton.innerHTML = 'Tools'
    toolsButton.classList.add('actionButton', 'btn-secondary', 'action-button-focus')
    actionButtons.push(toolsButton)
    toolsButton.addEventListener('click', function (_event) {
      setActiveActionButton(toolsButton)
      deselectAllPeople(ctx.ulPeople)
      ctx.showDetailsSection()
      ctx.detailsSectionContent.innerHTML = ''
      ctx.detailsSectionContent.classList.add('detailsSectionContent--wide')
      ctx.detailsSectionContent.appendChild(
        toolsPane_toolsPane(
          selectAllGroups,
          selectedGroups,
          ctx.ulGroups,
          book,
          dataBrowserContext,
          me,
          function refreshGroups () {
            if (ctx.allGroupsLi.parentNode) ctx.allGroupsLi.parentNode.removeChild(ctx.allGroupsLi)
            if (ctx.newGroupLi.parentNode) ctx.newGroupLi.parentNode.removeChild(ctx.newGroupLi)
            syncGroupUl(book, options, ctx.ulGroups, dom, selectedGroups, ctx.ulPeople, ctx.searchInput)
            ctx.ulGroups.insertBefore(ctx.allGroupsLi, ctx.ulGroups.firstChild)
            ctx.ulGroups.appendChild(ctx.newGroupLi)
            refreshThingsSelected(ctx.ulGroups, selectedGroups)
          }
        )
      )
    })
  } // if book

  return cardFooter
}




__webpack_exports__ = __webpack_exports__["default"];
/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=contactsPane.js.map